/**
 * Created by Rajeshwarasethupathy.N on 20-10-2020.
 */

export class FirebaseConstant {
  public static get LOBBY() {
    return {
      '1': {
        catId: 'A',
        eventId: 1,
        category: '(A) Casino',
        eventAction: 'Click',
        Label: '(1) Login',
        value: '',
      },
      '2': {
        catId: 'A',
        eventId: 2,
        category: '(A) Casino',
        eventAction: 'Click',
        Label: '(2) Register',
        value: '',
      },
      '3': {
        catId: 'A',
        eventId: 3,
        category: '(A) Casino',
        eventAction: 'Click',
        Label: '(3) Register - Submit',
        value: '',
      },
      '4': {
        catId: 'A',
        eventId: 4,
        category: '(A) Casino',
        eventAction: 'Click',
        Label: '(4) Login - LoginButton',
        value: '',
      },
      '5': {
        catId: 'A',
        eventId: 5,
        category: '(A) Casino',
        eventAction: 'Click',
        Label: '(5) ThirdPartyLogin',
        value: '',
      },
      '6': {
        catId: 'A',
        eventId: 6,
        category: '(A) Casino',
        eventAction: 'Click',
        Label: '(6) Device Responsive FCG to FCG RGS Lobby (Desktop)',
        value: '',
      },
      '7': {
        catId: 'A',
        eventId: 7,
        category: '(A) Casino',
        eventAction: 'Click',
        Label: '(7) Device Responsive FCG to FCG RGS Lobby (Mobile)',
        value: '',
      },
    };
  }

  public static get LOBBYDESKTOPHEADER() {
    return {
      FullColorGames: {
        catId: 'B',
        eventId: 7,
        category: '(B) Lobby Desktop - Header',
        eventAction: 'Click',
        Label: '(7) FullColorGames',
        value: '',
      },
      menu: {
        catId: 'B',
        eventId: 8,
        category: '(B) Lobby Desktop - Header',
        eventAction: 'Click',
        Label: '(8) Menu Open',
        value: '',
      },
      menuClose: {
        catId: 'B',
        eventId: 9,
        category: '(B) Lobby Desktop - Header',
        eventAction: 'Click',
        Label: '(9) Menu Close',
        value: '',
      },
      favoritesopen: {
        catId: 'B',
        eventId: 10,
        category: '(B) Lobby Desktop - Header',
        eventAction: 'Click',
        Label: '(10) Favorites Open',
        value: '',
      },
      favoritesClose: {
        catId: 'B',
        eventId: 11,
        category: '(B) Lobby Desktop - Header',
        eventAction: 'Click',
        Label: '(11) Favorites Close',
        value: '',
      },
      favoritesplay: {
        catId: 'B',
        eventId: 12,
        category: '(B) Lobby Desktop - Header',
        eventAction: 'Click',
        Label: '(12) Favorites - PlayButton',
        value: '',
      },
      mobile_icon: {
        catId: 'B',
        eventId: 13,
        category: '(B) Lobby Desktop - Header',
        eventAction: 'Click',
        Label: '(13) MobileView On',
        value: '',
      },
      desktop_icon: {
        catId: 'B',
        eventId: 14,
        category: '(B) Lobby Desktop - Header',
        eventAction: 'Click',
        Label: '(14) DesktopView On',
        value: '',
      },
      language: {
        catId: 'B',
        eventId: 15,
        category: '(B) Lobby Desktop - Header',
        eventAction: 'Click',
        Label: '(15) Language - SelectedLanguage',
        value: '',
      },
      fcg: {
        catId: 'B',
        eventId: 16,
        category: '(B) Lobby Desktop - Header',
        eventAction: 'Click',
        Label: '(16) AllGames',
        value: '',
      },
      fc21: {
        catId: 'B',
        eventId: 17,
        category: '(B) Lobby Desktop - Header',
        eventAction: 'Click',
        Label: '(17) FC21ORNOTHING',
        value: '',
      },
      fcb: {
        catId: 'B',
        eventId: 18,
        category: '(B) Lobby Desktop - Header',
        eventAction: 'Click',
        Label: '(18) FCBACCARAT',
        value: '',
      },
    };
  }

  public static get MENU() {
    return {
      home: {
        catId: 'C',
        eventId: 19,
        category: '(C) Menu',
        eventAction: 'Click',
        Label: '(19) Home',
        value: '',
      },
      languages: {
        catId: 'C',
        eventId: 20,
        category: '(C) Menu',
        eventAction: 'Click',
        Label: '(20) Languages',
        value: '',
      },
      settings: {
        catId: 'C',
        eventId: 21,
        category: '(C) Menu',
        eventAction: 'Click',
        Label: '(21) Settings',
        value: '',
      },
      tutorials: {
        catId: 'C',
        eventId: 22,
        category: '(C) Menu',
        eventAction: 'Click',
        Label: '(22) Tutorials',
        value: '',
      },
      quickkeys: {
        catId: 'C',
        eventId: 23,
        category: '(C) Menu',
        eventAction: 'Click',
        Label: '(23) Quickkeys',
        value: '',
      },
      videotutorials: {
        catId: 'C',
        eventId: 24,
        category: '(C) Menu',
        eventAction: 'Click',
        Label: '(24)Video Tutorials',
        value: '',
      },
      premiumpay: {
        catId: 'C',
        eventId: 25,
        category: '(C) Menu',
        eventAction: 'Click',
        Label: '(25)Premium Pays',
        value: '',
      },
      history: {
        catId: 'C',
        eventId: 26,
        category: '(C) Menu',
        eventAction: 'Click',
        Label: '(26) History',
        value: '',
      },
      communityforums: {
        catId: 'C',
        eventId: 27,
        category: '(C) Menu',
        eventAction: 'Click',
        Label: '(27) Community Forums',
        value: '',
      },
      fixourtranslations: {
        catId: 'C',
        eventId: 28,
        category: '(C) Menu',
        eventAction: 'Click',
        Label: '(28) FixOurTranslations',
        value: '',
      },
      helpdesk: {
        catId: 'C',
        eventId: 29,
        category: '(C) Menu',
        eventAction: 'Click',
        Label: '(29) Help Desk',
        value: '',
      },
      aboutus: {
        catId: 'C',
        eventId: 30,
        category: '(C) Menu',
        eventAction: 'Click',
        Label: '(30) About Us',
        value: '',
      },
      logout: {
        catId: 'C',
        eventId: 31,
        category: '(C) Menu',
        eventAction: 'Click',
        Label: '(31) Logout',
        value: '',
      },
      selecttable: {
        catId: 'C',
        eventId: 32,
        category: '(C) Menu',
        eventAction: 'Click',
        Label: '(32) SelectTable',
        value: '',
      },
      gamedetails: {
        catId: 'C',
        eventId: 33,
        category: '(C) Menu',
        eventAction: 'Click',
        Label: '(33) GameDetails',
        value: '',
      },
      handranks: {
        catId: 'C',
        eventId: 34,
        category: '(C) Menu',
        eventAction: 'Click',
        Label: '(34) HandRanks',
        value: '',
      },
      changechips: {
        catId: 'C',
        eventId: 35,
        category: '(C) Menu',
        eventAction: 'Click',
        Label: '(35) ChangeChips',
        value: '',
      },
      quickstart: {
        catId: 'C',
        eventId: 36,
        category: '(C) Menu',
        eventAction: 'Click',
        Label: '(36) Quickstart',
        value: '',
      },
      quicktips: {
        catId: 'C',
        eventId: 37,
        category: '(C) Menu',
        eventAction: 'Click',
        Label: '(37) Quicktips',
        value: '',
      },
      helpinghands: {
        catId: 'C',
        eventId: 38,
        category: '(C) Menu',
        eventAction: 'Click',
        Label: '(38) HelpingHand',
        value: '',
      },
      fcbtutorials: {
        catId: 'C',
        eventId: 39,
        category: '(C) Menu',
        eventAction: 'Click',
        Label: '(39) FcbTutorials',
        value: '',
      },
      quickstart_turnon: {
        catId: 'C',
        eventId: 40,
        category: '(C) Menu',
        eventAction: 'Click',
        Label: '(40) Submenu - Quickstart - TurnonQuickstart',
        value: '',
      },
      quickstart_reset: {
        catId: 'C',
        eventId: 41,
        category: '(C) Menu',
        eventAction: 'Click',
        Label: '(41) Submenu - Quickstart - ResetQuickstart',
        value: '',
      },
      quicktips_turnon: {
        catId: 'C',
        eventId: 42,
        category: '(C) Menu',
        eventAction: 'Click',
        Label: '(42) Submenu - Quicktips - TurnonQuicktips',
        value: '',
      },
      quicktips_turnoff: {
        catId: 'C',
        eventId: 43,
        category: '(C) Menu',
        eventAction: 'Click',
        Label: '(43) Submenu - Quicktips - TurnoffQuicktips',
        value: '',
      },
      helpinghands_turnoff: {
        catId: 'C',
        eventId: 44,
        category: '(C) Menu',
        eventAction: 'Click',
        Label: '(44) Submenu - HelpingHand - TurnoffHelpinghands',
        value: '',
      },
      helpinghands_turnon: {
        catId: 'C',
        eventId: 45,
        category: '(C) Menu',
        eventAction: 'Click',
        Label: '(45) Submenu - HelpingHand - TurnonHelpinghands',
        value: '',
      },
      helpinghands_continue: {
        catId: 'C',
        eventId: 46,
        category: '(C) Menu',
        eventAction: 'Click',
        Label: '(46) Submenu - HelpingHand - ContinueHelpinghands',
        value: '',
      },
      helpinghands_reset: {
        catId: 'C',
        eventId: 47,
        category: '(C) Menu',
        eventAction: 'Click',
        Label: '(47) Submenu - HelpingHand - ResetHelpinghands',
        value: '',
      },
    };
  }

  public static get LANGUAGE() {
    return {
      en: {
        catId: 'D',
        eventId: 54,
        category: '(D) Menu - Languages',
        eventAction: 'Click',
        Label: '(54) en_English',
        value: '',
      },
      es: {
        catId: 'D',
        eventId: 55,
        category: '(D) Menu - Languages',
        eventAction: 'Click',
        Label: '(55) es_Spanish',
        value: '',
      },
      cs: {
        catId: 'D',
        eventId: 50,
        category: '(D) Menu - Languages',
        eventAction: 'Click',
        Label: '(50) cs_Czech',
        value: '',
      },
      da: {
        catId: 'D',
        eventId: 51,
        category: '(D) Menu - Languages',
        eventAction: 'Click',
        Label: '(51) da_Danish',
        value: '',
      },
      de: {
        catId: 'D',
        eventId: 52,
        category: '(D) Menu - Languages',
        eventAction: 'Click',
        Label: '(52) de_German',
        value: '',
      },
      fi: {
        catId: 'D',
        eventId: 56,
        category: '(D) Menu - Languages',
        eventAction: 'Click',
        Label: '(56) fi_Finnish',
        value: '',
      },
      fr: {
        catId: 'D',
        eventId: 57,
        category: '(D) Menu - Languages',
        eventAction: 'Click',
        Label: '(57) fr_French',
        value: '',
      },
      he: {
        catId: 'D',
        eventId: 60,
        category: '(D) Menu - Languages',
        eventAction: 'Click',
        Label: '(60) he_Hebrew',
        value: '',
      },
      hy: {
        catId: 'D',
        eventId: 63,
        category: '(D) Menu - Languages',
        eventAction: 'Click',
        Label: '(63) hy_Armenian',
        value: '',
      },
      id: {
        catId: 'D',
        eventId: 64,
        category: '(D) Menu - Languages',
        eventAction: 'Click',
        Label: '(64) id_Indonesian',
        value: '',
      },
      it: {
        catId: 'D',
        eventId: 65,
        category: '(D) Menu - Languages',
        eventAction: 'Click',
        Label: '(65) it_Italian',
        value: '',
      },
      ja: {
        catId: 'D',
        eventId: 66,
        category: '(D) Menu - Languages',
        eventAction: 'Click',
        Label: '(66) ja_Japanese',
        value: '',
      },
      ko: {
        catId: 'D',
        eventId: 68,
        category: '(D) Menu - Languages',
        eventAction: 'Click',
        Label: '(68) ko_Korean',
        value: '',
      },
      nb: {
        catId: 'D',
        eventId: 73,
        category: '(D) Menu - Languages',
        eventAction: 'Click',
        Label: '(73) nb_Norwegian',
        value: '',
      },
      nl: {
        catId: 'D',
        eventId: 74,
        category: '(D) Menu - Languages',
        eventAction: 'Click',
        Label: '(74) nl_Dutch',
        value: '',
      },
      pl: {
        catId: 'D',
        eventId: 76,
        category: '(D) Menu - Languages',
        eventAction: 'Click',
        Label: '(76) pl_Polish',
        value: '',
      },
      'pt-BR': {
        catId: 'D',
        eventId: 77,
        category: '(D) Menu - Languages',
        eventAction: 'Click',
        Label: '(77) pt-BR_Portuguese',
        value: '',
      },
      ru: {
        catId: 'D',
        eventId: 79,
        category: '(D) Menu - Languages',
        eventAction: 'Click',
        Label: '(79) ru_Russian',
        value: '',
      },
      sv: {
        catId: 'D',
        eventId: 83,
        category: '(D) Menu - Languages',
        eventAction: 'Click',
        Label: '(83) sv_Swedish',
        value: '',
      },
      th: {
        catId: 'D',
        eventId: 85,
        category: '(D) Menu - Languages',
        eventAction: 'Click',
        Label: '(85) th_Thai',
        value: '',
      },
      tr: {
        catId: 'D',
        eventId: 86,
        category: '(D) Menu - Languages',
        eventAction: 'Click',
        Label: '(86) tr_Turkish',
        value: '',
      },
      vi: {
        catId: 'D',
        eventId: 88,
        category: '(D) Menu - Languages',
        eventAction: 'Click',
        Label: '(88) vi_Vietnamese',
        value: '',
      },
      'zh-Hant': {
        catId: 'D',
        eventId: 90,
        category: '(D) Menu - Languages',
        eventAction: 'Click',
        Label: '(90) zh-Hant_Traditional Chinese',
        value: '',
      },
      'zh-Hans': {
        catId: 'D',
        eventId: 89,
        category: '(D) Menu - Languages',
        eventAction: 'Click',
        Label: '(89) zh-Hans_Simplified Chinese',
        value: '',
      },
      ar: {
        catId: 'D',
        eventId: 48,
        category: '(D) Menu - Languages',
        eventAction: 'Click',
        Label: '(48) ar_Arabic',
        value: '',
      },
      bg: {
        catId: 'D',
        eventId: 49,
        category: '(D) Menu - Languages',
        eventAction: 'Click',
        Label: '(49) bg_Bulgarian',
        value: '',
      },
      ee: {
        catId: 'D',
        eventId: 53,
        category: '(D) Menu - Languages',
        eventAction: 'Click',
        Label: '(53) ee_Estonian',
        value: '',
      },
      ge: {
        catId: 'D',
        eventId: 58,
        category: '(D) Menu - Languages',
        eventAction: 'Click',
        Label: '(58) ge_Georgian',
        value: '',
      },
      gr: {
        catId: 'D',
        eventId: 59,
        category: '(D) Menu - Languages',
        eventAction: 'Click',
        Label: '(59) gr_Greek',
        value: '',
      },
      'hi-IN': {
        catId: 'D',
        eventId: 61,
        category: '(D) Menu - Languages',
        eventAction: 'Click',
        Label: '(61) hi-IN_Hindi',
        value: '',
      },
      hu: {
        catId: 'D',
        eventId: 62,
        category: '(D) Menu - Languages',
        eventAction: 'Click',
        Label: '(62) hu_Hungarian',
        value: '',
      },
      lt: {
        catId: 'D',
        eventId: 69,
        category: '(D) Menu - Languages',
        eventAction: 'Click',
        Label: '(69) lt_Lithuanian',
        value: '',
      },
      kh: {
        catId: 'D',
        eventId: 67,
        category: '(D) Menu - Languages',
        eventAction: 'Click',
        Label: '(67) kh_Cambodian',
        value: '',
      },
      lv: {
        catId: 'D',
        eventId: 70,
        category: '(D) Menu - Languages',
        eventAction: 'Click',
        Label: '(70) lv_Latvian',
        value: '',
      },
      mt: {
        catId: 'D',
        eventId: 71,
        category: '(D) Menu - Languages',
        eventAction: 'Click',
        Label: '(71) mt_Maltese',
        value: '',
      },
      my: {
        catId: 'D',
        eventId: 72,
        category: '(D) Menu - Languages',
        eventAction: 'Click',
        Label: '(72) my_Malaysian',
        value: '',
      },
      ph: {
        catId: 'D',
        eventId: 75,
        category: '(D) Menu - Languages',
        eventAction: 'Click',
        Label: '(75) ph_Filipino',
        value: '',
      },
      ro: {
        catId: 'D',
        eventId: 78,
        category: '(D) Menu - Languages',
        eventAction: 'Click',
        Label: '(78) ro_Romanian',
        value: '',
      },
      si: {
        catId: 'D',
        eventId: 81,
        category: '(D) Menu - Languages',
        eventAction: 'Click',
        Label: '(81) si_Slovenian',
        value: '',
      },
      sk: {
        catId: 'D',
        eventId: 80,
        category: '(D) Menu - Languages',
        eventAction: 'Click',
        Label: '(80) sk_Slovakian',
        value: '',
      },
      'sr-RS': {
        catId: 'D',
        eventId: 82,
        category: '(D) Menu - Languages',
        eventAction: 'Click',
        Label: '(82) sr-RS_Serbian',
        value: '',
      },
      'ta-IN': {
        catId: 'D',
        eventId: 84,
        category: '(D) Menu - Languages',
        eventAction: 'Click',
        Label: '(84) ta-IN_Tamil',
        value: '',
      },
      ua: {
        catId: 'D',
        eventId: 87,
        category: '(D) Menu - Languages',
        eventAction: 'Click',
        Label: '(87) ua_Ukranian',
        value: '',
      },
    };
  }

  public static get SETTINGS() {
    return {
      quickkeys: {
        catId: 'E',
        eventId: 91,
        category: '(E) Menu - Settings',
        eventAction: 'Click',
        Label: '(91) Settings - Quickkeys',
        value: '',
      },
      languages: {
        catId: 'E',
        eventId: 92,
        category: '(E) Menu - Settings',
        eventAction: 'Click',
        Label: '(92) Settings - Languages',
        value: '',
      },
      tutorials: {
        catId: 'E',
        eventId: 93,
        category: '(E) Menu - Settings',
        eventAction: 'Click',
        Label: '(93) Settings - Tutorials',
        value: '',
      },
      increase: {
        catId: 'E',
        eventId: 94,
        category: '(E) Menu - Settings',
        eventAction: 'Click',
        Label: '(94) Settings - VolumeIncrease',
        value: '',
      },
      decrease: {
        catId: 'E',
        eventId: 95,
        category: '(E) Menu - Settings',
        eventAction: 'Click',
        Label: '(95) Settings - VolumeDecrease',
        value: '',
      },
      SettingsVoiceSounds: {
        catId: 'E',
        eventId: 95,
        category: '(E) Menu - Settings',
        eventAction: 'Click',
        Label: '(96) Settings - VoiceSounds',
        value: '',
      },
      SettingsGameSounds: {
        catId: 'E',
        eventId: 95,
        category: '(E) Menu - Settings',
        eventAction: 'Click',
        Label: '(97) Settings - GameSounds',
        value: '',
      },
      'feltColor-green': {
        catId: 'E',
        eventId: 98,
        category: '(E) Menu - Settings',
        eventAction: 'Click',
        Label: '(98) Settings - GreenFeltColor',
        value: '',
      },
      'feltColor-red': {
        catId: 'E',
        eventId: 99,
        category: '(E) Menu - Settings',
        eventAction: 'Click',
        Label: '(99) Settings - RedFeltColor',
        value: '',
      },
      'feltColor-blue': {
        catId: 'E',
        eventId: 100,
        category: '(E) Menu - Settings',
        eventAction: 'Click',
        Label: '(100) Settings - BlueFeltColor',
        value: '',
      },
      'feltColor-violet': {
        catId: 'E',
        eventId: 101,
        category: '(E) Menu - Settings',
        eventAction: 'Click',
        Label: '(101) Settings - PurpleFeltColor',
        value: '',
      },
      dealSpeed_0: {
        catId: 'E',
        eventId: 102,
        category: '(E) Menu - Settings',
        eventAction: 'Click',
        Label: '(102) Settings - SlowPlay',
        value: '',
      },
      dealSpeed_1: {
        catId: 'E',
        eventId: 103,
        category: '(E) Menu - Settings',
        eventAction: 'Click',
        Label: '(103) Settings - NormalPlay',
        value: '',
      },
      dealSpeed_2: {
        catId: 'E',
        eventId: 104,
        category: '(E) Menu - Settings',
        eventAction: 'Click',
        Label: '(104) Settings - InstantPlay',
        value: '',
      },
      roadmaps: {
        catId: 'E',
        eventId: 105,
        category: '(E) Menu - Settings',
        eventAction: 'Click',
        Label: 'Settings - RoadMaps',
        value: '',
      },
      commission_0: {
        catId: 'E',
        eventId: 106,
        category: '(E) Menu - Settings',
        eventAction: 'Click',
        Label: 'Settings - CommissionZero',
        value: '',
      },
      commission_5: {
        catId: 'E',
        eventId: 107,
        category: '(E) Menu - Settings',
        eventAction: 'Click',
        Label: 'Settings - CommissionFive',
        value: '',
      },
      Settings_PauseCard_2: {
        catId: 'E',
        eventId: 108,
        category: '(E) Menu - Settings',
        eventAction: 'Click',
        Label: 'Settings - PauseCard',
        value: '',
      },
      Settings_PauseAfterHandsDealt_1: {
        catId: 'E',
        eventId: 109,
        category: '(E) Menu - Settings',
        eventAction: 'Click',
        Label: 'Settings - PauseAfterHandsDealt',
        value: '',
      },
      Settings_DealDraw_0: {
        catId: 'E',
        eventId: 110,
        category: '(E) Menu - Settings',
        eventAction: 'Click',
        Label: 'Settings - DealDraw',
        value: '',
      },
    };
  }
  public static get TutorialsPopup_FC21() {
    return {
      '0': {
        catId: 'F',
        eventId: 111,
        category: '(F) Tutorials - FC21',
        eventAction: 'Click',
        Label: '(111) Tutorials - Index',
        value: '',
      },
      '1': {
        catId: 'F',
        eventId: 111,
        category: '(F) Tutorials - FC21',
        eventAction: 'Click',
        Label: '(111) Tutorials - Fullcolorcards',
        value: '',
      },
      '2': {
        catId: 'F',
        eventId: 112,
        category: '(F) Tutorials - FC21',
        eventAction: 'Click',
        Label: '(112) Tutorials - Plusminusscores',
        value: '',
      },
      '3': {
        catId: 'F',
        eventId: 113,
        category: '(F) Tutorials - FC21',
        eventAction: 'Click',
        Label: '(113) Tutorials - Gameaction',
        value: '',
      },
      '4': {
        catId: 'F',
        eventId: 114,
        category: '(F) Tutorials - FC21',
        eventAction: 'Click',
        Label: '(114) Tutorials - Gamerules',
        value: '',
      },
      '5': {
        catId: 'F',
        eventId: 115,
        category: '(F) Tutorials - FC21',
        eventAction: 'Click',
        Label: '(115) Tutorials - Soft17',
        value: '',
      },
      '6': {
        catId: 'F',
        eventId: 116,
        category: '(F) Tutorials - FC21',
        eventAction: 'Click',
        Label: '(116) Tutorials - Startagame',
        value: '',
      },
      '7': {
        catId: 'F',
        eventId: 117,
        category: '(F) Tutorials - FC21',
        eventAction: 'Click',
        Label: '(117) Tutorials - The4naturals',
        value: '',
      },
      '8': {
        catId: 'F',
        eventId: 118,
        category: '(F) Tutorials - FC21',
        eventAction: 'Click',
        Label: '(118) Tutorials - Supernatural',
        value: '',
      },
      '9': {
        catId: 'F',
        eventId: 119,
        category: '(F) Tutorials - FC21',
        eventAction: 'Click',
        Label: '(119) Tutorials - Natural21',
        value: '',
      },
      '10': {
        catId: 'F',
        eventId: 120,
        category: '(F) Tutorials - FC21',
        eventAction: 'Click',
        Label: '(120) Tutorials - Doublenatural',
        value: '',
      },
      '11': {
        catId: 'F',
        eventId: 121,
        category: '(F) Tutorials - FC21',
        eventAction: 'Click',
        Label: '(121) Tutorials - Naturalzero',
        value: '',
      },
      '12': {
        catId: 'F',
        eventId: 122,
        category: '(F) Tutorials - FC21',
        eventAction: 'Click',
        Label: '(122) Tutorials - Bustrules',
        value: '',
      },
      '13': {
        catId: 'F',
        eventId: 123,
        category: '(F) Tutorials - FC21',
        eventAction: 'Click',
        Label: '(123) Tutorials - Splitpairs',
        value: '',
      },
      '14': {
        catId: 'F',
        eventId: 124,
        category: '(F) Tutorials - FC21',
        eventAction: 'Click',
        Label: '(124) Tutorials - Impossiblesplits',
        value: '',
      },
      '15': {
        catId: 'F',
        eventId: 125,
        category: '(F) Tutorials - FC21',
        eventAction: 'Click',
        Label: '(125) Tutorials - Doubledown',
        value: '',
      },
      '16': {
        catId: 'F',
        eventId: 126,
        category: '(F) Tutorials - FC21',
        eventAction: 'Click',
        Label: '(126) Tutorials - Colorcardinsurance',
        value: '',
      },
      '17': {
        catId: 'F',
        eventId: 127,
        category: '(F) Tutorials - FC21',
        eventAction: 'Click',
        Label: '(127) Tutorials - Whitecardinsurance',
        value: '',
      },
      '18': {
        catId: 'F',
        eventId: 128,
        category: '(F) Tutorials - FC21',
        eventAction: 'Click',
        Label: '(128) Tutorials - Russianroulette',
        value: '',
      },

      '19': {
        catId: 'F',
        eventId: 128,
        category: '(F) Tutorials - FC21',
        eventAction: 'Click',
        Label: '(129) Tutorials - PremiumPayouts',
        value: '',
      },
      '20': {
        catId: 'F',
        eventId: 128,
        category: '(F) Tutorials - FC21',
        eventAction: 'Click',
        Label: '(130) Tutorials - AboutUs',
        value: '',
      },
      '21': {
        catId: 'F',
        eventId: 128,
        category: '(F) Tutorials - FC21',
        eventAction: 'Click',
        Label: '(131) Tutorials - QuickKeys',
        value: '',
      },

      /*'19': {catId: 'F', eventId: 129, category: '(F) Tutorials - FC21', eventAction: 'Click', Label: '(132) Tutorials - Handranks', value: ''},
      '20': {catId: 'F', eventId: 130, category: '(F) Tutorials - FC21', eventAction: 'Click', Label: '(133) Tutorials - Handrankdetails', value: ''},
      '21': {catId: 'F', eventId: 131, category: '(F) Tutorials - FC21', eventAction: 'Click', Label: '(134) Tutorials - Premiumpay', value: ''},*/
    };
  }

  public static get Tutorials_FC21() {
    return {
      '0': {
        catId: 'F',
        eventId: 111,
        category: '(F) Tutorials - FC21',
        eventAction: 'Click',
        Label: '(111) Tutorials - Index',
        value: '',
      },
      '1': {
        catId: 'F',
        eventId: 111,
        category: '(F) Tutorials - FC21',
        eventAction: 'Click',
        Label: '(111) Tutorials - Fullcolorcards',
        value: '',
      },
      '2': {
        catId: 'F',
        eventId: 112,
        category: '(F) Tutorials - FC21',
        eventAction: 'Click',
        Label: '(112) Tutorials - Plusminusscores',
        value: '',
      },
      '3': {
        catId: 'F',
        eventId: 113,
        category: '(F) Tutorials - FC21',
        eventAction: 'Click',
        Label: '(113) Tutorials - Gameaction',
        value: '',
      },
      '4': {
        catId: 'F',
        eventId: 114,
        category: '(F) Tutorials - FC21',
        eventAction: 'Click',
        Label: '(114) Tutorials - Gamerules',
        value: '',
      },
      '5': {
        catId: 'F',
        eventId: 115,
        category: '(F) Tutorials - FC21',
        eventAction: 'Click',
        Label: '(115) Tutorials - Soft17',
        value: '',
      },
      '6': {
        catId: 'F',
        eventId: 116,
        category: '(F) Tutorials - FC21',
        eventAction: 'Click',
        Label: '(116) Tutorials - Startagame',
        value: '',
      },
      '7': {
        catId: 'F',
        eventId: 117,
        category: '(F) Tutorials - FC21',
        eventAction: 'Click',
        Label: '(117) Tutorials - The4naturals',
        value: '',
      },
      '8': {
        catId: 'F',
        eventId: 118,
        category: '(F) Tutorials - FC21',
        eventAction: 'Click',
        Label: '(118) Tutorials - Supernatural',
        value: '',
      },
      '9': {
        catId: 'F',
        eventId: 119,
        category: '(F) Tutorials - FC21',
        eventAction: 'Click',
        Label: '(119) Tutorials - Natural21',
        value: '',
      },
      '10': {
        catId: 'F',
        eventId: 120,
        category: '(F) Tutorials - FC21',
        eventAction: 'Click',
        Label: '(120) Tutorials - Doublenatural',
        value: '',
      },
      '11': {
        catId: 'F',
        eventId: 121,
        category: '(F) Tutorials - FC21',
        eventAction: 'Click',
        Label: '(121) Tutorials - Naturalzero',
        value: '',
      },
      '12': {
        catId: 'F',
        eventId: 122,
        category: '(F) Tutorials - FC21',
        eventAction: 'Click',
        Label: '(122) Tutorials - Bustrules',
        value: '',
      },
      '13': {
        catId: 'F',
        eventId: 123,
        category: '(F) Tutorials - FC21',
        eventAction: 'Click',
        Label: '(123) Tutorials - Splitpairs',
        value: '',
      },
      '14': {
        catId: 'F',
        eventId: 124,
        category: '(F) Tutorials - FC21',
        eventAction: 'Click',
        Label: '(124) Tutorials - Impossiblesplits',
        value: '',
      },
      '15': {
        catId: 'F',
        eventId: 125,
        category: '(F) Tutorials - FC21',
        eventAction: 'Click',
        Label: '(125) Tutorials - Doubledown',
        value: '',
      },
      '16': {
        catId: 'F',
        eventId: 126,
        category: '(F) Tutorials - FC21',
        eventAction: 'Click',
        Label: '(126) Tutorials - Colorcardinsurance',
        value: '',
      },
      '17': {
        catId: 'F',
        eventId: 127,
        category: '(F) Tutorials - FC21',
        eventAction: 'Click',
        Label: '(127) Tutorials - Whitecardinsurance',
        value: '',
      },
      '18': {
        catId: 'F',
        eventId: 128,
        category: '(F) Tutorials - FC21',
        eventAction: 'Click',
        Label: '(128) Tutorials - Russianroulette',
        value: '',
      },

      /*'19': {catId: 'F', eventId: 128, category: '(F) Tutorials - FC21', eventAction: 'Click', Label: '(129) Tutorials - PremiumPayouts', value: ''},
      '20': {catId: 'F', eventId: 128, category: '(F) Tutorials - FC21', eventAction: 'Click', Label: '(130) Tutorials - AboutUs', value: ''},
      '21': {catId: 'F', eventId: 128, category: '(F) Tutorials - FC21', eventAction: 'Click', Label: '(131) Tutorials - QuickKeys', value: ''},*/

      '19': {
        catId: 'F',
        eventId: 129,
        category: '(F) Tutorials - FC21',
        eventAction: 'Click',
        Label: '(132) Tutorials - Handranks',
        value: '',
      },
      '20': {
        catId: 'F',
        eventId: 130,
        category: '(F) Tutorials - FC21',
        eventAction: 'Click',
        Label: '(133) Tutorials - Handrankdetails',
        value: '',
      },
      '21': {
        catId: 'F',
        eventId: 131,
        category: '(F) Tutorials - FC21',
        eventAction: 'Click',
        Label: '(134) Tutorials - Premiumpay',
        value: '',
      },
    };
  }

  public static get GAMEDETAILS() {
    return {
      '1~5': {
        catId: 'G',
        eventId: 132,
        category: '(G) GameDetails',
        eventAction: 'Click',
        Label: '(132) GameDetails - 1~5',
        value: '',
      },
      '8Decks': {
        catId: 'G',
        eventId: 133,
        category: '(G) GameDetails',
        eventAction: 'Click',
        Label: '(133) GameDetails - 8Decks',
        value: '',
      },
      Shuffle: {
        catId: 'G',
        eventId: 134,
        category: '(G) GameDetails',
        eventAction: 'Click',
        Label: '(134) GameDetails - 50%Shuffle',
        value: '',
      },
      Splits: {
        catId: 'G',
        eventId: 135,
        category: '(G) GameDetails',
        eventAction: 'Click',
        Label: '(135) GameDetails - Splits',
        value: '',
      },
      Soft17: {
        catId: 'G',
        eventId: 136,
        category: '(G) GameDetails',
        eventAction: 'Click',
        Label: '(136) GameDetails - Soft17',
        value: '',
      },
      DoubleDown: {
        catId: 'G',
        eventId: 137,
        category: '(G) GameDetails',
        eventAction: 'Click',
        Label: '(137) GameDetails - DoubleDown',
        value: '',
      },
      ColorInsurance: {
        catId: 'G',
        eventId: 138,
        category: '(G) GameDetails',
        eventAction: 'Click',
        Label: '(138) GameDetails - ColorInsurance',
        value: '',
      },
      WhiteInsurance: {
        catId: 'G',
        eventId: 139,
        category: '(G) GameDetails',
        eventAction: 'Click',
        Label: '(139) GameDetails - WhiteInsurance',
        value: '',
      },
      Roulette17: {
        catId: 'G',
        eventId: 140,
        category: '(G) GameDetails',
        eventAction: 'Click',
        Label: '(140) GameDetails - Roulette17',
        value: '',
      },
      Roulette18: {
        catId: 'G',
        eventId: 141,
        category: '(G) GameDetails',
        eventAction: 'Click',
        Label: '(141) GameDetails - Roulette18',
        value: '',
      },
      Roulette19: {
        catId: 'G',
        eventId: 142,
        category: '(G) GameDetails',
        eventAction: 'Click',
        Label: '(142) GameDetails - Roulette19',
        value: '',
      },
      Roulette20: {
        catId: 'G',
        eventId: 143,
        category: '(G) GameDetails',
        eventAction: 'Click',
        Label: '(143) GameDetails - Roulette20',
        value: '',
      },
      Aboutus: {
        catId: 'G',
        eventId: 144,
        category: '(G) GameDetails',
        eventAction: 'Click',
        Label: '(144) GameDetails - Aboutus',
        value: '',
      },
    };
  }
  public static get GAMEDETAILS_FCB() {
    return {
      '1': {
        catId: 'G',
        eventId: 132,
        category: '(G) GameDetails_FCB',
        eventAction: 'Click',
        Label: '(132) 1',
        value: '',
      },
      '0%~5%': {
        catId: 'G',
        eventId: 133,
        category: '(G) GameDetails_FCB',
        eventAction: 'Click',
        Label: '(133) 0%~5%',
        value: '',
      },
      minbet: {
        catId: 'G',
        eventId: 134,
        category: '(G) GameDetails_FCB',
        eventAction: 'Click',
        Label: '(134) MinBet',
        value: '',
      },
      maxbet: {
        catId: 'G',
        eventId: 135,
        category: '(G) GameDetails_FCB',
        eventAction: 'Click',
        Label: '(135) MaxBet',
        value: '',
      },
      '8Decks': {
        catId: 'G',
        eventId: 136,
        category: '(G) GameDetails_FCB',
        eventAction: 'Click',
        Label: '(136) 8Decks',
        value: '',
      },
      Shuffle: {
        catId: 'G',
        eventId: 137,
        category: '(G) GameDetails_FCB',
        eventAction: 'Click',
        Label: '(137) 96%Shuffle',
        value: '',
      },
      'Sidebets-Tie': {
        catId: 'G',
        eventId: 138,
        category: '(G) GameDetails_FCB',
        eventAction: 'Click',
        Label: '(138) SideBets-Tie',
        value: '',
      },
      'Sidebets-2Minus': {
        catId: 'G',
        eventId: 139,
        category: '(G) GameDetails_FCB',
        eventAction: 'Click',
        Label: '(139) SideBets-2Minus',
        value: '',
      },
      'Sidebets-2Plus': {
        catId: 'G',
        eventId: 140,
        category: '(G) GameDetails_FCB',
        eventAction: 'Click',
        Label: '(140) SideBets-2Plus',
        value: '',
      },
      'Sidebets-3Minus': {
        catId: 'G',
        eventId: 141,
        category: '(G) GameDetails_FCB',
        eventAction: 'Click',
        Label: '(141) SideBets-3Minus',
        value: '',
      },
      'Sidebets-3Plus': {
        catId: 'G',
        eventId: 142,
        category: '(G) GameDetails_FCB',
        eventAction: 'Click',
        Label: '(142) SideBets-3Plus',
        value: '',
      },
      /*'Aboutus': {catId: 'N', eventId: 215, category: 'GameDetails', eventAction: 'Click', Label: 'Aboutus', value: ''},*/
    };
  }
  public static get HANDRANKS() {
    return {
      handrankdetails: {
        catId: 'H',
        eventId: 145,
        category: '(H) HandRanks',
        eventAction: 'Click',
        Label: '(145) HandRanks - DealRules',
        value: '',
      },
      supernatural: {
        catId: 'H',
        eventId: 146,
        category: '(H) HandRanks',
        eventAction: 'Click',
        Label: '(146) HandRanks - SuperNatural',
        value: '',
      },
      natural21: {
        catId: 'H',
        eventId: 147,
        category: '(H) HandRanks',
        eventAction: 'Click',
        Label: '(147) HandRanks - Natural21',
        value: '',
      },
      doublenatural: {
        catId: 'H',
        eventId: 148,
        category: '(H) HandRanks',
        eventAction: 'Click',
        Label: '(148) HandRanks - DoubleNatural',
        value: '',
      },
      naturalzero: {
        catId: 'H',
        eventId: 149,
        category: '(H) HandRanks',
        eventAction: 'Click',
        Label: '(149) HandRanks - NaturalZero',
        value: '',
      },
      dealscore: {
        catId: 'H',
        eventId: 150,
        category: '(H) HandRanks',
        eventAction: 'Click',
        Label: '(150) HandRanks - DealScore',
        value: '',
      },
      draw21: {
        catId: 'H',
        eventId: 151,
        category: '(H) HandRanks',
        eventAction: 'Click',
        Label: '(151) HandRanks - Draw21',
        value: '',
      },
      drawzero: {
        catId: 'H',
        eventId: 152,
        category: '(H) HandRanks',
        eventAction: 'Click',
        Label: '(152) HandRanks - DrawZero',
        value: '',
      },
      drawscore: {
        catId: 'H',
        eventId: 153,
        category: '(H) HandRanks',
        eventAction: 'Click',
        Label: '(153) HandRanks - DrawScore',
        value: '',
      },
      bust: {
        catId: 'H',
        eventId: 154,
        category: '(H) HandRanks',
        eventAction: 'Click',
        Label: '(154) HandRanks - Bust',
        value: '',
      },
    };
  }

  public static get PREMIUMPAYS() {
    return {
      supernatural: {
        catId: 'I',
        eventId: 155,
        category: '(I) PremiumPays',
        eventAction: 'Click',
        Label: '(155) PremiumPays - SuperNatural',
        value: '',
      },
      natural21: {
        catId: 'I',
        eventId: 156,
        category: '(I) PremiumPays',
        eventAction: 'Click',
        Label: '(156) PremiumPays - Natural21',
        value: '',
      },
      doublenatural: {
        catId: 'I',
        eventId: 157,
        category: '(I) PremiumPays',
        eventAction: 'Click',
        Label: '(157) PremiumPays - DoubleNatural',
        value: '',
      },
      naturalzero: {
        catId: 'I',
        eventId: 158,
        category: '(I) PremiumPays',
        eventAction: 'Click',
        Label: '(158) PremiumPays - NaturalZero',
        value: '',
      },
      colorcardinsurance: {
        catId: 'I',
        eventId: 159,
        category: '(I) PremiumPays',
        eventAction: 'Click',
        Label: '(159) PremiumPays - ColorCardInsurance',
        value: '',
      },
      whitecardinsurance: {
        catId: 'I',
        eventId: 160,
        category: '(I) PremiumPays',
        eventAction: 'Click',
        Label: '(160) PremiumPays - WhiteCardInsurance',
        value: '',
      },
      russianroulette: {
        catId: 'I',
        eventId: 161,
        category: '(I) PremiumPays',
        eventAction: 'Click',
        Label: '(161) PremiumPays - RussianRoulette',
        value: '',
      },
      doubledown: {
        catId: 'I',
        eventId: 162,
        category: '(I) PremiumPays',
        eventAction: 'Click',
        Label: '(162) PremiumPays - DoubleDown',
        value: '',
      },
      splits: {
        catId: 'I',
        eventId: 163,
        category: '(I) PremiumPays',
        eventAction: 'Click',
        Label: '(163) PremiumPays - Splits',
        value: '',
      },
    };
  }

  public static get HISTORY() {
    return {
      allgames: {
        catId: 'J',
        eventId: 164,
        category: '(J) History',
        eventAction: 'Click',
        Label: '(164) History - AllGamesDropDown',
        value: '',
      },
      private: {
        catId: 'J',
        eventId: 165,
        category: '(J) History',
        eventAction: 'Click',
        Label: '(165) History - PrivateTableDropDown',
        value: '',
      },
      livecasino: {
        catId: 'J',
        eventId: 166,
        category: '(J) History',
        eventAction: 'Click',
        Label: '(166) History - LiveCasinoDropDown',
        value: '',
      },
      symbols: {
        catId: 'J',
        eventId: 167,
        category: '(J) History',
        eventAction: 'Click',
        Label: '(167) SymbolsIcon',
        value: '',
      },
      colortrue: {
        catId: 'J',
        eventId: 168,
        category: '(J) History',
        eventAction: 'On',
        Label: '(168) ColorOn',
        value: '',
      },
      colorfalse: {
        catId: 'J',
        eventId: 169,
        category: '(J) History',
        eventAction: 'Off',
        Label: '(169) ColorOff',
        value: '',
      },
      gamedetailssummary: {
        catId: 'J',
        eventId: 170,
        category: '(J) History',
        eventAction: 'Click',
        Label: '(170) Toggle GameDetails / GameSummary',
        value: '',
      },
      info: {
        catId: 'J',
        eventId: 171,
        category: '(J) History',
        eventAction: 'Click',
        Label: '(171) Information',
        value: '',
      },
      gamesummary: {
        catId: 'J',
        eventId: 172,
        category: '(J) History',
        eventAction: 'Click',
        Label: '(172) GameSummary - AllRows',
        value: '',
      },
      nextprev1: {
        catId: 'J',
        eventId: 174,
        category: '(J) History',
        eventAction: 'Click',
        Label: '(174) GameDetails - NextGameId',
        value: '',
      },
      'nextprev-1': {
        catId: 'J',
        eventId: 175,
        category: '(J) History',
        eventAction: 'Click',
        Label: '(175) GameDetails - PreviousGameId',
        value: '',
      },
      close: {
        catId: 'J',
        eventId: 176,
        category: '(J) History',
        eventAction: 'Click',
        Label: '(176) GameDetails - Close',
        value: '',
      },
    };
  }

  public static get LOBBYDESKTOP() {
    return {
      livedealer_fc21: {
        catId: 'K',
        eventId: 177,
        category: '(K) Lobby Desktop (Links)',
        eventAction: 'Click',
        Label: '(177) FC21 - LiveDealer - Select a Table',
        value: '',
      },
      livecasino_fc21: {
        catId: 'K',
        eventId: 178,
        category: '(K) Lobby Desktop (Links)',
        eventAction: 'Click',
        Label: '(178) FC21 - LiveCasino - Select a Table',
        value: '',
      },
      private_fc21: {
        catId: 'K',
        eventId: 179,
        category: '(K) Lobby Desktop (Links)',
        eventAction: 'Click',
        Label: '(179) FC21 - PrivateTable - Select a Table',
        value: '',
      },
      privatefriends_fc21: {
        catId: 'K',
        eventId: 180,
        category: '(K) Lobby Desktop (Links)',
        eventAction: 'Click',
        Label: '(180) FC21 - PrivateTable+Friends - Select a Table',
        value: '',
      },
      gamelist_livedealer_fc21: {
        catId: 'K',
        eventId: 181,
        category: '(K) Lobby Desktop (Links)',
        eventAction: 'Click',
        Label: '(181) FC21Gamelist - LiveDealer - Select a Table',
        value: '',
      },
      gamelist_livecasino_fc21: {
        catId: 'K',
        eventId: 182,
        category: '(K) Lobby Desktop (Links)',
        eventAction: 'Click',
        Label: '(182) FC21Gamelist - LiveCasino - Select a Table',
        value: '',
      },
      gamelist_private_fc21: {
        catId: 'K',
        eventId: 183,
        category: '(K) Lobby Desktop (Links)',
        eventAction: 'Click',
        Label: '(183) FC21Gamelist - PrivateTable - Select a Table',
        value: '',
      },
      gamelist_privatefriends_fc21: {
        catId: 'K',
        eventId: 184,
        category: '(K) Lobby Desktop (Links)',
        eventAction: 'Click',
        Label: '(184) FC21Gamelist - PrivateTable+Friends - Select a Table',
        value: '',
      },
      gamelist_fc21_tutorial: {
        catId: 'K',
        eventId: 185,
        category: '(K) Lobby Desktop (Links)',
        eventAction: 'Click',
        Label: '(185) FC21 - Info Icon - Tutorials',
        value: '',
      },
      livedealer_fcb: {
        catId: 'K',
        eventId: 186,
        category: '(K) Lobby Desktop (Links)',
        eventAction: 'Click',
        Label: '(186) FCB - LiveDealer - Select a Table',
        value: '',
      },
      livecasino_fcb: {
        catId: 'K',
        eventId: 187,
        category: '(K) Lobby Desktop (Links)',
        eventAction: 'Click',
        Label: '(187) FCB - LiveCasino - Select a Table',
        value: '',
      },
      private_fcb: {
        catId: 'K',
        eventId: 188,
        category: '(K) Lobby Desktop (Links)',
        eventAction: 'Click',
        Label: '(188) FCB - PrivateTable - Select a Table',
        value: '',
      },
      privatefriends_fcb: {
        catId: 'K',
        eventId: 189,
        category: '(K) Lobby Desktop (Links)',
        eventAction: 'Click',
        Label: '(189) FCB - PrivateTable+Friends - Select a Table',
        value: '',
      },
      gamelist_livedealer_fcb: {
        catId: 'K',
        eventId: 190,
        category: '(K) Lobby Desktop (Links)',
        eventAction: 'Click',
        Label: '(190) FCBGamelist - LiveDealer - Select a Table',
        value: '',
      },
      gamelist_livecasino_fcb: {
        catId: 'K',
        eventId: 191,
        category: '(K) Lobby Desktop (Links)',
        eventAction: 'Click',
        Label: '(191) FCBGamelist - LiveCasino - Select a Table',
        value: '',
      },
      gamelist_private_fcb: {
        catId: 'K',
        eventId: 192,
        category: '(K) Lobby Desktop (Links)',
        eventAction: 'Click',
        Label: '(192) FCBGamelist - PrivateTable - Select a Table',
        value: '',
      },
      gamelist_privatefriends_fcb: {
        catId: 'K',
        eventId: 193,
        category: '(K) Lobby Desktop (Links)',
        eventAction: 'Click',
        Label: '(193) FCBGamelist - PrivateTable+Friends - Select a Table',
        value: '',
      },
      gamelist_fcb_tutorial: {
        catId: 'K',
        eventId: 194,
        category: '(K) Lobby Desktop (Links)',
        eventAction: 'Click',
        Label: '(194) FCB - Info Icon - Tutorials',
        value: '',
      },
    };
  }

  public static get FC21HeaderDesktop() {
    return {
      livedealer: {
        catId: 'L',
        eventId: 195,
        category: '(L) Desktop',
        eventAction: 'Click',
        Label: '(195) FC21DropDownSwitchToLiveDealer',
        value: '',
      },
      livecasino: {
        catId: 'L',
        eventId: 196,
        category: '(L) Desktop',
        eventAction: 'Click',
        Label: '(196) FC21DropDownSwitchToLiveCasino',
        value: '',
      },
      private: {
        catId: 'L',
        eventId: 197,
        category: '(L) Desktop',
        eventAction: 'Click',
        Label: '(197) FC21DropDownSwitchToPrivateTable',
        value: '',
      },
      privatefriends: {
        catId: 'L',
        eventId: 198,
        category: '(L) Desktop',
        eventAction: 'Click',
        Label: '(198) FC21DropDownSwitchToPrivateTable+',
        value: '',
      },
      livedealer_icon: {
        catId: 'L',
        eventId: 199,
        category: '(L) Desktop',
        eventAction: 'Click',
        Label: '(199) FC21LiveDealer / Live CasinoIcon',
        value: '',
      },
      private_icon: {
        catId: 'L',
        eventId: 200,
        category: '(L) Desktop',
        eventAction: 'Click',
        Label: '(200) FC21PrivateTableIcon / LiveCasinoIcon',
        value: '',
      },
      livecasino_icon: {
        catId: 'L',
        eventId: 200,
        category: '(L) Desktop',
        eventAction: 'Click',
        Label: '(200) FC21PrivateTableIcon / LiveCasinoIcon',
        value: '',
      },
      privatefriends_icon: {
        catId: 'L',
        eventId: 201,
        category: '(L) Desktop',
        eventAction: 'Click',
        Label: '(201) FC21PrivateTableFriendsIcon',
        value: '',
      },
    };
  }
  public static get FC21LDDesktop() {
    return {
      favorites1: {
        catId: 'M',
        eventId: 202,
        category: '(M) Select a Table - FC21 LD - Desktop',
        eventAction: 'On',
        Label: '(202) FC21LiveDealerFavoritesIconSelected - Studio1',
        value: '',
      },
      favorites2: {
        catId: 'M',
        eventId: 203,
        category: '(M) Select a Table - FC21 LD - Desktop',
        eventAction: 'On',
        Label: '(203) FC21LiveDealerFavoritesIconSelected - Studio2',
        value: '',
      },
      favorites3: {
        catId: 'M',
        eventId: 204,
        category: '(M) Select a Table - FC21 LD - Desktop',
        eventAction: 'On',
        Label: '(204) FC21LiveDealerFavoritesIconSelected - Studio3',
        value: '',
      },
      favorites4: {
        catId: 'M',
        eventId: 205,
        category: '(M) Select a Table - FC21 LD - Desktop',
        eventAction: 'On',
        Label: '(205) FC21LiveDealerFavoritesIconSelected - Studio4',
        value: '',
      },
      favorites5: {
        catId: 'M',
        eventId: 206,
        category: '(M) Select a Table - FC21 LD - Desktop',
        eventAction: 'On',
        Label: '(206) FC21LiveDealerFavoritesIconSelected - Studio5',
        value: '',
      },
      favoritesnewtable: {
        catId: 'M',
        eventId: 207,
        category: '(M) Select a Table - FC21 LD - Desktop',
        eventAction: 'On',
        Label: '(207) FC21LiveDealerFavoritesIconSelected - Studio6',
        value: '',
      },
      playnow1: {
        catId: 'M',
        eventId: 208,
        category: '(M) Select a Table - FC21 LD - Desktop',
        eventAction: 'On',
        Label: '(208) FC21LiveDealerPlayNow - Table1',
        value: '',
      },
      playnow2: {
        catId: 'M',
        eventId: 209,
        category: '(M) Select a Table - FC21 LD - Desktop',
        eventAction: 'On',
        Label: '(209) FC21LiveDealerPlayNow - Table2',
        value: '',
      },
      playnow3: {
        catId: 'M',
        eventId: 210,
        category: '(M) Select a Table - FC21 LD - Desktop',
        eventAction: 'On',
        Label: '(210) FC21LiveDealerPlayNow - Table3',
        value: '',
      },
      playnow4: {
        catId: 'M',
        eventId: 211,
        category: '(M) Select a Table - FC21 LD - Desktop',
        eventAction: 'On',
        Label: '(211) FC21LiveDealerPlayNow - Table4',
        value: '',
      },
      playnow5: {
        catId: 'M',
        eventId: 212,
        category: '(M) Select a Table - FC21 LD - Desktop',
        eventAction: 'On',
        Label: '(212) FC21LiveDealerPlayNow - Table5',
        value: '',
      },
      playnow0: {
        catId: 'M',
        eventId: 213,
        category: '(M) Select a Table - FC21 LD - Desktop',
        eventAction: 'On',
        Label: '(213) FC21LiveDealerPlayNow - Table6',
        value: '',
      },
      gamedetails: {
        catId: 'M',
        eventId: 214,
        category: '(M) Select a Table - FC21 LD - Desktop',
        eventAction: 'Click',
        Label: '(214) FC21LiveDealerGameSettings Open/Close',
        value: '',
      },
    };
  }
  public static get FC21LCDesktop() {
    return {
      favorites1: {
        catId: 'N',
        eventId: 215,
        category: '(N) Select a Table - FC21 LC - Desktop',
        eventAction: 'On',
        Label: '(215) FC21LiveCasinoFavoritesIconSelected - BetLimit1',
        value: '',
      },
      favorites2: {
        catId: 'N',
        eventId: 216,
        category: '(N) Select a Table - FC21 LC - Desktop',
        eventAction: 'On',
        Label: '(216) FC21LiveCasinoFavoritesIconSelected - BetLimit2',
        value: '',
      },
      favorites3: {
        catId: 'N',
        eventId: 217,
        category: '(N) Select a Table - FC21 LC - Desktop',
        eventAction: 'On',
        Label: '(217) FC21LiveCasinoFavoritesIconSelected - BetLimit3',
        value: '',
      },
      favorites4: {
        catId: 'N',
        eventId: 218,
        category: '(N) Select a Table - FC21 LC - Desktop',
        eventAction: 'On',
        Label: '(218) FC21LiveCasinoFavoritesIconSelected - BetLimit4',
        value: '',
      },
      favorites5: {
        catId: 'N',
        eventId: 219,
        category: '(N) Select a Table - FC21 LC - Desktop',
        eventAction: 'On',
        Label: '(219) FC21LiveCasinoFavoritesIconSelected - BetLimit5',
        value: '',
      },
      favorites0: {
        catId: 'N',
        eventId: 220,
        category: '(N) Select a Table - FC21 LC - Desktop',
        eventAction: 'On',
        Label: '(220) FC21LiveCasinoFavoritesIconSelected - NewTable',
        value: '',
      },
      playnow1: {
        catId: 'N',
        eventId: 221,
        category: '(N) Select a Table - FC21 LC - Desktop',
        eventAction: 'On',
        Label: '(221) FC21LiveCasinoPlayNow - BetLimit1',
        value: '',
      },
      playnow2: {
        catId: 'N',
        eventId: 222,
        category: '(N) Select a Table - FC21 LC - Desktop',
        eventAction: 'On',
        Label: '(222) FC21LiveCasinoPlayNow - BetLimit2',
        value: '',
      },
      playnow3: {
        catId: 'N',
        eventId: 223,
        category: '(N) Select a Table - FC21 LC - Desktop',
        eventAction: 'On',
        Label: '(223) FC21LiveCasinoPlayNow - BetLimit3',
        value: '',
      },
      playnow4: {
        catId: 'N',
        eventId: 224,
        category: '(N) Select a Table - FC21 LC - Desktop',
        eventAction: 'On',
        Label: '(224) FC21LiveCasinoPlayNow - BetLimit4',
        value: '',
      },
      playnow5: {
        catId: 'N',
        eventId: 225,
        category: '(N) Select a Table - FC21 LC - Desktop',
        eventAction: 'On',
        Label: '(225) FC21LiveCasinoPlayNow - BetLimit5',
        value: '',
      },
      playnow0: {
        catId: 'N',
        eventId: 226,
        category: '(N) Select a Table - FC21 LC - Desktop',
        eventAction: 'On',
        Label: '(226) FC21LiveCasinoPlayNow - NewTable',
        value: '',
      },
      gamedetails: {
        catId: 'N',
        eventId: 227,
        category: '(N) Select a Table - FC21 LC - Desktop',
        eventAction: 'Click',
        Label: '(227) FC21LiveCasinoGameSettings Open/Close',
        value: '',
      },
    };
  }

  public static get FC21PT5HDesktop() {
    return {
      favorites6: {
        catId: 'O',
        eventId: 228,
        category: '(O) Select a Table-FC21 PT5H-Desktop',
        eventAction: 'On',
        Label: '(228) FC21PrivateTable5HFavoritesIconSelected - BetLimit1',
        value: '',
      },
      favorites7: {
        catId: 'O',
        eventId: 229,
        category: '(O) Select a Table - FC21 PT5H - Desktop',
        eventAction: 'On',
        Label: '(229) FC21PrivateTable5HFavoritesIconSelected - BetLimit2',
        value: '',
      },
      favorites8: {
        catId: 'O',
        eventId: 230,
        category: '(O) Select a Table - FC21 PT5H - Desktop',
        eventAction: 'On',
        Label: '(230) FC21PrivateTable5HFavoritesIconSelected - BetLimit3',
        value: '',
      },
      favorites9: {
        catId: 'O',
        eventId: 231,
        category: '(O) Select a Table - FC21 PT5H - Desktop',
        eventAction: 'On',
        Label: '(231) FC21PrivateTable5HFavoritesIconSelected - BetLimit4',
        value: '',
      },
      favorites10: {
        catId: 'O',
        eventId: 232,
        category: '(O) Select a Table - FC21 PT5H - Desktop',
        eventAction: 'On',
        Label: '(232) FC21PrivateTable5HFavoritesIconSelected - BetLimit5',
        value: '',
      },
      favorites0: {
        catId: 'O',
        eventId: 233,
        category: '(O) Select a Table - FC21 PT5H - Desktop',
        eventAction: 'On',
        Label: '(233) FC21PrivateTable5HFavoritesIconSelected - NewTable',
        value: '',
      },
      playnow6: {
        catId: 'O',
        eventId: 234,
        category: '(O) Select a Table - FC21 PT5H - Desktop',
        eventAction: 'On',
        Label: '(234) FC21PrivateTable5HPlayNow - BetLimit1',
        value: '',
      },
      playnow7: {
        catId: 'O',
        eventId: 235,
        category: '(O) Select a Table - FC21 PT5H - Desktop',
        eventAction: 'On',
        Label: '(235) FC21PrivateTable5HPlayNow - BetLimit2',
        value: '',
      },
      playnow8: {
        catId: 'O',
        eventId: 236,
        category: '(O) Select a Table - FC21 PT5H - Desktop',
        eventAction: 'On',
        Label: '(236) FC21PrivateTable5HPlayNow - BetLimit3',
        value: '',
      },
      playnow9: {
        catId: 'O',
        eventId: 237,
        category: '(O) Select a Table - FC21 PT5H - Desktop',
        eventAction: 'On',
        Label: '(237) FC21PrivateTable5HPlayNow - BetLimit4',
        value: '',
      },
      playnow10: {
        catId: 'O',
        eventId: 238,
        category: '(O) Select a Table - FC21 PT5H - Desktop',
        eventAction: 'On',
        Label: '(238) FC21PrivateTable5HPlayNow - BetLimit5',
        value: '',
      },
      playnow0: {
        catId: 'O',
        eventId: 239,
        category: '(O) Select a Table - FC21 PT5H - Desktop',
        eventAction: 'On',
        Label: '(239) FC21PrivateTable5HPlayNow - NewTable',
        value: '',
      },
      gamedetails: {
        catId: 'O',
        eventId: 240,
        category: '(O) Select a Table - FC21 PT5H - Desktop',
        eventAction: 'Click',
        Label: '(240) FC21PrivateTable5HGameSettings Open/Close',
        value: '',
      },
    };
  }
  public static get FCBHeaderDesktop() {
    return {
      livedealer: {
        catId: 'P',
        eventId: 241,
        category: '(P) Select a Table - FCB Header - Desktop',
        eventAction: 'Click',
        Label: '(241) FCBDropDownSwitchToLiveDealer',
        value: '',
      },
      livecasino: {
        catId: 'P',
        eventId: 242,
        category: '(P) Select a Table - FCB Header - Desktop',
        eventAction: 'Click',
        Label: '(242) FCBDropDownSwitchToLiveCasino',
        value: '',
      },
      private: {
        catId: 'P',
        eventId: 243,
        category: '(P) Select a Table - FCB Header - Desktop',
        eventAction: 'Click',
        Label: '(243) FCBDropDownSwitchToPrivateTable',
        value: '',
      },
      privatefriends: {
        catId: 'P',
        eventId: 244,
        category: '(P) Select a Table - FCB Header - Desktop',
        eventAction: 'Click',
        Label: '(244) FCBDropDownSwitchToPrivateTable+',
        value: '',
      },
      livedealer_icon: {
        catId: 'P',
        eventId: 245,
        category: '(P) Select a Table - FCB Header - Desktop',
        eventAction: 'Click',
        Label: '(245) FCBLiveDealer / Live CasinoIcon',
        value: '',
      },
      private_icon: {
        catId: 'P',
        eventId: 246,
        category: '(P) Select a Table - FCB Header - Desktop',
        eventAction: 'Click',
        Label: '(246) FCBPrivateTableIcon / LiveCasinoIcon',
        value: '',
      },
      livecasino_icon: {
        catId: 'P',
        eventId: 246,
        category: '(P) Select a Table - FCB Header - Desktop',
        eventAction: 'Click',
        Label: '(246) FCBPrivateTableIcon / LiveCasinoIcon',
        value: '',
      },
      privatefriends_icon: {
        catId: 'P',
        eventId: 247,
        category: '(P) Select a Table - FCB Header - Desktop',
        eventAction: 'Click',
        Label: '(247) FCBPrivateTableFriendsIcon',
        value: '',
      },
    };
  }
  public static get FCBLDDesktop() {
    return {
      favorites1: {
        catId: 'Q',
        eventId: 248,
        category: '(Q) Select a Table - FCB LD - Desktop',
        eventAction: 'On',
        Label: '(248) FCBLiveDealerFavoritesIconSelected - Studio1',
        value: '',
      },
      favorites2: {
        catId: 'Q',
        eventId: 249,
        category: '(Q) Select a Table - FCB LD - Desktop',
        eventAction: 'On',
        Label: '(249) FCBLiveDealerFavoritesIconSelected - Studio2',
        value: '',
      },
      favorites3: {
        catId: 'Q',
        eventId: 250,
        category: '(Q) Select a Table - FCB LD - Desktop',
        eventAction: 'On',
        Label: '(250) FCBLiveDealerFavoritesIconSelected - Studio3',
        value: '',
      },
      favorites4: {
        catId: 'Q',
        eventId: 251,
        category: '(Q) Select a Table - FCB LD - Desktop',
        eventAction: 'On',
        Label: '(251) FCBLiveDealerFavoritesIconSelected - Studio4',
        value: '',
      },
      favorites5: {
        catId: 'Q',
        eventId: 252,
        category: '(Q) Select a Table - FCB LD - Desktop',
        eventAction: 'On',
        Label: '(252) FCBLiveDealerFavoritesIconSelected - Studio5',
        value: '',
      },
      favoritesnewtable: {
        catId: 'Q',
        eventId: 253,
        category: '(Q) Select a Table - FCB LD - Desktop',
        eventAction: 'On',
        Label: '(253) FCBLiveDealerFavoritesIconSelected - Studio6',
        value: '',
      },
      playnow1: {
        catId: 'Q',
        eventId: 254,
        category: '(Q) Select a Table - FCB LD - Desktop',
        eventAction: 'On',
        Label: '(254) FCBLiveDealerPlayNow - Table1',
        value: '',
      },
      playnow2: {
        catId: 'Q',
        eventId: 255,
        category: '(Q) Select a Table - FCB LD - Desktop',
        eventAction: 'On',
        Label: '(255) FCBLiveDealerPlayNow - Table2',
        value: '',
      },
      playnow3: {
        catId: 'Q',
        eventId: 256,
        category: '(Q) Select a Table - FCB LD - Desktop',
        eventAction: 'On',
        Label: '(256) FCBLiveDealerPlayNow - Table3',
        value: '',
      },
      playnow4: {
        catId: 'Q',
        eventId: 257,
        category: '(Q) Select a Table - FCB LD - Desktop',
        eventAction: 'On',
        Label: '(257) FCBLiveDealerPlayNow - Table4',
        value: '',
      },
      playnow5: {
        catId: 'Q',
        eventId: 258,
        category: '(Q) Select a Table - FCB LD - Desktop',
        eventAction: 'On',
        Label: '(258) FCBLiveDealerPlayNow - Table5',
        value: '',
      },
      playnow0: {
        catId: 'Q',
        eventId: 259,
        category: '(Q) Select a Table - FCB LD - Desktop',
        eventAction: 'On',
        Label: '(259) FCBLiveDealerPlayNow - Table6',
        value: '',
      },
      gamedetails: {
        catId: 'Q',
        eventId: 260,
        category: '(Q) Select a Table - FCB LD - Desktop',
        eventAction: 'Click',
        Label: '(260) FCBLiveDealerGameSettings Open/Close',
        value: '',
      },
    };
  }

  public static get FCBLCDesktop() {
    return {
      favorites1: {
        catId: 'R',
        eventId: 261,
        category: '(R) Select a Table - FCB LC - Desktop',
        eventAction: 'On',
        Label: '(261) FCBLiveCasinoFavoritesIconSelected - BetLimit1',
        value: '',
      },
      favorites2: {
        catId: 'R',
        eventId: 262,
        category: '(R) Select a Table - FCB LC - Desktop',
        eventAction: 'On',
        Label: '(262) FCBLiveCasinoFavoritesIconSelected - BetLimit2',
        value: '',
      },
      favorites3: {
        catId: 'R',
        eventId: 263,
        category: '(R) Select a Table - FCB LC - Desktop',
        eventAction: 'On',
        Label: '(263) FCBLiveCasinoFavoritesIconSelected - BetLimit3',
        value: '',
      },
      favorites4: {
        catId: 'R',
        eventId: 264,
        category: '(R) Select a Table - FCB LC - Desktop',
        eventAction: 'On',
        Label: '(264) FCBLiveCasinoFavoritesIconSelected - BetLimit4',
        value: '',
      },
      favorites5: {
        catId: 'R',
        eventId: 265,
        category: '(R) Select a Table - FCB LC - Desktop',
        eventAction: 'On',
        Label: '(265) FCBLiveCasinoFavoritesIconSelected - BetLimit5',
        value: '',
      },
      favorites0: {
        catId: 'R',
        eventId: 266,
        category: '(R) Select a Table - FCB LC - Desktop',
        eventAction: 'On',
        Label: '(266) FCBLiveCasinoFavoritesIconSelected - NewTable',
        value: '',
      },
      playnow1: {
        catId: 'R',
        eventId: 267,
        category: '(R) Select a Table - FCB LC - Desktop',
        eventAction: 'On',
        Label: '(267) FCBLiveCasinoPlayNow - BetLimit1',
        value: '',
      },
      playnow2: {
        catId: 'R',
        eventId: 268,
        category: '(R) Select a Table - FCB LC - Desktop',
        eventAction: 'On',
        Label: '(268) FCBLiveCasinoPlayNow - BetLimit2',
        value: '',
      },
      playnow3: {
        catId: 'R',
        eventId: 269,
        category: '(R) Select a Table - FCB LC - Desktop',
        eventAction: 'On',
        Label: '(269) FCBLiveCasinoPlayNow - BetLimit3',
        value: '',
      },
      playnow4: {
        catId: 'R',
        eventId: 270,
        category: '(R) Select a Table - FCB LC - Desktop',
        eventAction: 'On',
        Label: '(270) FCBLiveCasinoPlayNow - BetLimit4',
        value: '',
      },
      playnow5: {
        catId: 'R',
        eventId: 271,
        category: '(R) Select a Table - FCB LC - Desktop',
        eventAction: 'On',
        Label: '(271) FCBLiveCasinoPlayNow - BetLimit5',
        value: '',
      },
      playnow0: {
        catId: 'R',
        eventId: 272,
        category: '(R) Select a Table - FCB LC - Desktop',
        eventAction: 'On',
        Label: '(272) FCBLiveCasinoPlayNow - NewTable',
        value: '',
      },
      gamedetails: {
        catId: 'R',
        eventId: 273,
        category: '(R) Select a Table - FCB LC - Desktop',
        eventAction: 'Click',
        Label: '(273) FCBLiveCasinoGameSettings Open/Close',
        value: '',
      },
    };
  }

  public static get FCBPTDesktop() {
    return {
      favorites6: {
        catId: 'S',
        eventId: 274,
        category: '(S) Select a Table - FCB PT-Desktop',
        eventAction: 'On',
        Label: '(274) FCBPrivateTable5HFavoritesIconSelected - BetLimit1',
        value: '',
      },
      favorites7: {
        catId: 'S',
        eventId: 275,
        category: '(S) Select a Table - FCB PT - Desktop',
        eventAction: 'On',
        Label: '(275) FCBPrivateTable5HFavoritesIconSelected - BetLimit2',
        value: '',
      },
      favorites8: {
        catId: 'S',
        eventId: 276,
        category: '(S) Select a Table - FCB PT - Desktop',
        eventAction: 'On',
        Label: '(276) FCBPrivateTable5HFavoritesIconSelected - BetLimit3',
        value: '',
      },
      favorites9: {
        catId: 'S',
        eventId: 277,
        category: '(S) Select a Table - FCB PT - Desktop',
        eventAction: 'On',
        Label: '(277) FCBPrivateTable5HFavoritesIconSelected - BetLimit4',
        value: '',
      },
      favorites10: {
        catId: 'S',
        eventId: 278,
        category: '(S) Select a Table - FCB PT - Desktop',
        eventAction: 'On',
        Label: '(278) FCBPrivateTable5HFavoritesIconSelected - BetLimit5',
        value: '',
      },
      favorites0: {
        catId: 'S',
        eventId: 279,
        category: '(S) Select a Table - FCB PT - Desktop',
        eventAction: 'On',
        Label: '(279) FCBPrivateTable5HFavoritesIconSelected - NewTable',
        value: '',
      },
      playnow6: {
        catId: 'S',
        eventId: 280,
        category: '(S) Select a Table - FCB PT - Desktop',
        eventAction: 'On',
        Label: '(280) FCBPrivateTable5HPlayNow - BetLimit1',
        value: '',
      },
      playnow7: {
        catId: 'S',
        eventId: 281,
        category: '(S) Select a Table - FCB PT - Desktop',
        eventAction: 'On',
        Label: '(281) FCBPrivateTable5HPlayNow - BetLimit2',
        value: '',
      },
      playnow8: {
        catId: 'S',
        eventId: 282,
        category: '(S) Select a Table - FCB PT - Desktop',
        eventAction: 'On',
        Label: '(282) FCBPrivateTable5HPlayNow - BetLimit3',
        value: '',
      },
      playnow9: {
        catId: 'S',
        eventId: 283,
        category: '(S) Select a Table - FCB PT - Desktop',
        eventAction: 'On',
        Label: '(283) FCBPrivateTable5HPlayNow - BetLimit4',
        value: '',
      },
      playnow10: {
        catId: 'S',
        eventId: 284,
        category: '(S) Select a Table - FCB PT - Desktop',
        eventAction: 'On',
        Label: '(284) FCBPrivateTable5HPlayNow - BetLimit5',
        value: '',
      },
      playnow0: {
        catId: 'S',
        eventId: 285,
        category: '(S) Select a Table - FCB PT - Desktop',
        eventAction: 'On',
        Label: '(285) FCBPrivateTable5HPlayNow - NewTable',
        value: '',
      },
      gamedetails: {
        catId: 'S',
        eventId: 286,
        category: '(S) Select a Table - FCB PT - Desktop',
        eventAction: 'Click',
        Label: '(286) FCBPrivateTable5HGameSettings Open/Close',
        value: '',
      },
    };
  }

  public static get LOBBYMOBILEHEADER() {
    return {
      menu: {
        catId: 'T',
        eventId: 287,
        category: '(T) Lobby Mobile - Header',
        eventAction: 'Click',
        Label: '(287) Header - Menu',
        value: '',
      },
      fcg: {
        catId: 'T',
        eventId: 288,
        category: '(T) Lobby Mobile - Header',
        eventAction: 'Click',
        Label: '(288) Header - HomeIcon',
        value: '',
      },
      mobile_icon: {
        catId: 'T',
        eventId: 289,
        category: '(T) Lobby Mobile - Header',
        eventAction: 'Click',
        Label: '(289)Header - MobileView On',
        value: '',
      },
      desktop_icon: {
        catId: 'T',
        eventId: 290,
        category: '(T) Lobby Mobile - Header',
        eventAction: 'Click',
        Label: '(290) Header - DesktopView On',
        value: '',
      },
      livedealer: {
        catId: 'T',
        eventId: 291,
        category: '(T) Lobby Mobile - Header',
        eventAction: 'Click',
        Label: '(291) Header - LiveDealerIcon',
        value: '',
      },
      livecasino: {
        catId: 'T',
        eventId: 292,
        category: '(T) Lobby Mobile - Header',
        eventAction: 'Click',
        Label: '(292) Header - LiveCasinoIcon',
        value: '',
      },
      private: {
        catId: 'T',
        eventId: 293,
        category: '(T) Lobby Mobile - Header',
        eventAction: 'Click',
        Label: '(293) Header - PrivateTableIcon',
        value: '',
      },
      privatefriends: {
        catId: 'T',
        eventId: 293,
        category: '(T) Lobby Mobile - Header',
        eventAction: 'Click',
        Label: '(293) Header - PrivateTable+Icon',
        value: '',
      },
      favoritesopen: {
        catId: 'T',
        eventId: 294,
        category: '(T) Lobby Mobile - Header',
        eventAction: 'Click',
        Label: '(294) Header - FavoritesOpen',
        value: '',
      },
      favoritesplay: {
        catId: 'T',
        eventId: 295,
        category: '(T) Lobby Mobile - Header',
        eventAction: 'Click',
        Label: '(295) Header - FavoritesPlay',
        value: '',
      },
      info_icon_fc21: {
        catId: 'T',
        eventId: 296,
        category: '(T) Lobby Mobile - Header',
        eventAction: 'Click',
        Label:
          '(296) Header-FC21Settings (Change the  (i) Icon to Settings Icon route to FC21)',
        value: '',
      },
      info_icon_fcb: {
        catId: 'T',
        eventId: 297,
        category: '(T) Lobby Mobile - Header',
        eventAction: 'Click',
        Label:
          '(297) Header-FCBSettings (Change (i) Icon to Settings Icon route to FCB)',
        value: '',
      },
      premiumpay_icon_fc21: {
        catId: 'T',
        eventId: 298,
        category: '(T) Lobby Mobile - Header',
        eventAction: 'Click',
        Label: '(298) Header - FC21 Premium Pays Icon',
        value: '',
      },
      premiumpay_icon_fcb: {
        catId: 'T',
        eventId: 299,
        category: '(T) Lobby Mobile - Header',
        eventAction: 'Click',
        Label: '(299) Header - FCB Premium Pays Icon',
        value: '',
      },
    };
  }

  public static get SOCIALMEDIALINKS() {
    return {
      gameinfo: {
        catId: 'U',
        eventId: 300,
        category: '(U) Social Media Links',
        eventAction: 'Click',
        Label: '(300) SocialMedia - GameInfo',
        value: '',
      },
      youtube: {
        catId: 'U',
        eventId: 301,
        category: '(U) Social Media Links',
        eventAction: 'Click',
        Label: '(301) SocialMedia - YouTube',
        value: '',
      },
      zendesk: {
        catId: 'U',
        eventId: 302,
        category: '(U) Social Media Links',
        eventAction: 'Click',
        Label: '(302) SocialMedia - ZendeskCommunity',
        value: '',
      },
      twitch: {
        catId: 'U',
        eventId: 303,
        category: '(U) Social Media Links',
        eventAction: 'Click',
        Label: '(303) SocialMedia - Twitch',
        value: '',
      },
      medium: {
        catId: 'U',
        eventId: 304,
        category: '(U) Social Media Links',
        eventAction: 'Click',
        Label: '(304) SocialMedia - Medium',
        value: '',
      },
      facebook: {
        catId: 'U',
        eventId: 305,
        category: '(U) Social Media Links',
        eventAction: 'Click',
        Label: '(305) SocialMedia - Facebook',
        value: '',
      },
      instagram: {
        catId: 'U',
        eventId: 306,
        category: '(U) Social Media Links',
        eventAction: 'Click',
        Label: '(306) SocialMedia - Instagram',
        value: '',
      },
      twitter: {
        catId: 'U',
        eventId: 307,
        category: '(U) Social Media Links',
        eventAction: 'Click',
        Label: '(307) SocialMedia - Twitter',
        value: '',
      },
    };
  }

  public static get LOBBYMOBILE() {
    return {
      livedealer_fc21: {
        catId: 'V',
        eventId: 308,
        category: '(V) Lobby Mobile (Links)',
        eventAction: 'Click',
        Label: '(308) FC21 - LiveDealer - Select a Table',
        value: '',
      },
      livecasino_fc21_5h: {
        catId: 'V',
        eventId: 309,
        category: '(V) Lobby Mobile (Links)',
        eventAction: 'Click',
        Label: '(309) FC21 - LiveCasino - Select a Table',
        value: '',
      },
      private_fc21_2h: {
        catId: 'V',
        eventId: 310,
        category: '(V) Lobby Mobile (Links)',
        eventAction: 'Click',
        Label: '(310) FC21 - PrivateTable 2H - Select a Table',
        value: '',
      },
      private_fc21_3h: {
        catId: 'V',
        eventId: 311,
        category: '(V) Lobby Mobile (Links)',
        eventAction: 'Click',
        Label: '(311) FC21 - PrivateTable 3H - Select a Table',
        value: '',
      },
      private_fc21_5h: {
        catId: 'V',
        eventId: 312,
        category: '(V) Lobby Mobile (Links)',
        eventAction: 'Click',
        Label: '(312) FC21 - PrivateTable 5H - Select a Table',
        value: '',
      },
      privatefriends_fc21: {
        catId: 'V',
        eventId: 313,
        category: '(V) Lobby Mobile (Links)',
        eventAction: 'Click',
        Label: '(313) FC21 - PrivateTable+Friends - Select a Table',
        value: '',
      },
      livedealer_fcb: {
        catId: 'V',
        eventId: 314,
        category: '(V) Lobby Mobile (Links)',
        eventAction: 'Click',
        Label: '(314) FCB - LiveDealer - Select a Table',
        value: '',
      },
      livecasino_fcb_1h: {
        catId: 'V',
        eventId: 315,
        category: '(V) Lobby Mobile (Links)',
        eventAction: 'Click',
        Label: '(315) FCB - LiveCasino - Select a Table',
        value: '',
      },
      private_fcb_1h: {
        catId: 'V',
        eventId: 316,
        category: '(V) Lobby Mobile (Links)',
        eventAction: 'Click',
        Label: '(316) FCB - PrivateTable - Select a Table',
        value: '',
      },
      privatefriends_fcb: {
        catId: 'V',
        eventId: 317,
        category: '(V) Lobby Mobile (Links)',
        eventAction: 'Click',
        Label: '(317) FCB - PrivateTable+Friends - Select a Table',
        value: '',
      },
    };
  }

  public static get FC21HEADERMOBILE() {
    return {
      livedealer: {
        catId: 'W',
        eventId: 318,
        category: '(W) FC21 Select a Table Mobile Header',
        eventAction: 'Click',
        Label: '(318) FC21 Dropdown - SwitchToFCB',
        value: '',
      },
      livecasino: {
        catId: 'W',
        eventId: 319,
        category: '(W) FC21 Select a Table Mobile Header',
        eventAction: 'Click',
        Label: '(319) FCB Dropdown - SwitchToF21',
        value: '',
      },
      LiveCasino_5h: {
        catId: 'W',
        eventId: 320,
        category: '(W) FC21 Select a Table Mobile Header',
        eventAction: 'Click',
        Label: '(320) FC21 Dropdown - LiveCasino - 5Seats',
        value: '',
      },
      private_2h: {
        catId: 'W',
        eventId: 321,
        category: '(W) FC21 Select a Table Mobile Header',
        eventAction: 'Click',
        Label: '(321) FC21 Dropdown - PrivateTable - 2Seats',
        value: '',
      },
      private_3h: {
        catId: 'W',
        eventId: 322,
        category: '(W) FC21 Select a Table Mobile Header',
        eventAction: 'Click',
        Label: '(322) FC21 Dropdown - PrivateTable - 3Seats',
        value: '',
      },
      private_5h: {
        catId: 'W',
        eventId: 323,
        category: '(W) FC21 Select a Table Mobile Header',
        eventAction: 'Click',
        Label: '(323) FC21 Dropdown - PrivateTable - 5Seats',
        value: '',
      },
      fc21_dropdown: {
        catId: 'W',
        eventId: 324,
        category: '(W) FC21 Select a Table Mobile Header',
        eventAction: 'Click',
        Label: '(324) FC21 Dropdown - Live Dealer',
        value: '',
      },
    };
  }
  public static get FC21LDMOBILE() {
    return {
      favorites1: {
        catId: 'X',
        eventId: 202,
        category: '(X) Select a Table - FC21 LD - Mobile',
        eventAction: 'On',
        Label: '(202) FC21LiveDealerFavoritesIconSelected - Studio1',
        value: '',
      },
      favorites2: {
        catId: 'X',
        eventId: 203,
        category: '(X) Select a Table - FC21 LD - Mobile',
        eventAction: 'On',
        Label: '(203) FC21LiveDealerFavoritesIconSelected - Studio2',
        value: '',
      },
      favorites3: {
        catId: 'X',
        eventId: 204,
        category: '(X) Select a Table - FC21 LD - Mobile',
        eventAction: 'On',
        Label: '(204) FC21LiveDealerFavoritesIconSelected - Studio3',
        value: '',
      },
      favorites4: {
        catId: 'X',
        eventId: 205,
        category: '(X) Select a Table - FC21 LD - Mobile',
        eventAction: 'On',
        Label: '(205) FC21LiveDealerFavoritesIconSelected - Studio4',
        value: '',
      },
      favorites5: {
        catId: 'X',
        eventId: 206,
        category: '(X) Select a Table - FC21 LD - Mobile',
        eventAction: 'On',
        Label: '(206) FC21LiveDealerFavoritesIconSelected - Studio5',
        value: '',
      },
      favorites0: {
        catId: 'X',
        eventId: 207,
        category: '(X) Select a Table - FC21 LD - Mobile',
        eventAction: 'On',
        Label: '(207) FC21LiveDealerFavoritesIconSelected - Studio6',
        value: '',
      },
      playnow1: {
        catId: 'X',
        eventId: 208,
        category: '(X) Select a Table - FC21 LD - Mobile',
        eventAction: 'On',
        Label: '(208) FC21LiveDealerPlayNow - Table1',
        value: '',
      },
      playnow2: {
        catId: 'X',
        eventId: 209,
        category: '(X) Select a Table - FC21 LD - Mobile',
        eventAction: 'On',
        Label: '(209) FC21LiveDealerPlayNow - Table2',
        value: '',
      },
      playnow3: {
        catId: 'X',
        eventId: 210,
        category: '(X) Select a Table - FC21 LD - Mobile',
        eventAction: 'On',
        Label: '(210) FC21LiveDealerPlayNow - Table3',
        value: '',
      },
      playnow4: {
        catId: 'X',
        eventId: 211,
        category: '(X) Select a Table - FC21 LD - Mobile',
        eventAction: 'On',
        Label: '(211) FC21LiveDealerPlayNow - Table4',
        value: '',
      },
      playnow5: {
        catId: 'X',
        eventId: 212,
        category: '(X) Select a Table - FC21 LD - Mobile',
        eventAction: 'On',
        Label: '(212) FC21LiveDealerPlayNow - Table5',
        value: '',
      },
      playnow0: {
        catId: 'X',
        eventId: 213,
        category: '(X) Select a Table - FC21 LD - Mobile',
        eventAction: 'On',
        Label: '(213) FC21LiveDealerPlayNow - Table6',
        value: '',
      },
      gamedetails: {
        catId: 'X',
        eventId: 214,
        category: '(X) Select a Table - FC21 LD - Mobile',
        eventAction: 'Click',
        Label: '(214) FC21LiveDealerGameSettings Open/Close',
        value: '',
      },
    };
  }
  public static get FC21LCMOBILE() {
    return {
      favorites1: {
        catId: 'Y',
        eventId: 215,
        category: '(X) Select a Table - FC21 LC - Mobile',
        eventAction: 'On',
        Label: '(215) FC21LiveCasinoFavoritesIconSelected - BetLimit1',
        value: '',
      },
      favorites2: {
        catId: 'Y',
        eventId: 216,
        category: '(X) Select a Table - FC21 LC - Mobile',
        eventAction: 'On',
        Label: '(216) FC21LiveCasinoFavoritesIconSelected - BetLimit2',
        value: '',
      },
      favorites3: {
        catId: 'Y',
        eventId: 217,
        category: '(X) Select a Table - FC21 LC - Mobile',
        eventAction: 'On',
        Label: '(217) FC21LiveCasinoFavoritesIconSelected - BetLimit3',
        value: '',
      },
      favorites4: {
        catId: 'Y',
        eventId: 218,
        category: '(X) Select a Table - FC21 LC - Mobile',
        eventAction: 'On',
        Label: '(218) FC21LiveCasinoFavoritesIconSelected - BetLimit4',
        value: '',
      },
      favorites5: {
        catId: 'Y',
        eventId: 219,
        category: '(X) Select a Table - FC21 LC - Mobile',
        eventAction: 'On',
        Label: '(219) FC21LiveCasinoFavoritesIconSelected - BetLimit5',
        value: '',
      },
      favorites0: {
        catId: 'Y',
        eventId: 220,
        category: '(X) Select a Table - FC21 LC - Mobile',
        eventAction: 'On',
        Label: '(220) FC21LiveCasinoFavoritesIconSelected - NewTable',
        value: '',
      },
      playnow1: {
        catId: 'Y',
        eventId: 221,
        category: '(X) Select a Table - FC21 LC - Mobile',
        eventAction: 'On',
        Label: '(221) FC21LiveCasinoPlayNow - BetLimit1',
        value: '',
      },
      playnow2: {
        catId: 'Y',
        eventId: 222,
        category: '(X) Select a Table - FC21 LC - Mobile',
        eventAction: 'On',
        Label: '(222) FC21LiveCasinoPlayNow - BetLimit2',
        value: '',
      },
      playnow3: {
        catId: 'Y',
        eventId: 223,
        category: '(X) Select a Table - FC21 LC - Mobile',
        eventAction: 'On',
        Label: '(223) FC21LiveCasinoPlayNow - BetLimit3',
        value: '',
      },
      playnow4: {
        catId: 'Y',
        eventId: 224,
        category: '(X) Select a Table - FC21 LC - Mobile',
        eventAction: 'On',
        Label: '(224) FC21LiveCasinoPlayNow - BetLimit4',
        value: '',
      },
      playnow5: {
        catId: 'Y',
        eventId: 225,
        category: '(X) Select a Table - FC21 LC - Mobile',
        eventAction: 'On',
        Label: '(225) FC21LiveCasinoPlayNow - BetLimit5',
        value: '',
      },
      playnow0: {
        catId: 'Y',
        eventId: 226,
        category: '(X) Select a Table - FC21 LC - Mobile',
        eventAction: 'On',
        Label: '(226) FC21LiveCasinoPlayNow - NewTable',
        value: '',
      },
      gamedetails: {
        catId: 'Y',
        eventId: 227,
        category: '(X) Select a Table - FC21 LC - Mobile',
        eventAction: 'Click',
        Label: '(227) FC21LiveCasinoGameSettings Open/Close',
        value: '',
      },
    };
  }

  public static get FC21PT5HMOBILE() {
    return {
      favorites6: {
        catId: 'Z',
        eventId: 228,
        category: '(Z) Select a Table-FC21 PT5H-Mobile',
        eventAction: 'On',
        Label: '(228) FC21PrivateTable5HFavoritesIconSelected - BetLimit1',
        value: '',
      },
      favorites7: {
        catId: 'Z',
        eventId: 229,
        category: '(Z) Select a Table - FC21 PT5H - Mobile',
        eventAction: 'On',
        Label: '(229) FC21PrivateTable5HFavoritesIconSelected - BetLimit2',
        value: '',
      },
      favorites8: {
        catId: 'Z',
        eventId: 230,
        category: '(Z) Select a Table - FC21 PT5H - Mobile',
        eventAction: 'On',
        Label: '(230) FC21PrivateTable5HFavoritesIconSelected - BetLimit3',
        value: '',
      },
      favorites9: {
        catId: 'Z',
        eventId: 231,
        category: '(Z) Select a Table - FC21 PT5H - Mobile',
        eventAction: 'On',
        Label: '(231) FC21PrivateTable5HFavoritesIconSelected - BetLimit4',
        value: '',
      },
      favorites10: {
        catId: 'Z',
        eventId: 232,
        category: '(Z) Select a Table - FC21 PT5H - Mobile',
        eventAction: 'On',
        Label: '(232) FC21PrivateTable5HFavoritesIconSelected - BetLimit5',
        value: '',
      },
      favorites0: {
        catId: 'Z',
        eventId: 233,
        category: '(Z) Select a Table - FC21 PT5H - Mobile',
        eventAction: 'On',
        Label: '(233) FC21PrivateTable5HFavoritesIconSelected - NewTable',
        value: '',
      },
      playnow6: {
        catId: 'Z',
        eventId: 234,
        category: '(Z) Select a Table - FC21 PT5H - Mobile',
        eventAction: 'On',
        Label: '(234) FC21PrivateTable5HPlayNow - BetLimit1',
        value: '',
      },
      playnow7: {
        catId: 'Z',
        eventId: 235,
        category: '(Z) Select a Table - FC21 PT5H - Mobile',
        eventAction: 'On',
        Label: '(235) FC21PrivateTable5HPlayNow - BetLimit2',
        value: '',
      },
      playnow8: {
        catId: 'Z',
        eventId: 236,
        category: '(Z) Select a Table - FC21 PT5H - Mobile',
        eventAction: 'On',
        Label: '(236) FC21PrivateTable5HPlayNow - BetLimit3',
        value: '',
      },
      playnow9: {
        catId: 'Z',
        eventId: 237,
        category: '(Z) Select a Table - FC21 PT5H - Mobile',
        eventAction: 'On',
        Label: '(237) FC21PrivateTable5HPlayNow - BetLimit4',
        value: '',
      },
      playnow10: {
        catId: 'Z',
        eventId: 238,
        category: '(Z) Select a Table - FC21 PT5H - Mobile',
        eventAction: 'On',
        Label: '(238) FC21PrivateTable5HPlayNow - BetLimit5',
        value: '',
      },
      playnow0: {
        catId: 'Z',
        eventId: 239,
        category: '(Z) Select a Table - FC21 PT5H - Mobile',
        eventAction: 'On',
        Label: '(239) FC21PrivateTable5HPlayNow - NewTable',
        value: '',
      },
      gamedetails: {
        catId: 'Z',
        eventId: 240,
        category: '(Z) Select a Table - FC21 PT5H - Mobile',
        eventAction: 'Click',
        Label: '(240) FC21PrivateTable5HGameSettings Open/Close',
        value: '',
      },
    };
  }

  public static get FC21PT2HMOBILE() {
    return {
      favorites6: {
        catId: 'AA',
        eventId: 325,
        category: '(AA) Select a Table - FC21 PT2H - Mobile',
        eventAction: 'On',
        Label: '(325) FC21PrivateTable2HFavoritesIconSelected - BetLimit1',
        value: '',
      },
      favorites7: {
        catId: 'AA',
        eventId: 326,
        category: '(AA) Select a Table - FC21 PT2H - Mobile',
        eventAction: 'On',
        Label: '(326) FC21PrivateTable2HFavoritesIconSelected - BetLimit2',
        value: '',
      },
      favorites8: {
        catId: 'AA',
        eventId: 327,
        category: '(AA) Select a Table - FC21 PT2H - Mobile',
        eventAction: 'On',
        Label: '(327) FC21PrivateTable2HFavoritesIconSelected - BetLimit3',
        value: '',
      },
      favorites9: {
        catId: 'AA',
        eventId: 328,
        category: '(AA) Select a Table - FC21 PT2H - Mobile',
        eventAction: 'On',
        Label: '(328) FC21PrivateTable2HFavoritesIconSelected - BetLimit4',
        value: '',
      },
      favorites10: {
        catId: 'AA',
        eventId: 329,
        category: '(AA) Select a Table - FC21 PT2H - Mobile',
        eventAction: 'On',
        Label: '(329) FC21PrivateTable2HFavoritesIconSelected - BetLimit5',
        value: '',
      },
      favorites0: {
        catId: 'AA',
        eventId: 330,
        category: '(AA) Select a Table - FC21 PT2H - Mobile',
        eventAction: 'On',
        Label: '(330) FC21PrivateTable2HFavoritesIconSelected - NewTable',
        value: '',
      },
      playnow6: {
        catId: 'AA',
        eventId: 331,
        category: '(AA) Select a Table - FC21 PT2H - Mobile',
        eventAction: 'On',
        Label: '(331) FC21PrivateTable2HPlayNow - BetLimit1',
        value: '',
      },
      playnow7: {
        catId: 'AA',
        eventId: 332,
        category: '(AA) Select a Table - FC21 PT2H - Mobile',
        eventAction: 'On',
        Label: '(332) FC21PrivateTable2HPlayNow - BetLimit2',
        value: '',
      },
      playnow8: {
        catId: 'AA',
        eventId: 333,
        category: '(AA) Select a Table - FC21 PT2H - Mobile',
        eventAction: 'On',
        Label: '(333) FC21PrivateTable2HPlayNow - BetLimit3',
        value: '',
      },
      playnow9: {
        catId: 'AA',
        eventId: 334,
        category: '(AA) Select a Table - FC21 PT2H - Mobile',
        eventAction: 'On',
        Label: '(334) FC21PrivateTable2HPlayNow - BetLimit4',
        value: '',
      },
      playnow10: {
        catId: 'AA',
        eventId: 335,
        category: '(AA) Select a Table - FC21 PT2H - Mobile',
        eventAction: 'On',
        Label: '(335) FC21PrivateTable2HPlayNow - BetLimit5',
        value: '',
      },
      playnow0: {
        catId: 'AA',
        eventId: 336,
        category: '(AA) Select a Table - FC21 PT2H - Mobile',
        eventAction: 'On',
        Label: '(336) FC21PrivateTable2HPlayNow - NewTable',
        value: '',
      },
      gamedetails: {
        catId: 'AA',
        eventId: 337,
        category: '(AA) Select a Table - FC21 PT2H - Mobile',
        eventAction: 'Click',
        Label: '(337) FC21PrivateTable2HGameSettings Open/Close',
        value: '',
      },
    };
  }

  public static get FC21PT3HMOBILE() {
    return {
      favorites6: {
        catId: 'AB',
        eventId: 338,
        category: '(AB) Select a Table - FC21 PT3H - Mobile',
        eventAction: 'On',
        Label: '(338) FC21PrivateTable3HFavoritesIconSelected - BetLimit1',
        value: '',
      },
      favorites7: {
        catId: 'AB',
        eventId: 339,
        category: '(AB) Select a Table - FC21 PT3H - Mobile',
        eventAction: 'On',
        Label: '(339) FC21PrivateTable3HFavoritesIconSelected - BetLimit2',
        value: '',
      },
      favorites8: {
        catId: 'AB',
        eventId: 340,
        category: '(AB) Select a Table - FC21 PT3H - Mobile',
        eventAction: 'On',
        Label: '(340) FC21PrivateTable3HFavoritesIconSelected - BetLimit3',
        value: '',
      },
      favorites9: {
        catId: 'AB',
        eventId: 341,
        category: '(AB) Select a Table - FC21 PT3H - Mobile',
        eventAction: 'On',
        Label: '(341) FC21PrivateTable3HFavoritesIconSelected - BetLimit4',
        value: '',
      },
      favorites10: {
        catId: 'AB',
        eventId: 342,
        category: '(AB) Select a Table - FC21 PT3H - Mobile',
        eventAction: 'On',
        Label: '(342) FC21PrivateTable3HFavoritesIconSelected - BetLimit5',
        value: '',
      },
      favorites0: {
        catId: 'AB',
        eventId: 343,
        category: '(AB) Select a Table - FC21 PT3H - Mobile',
        eventAction: 'On',
        Label: '(343) FC21PrivateTable3HFavoritesIconSelected - NewTable',
        value: '',
      },
      playnow6: {
        catId: 'AB',
        eventId: 344,
        category: '(AB) Select a Table - FC21 PT3H - Mobile',
        eventAction: 'On',
        Label: '(344) FC21PrivateTable3HPlayNow - BetLimit1',
        value: '',
      },
      playnow7: {
        catId: 'AB',
        eventId: 345,
        category: '(AB) Select a Table - FC21 PT3H - Mobile',
        eventAction: 'On',
        Label: '(345) FC21PrivateTable3HPlayNow - BetLimit2',
        value: '',
      },
      playnow8: {
        catId: 'AB',
        eventId: 346,
        category: '(AB) Select a Table - FC21 PT3H - Mobile',
        eventAction: 'On',
        Label: '(346) FC21PrivateTable3HPlayNow - BetLimit3',
        value: '',
      },
      playnow9: {
        catId: 'AB',
        eventId: 347,
        category: '(AB) Select a Table - FC21 PT3H - Mobile',
        eventAction: 'On',
        Label: '(347) FC21PrivateTable3HPlayNow - BetLimit4',
        value: '',
      },
      playnow10: {
        catId: 'AB',
        eventId: 348,
        category: '(AB) Select a Table - FC21 PT3H - Mobile',
        eventAction: 'On',
        Label: '(348) FC21PrivateTable3HPlayNow - BetLimit5',
        value: '',
      },
      playnow0: {
        catId: 'AB',
        eventId: 349,
        category: '(AB) Select a Table - FC21 PT3H - Mobile',
        eventAction: 'On',
        Label: '(349) FC21PrivateTable3HPlayNow - NewTable',
        value: '',
      },
      gamedetails: {
        catId: 'AB',
        eventId: 350,
        category: '(AB) Select a Table - FC21 PT3H - Mobile',
        eventAction: 'Click',
        Label: '(350) FC21PrivateTable3HGameSettings Open/Close',
        value: '',
      },
    };
  }
  public static get FCBHEADERMOBILE() {
    return {
      livedealer: {
        catId: 'AC',
        eventId: 318,
        category: '(AC) Select a Table - FCB Header - Mobile',
        eventAction: 'Click',
        Label: '(318) FC21 Dropdown - SwitchToFCB',
        value: '',
      },
      livecasino: {
        catId: 'AC',
        eventId: 319,
        category: '(AC) Select a Table - FCB Header - Mobile',
        eventAction: 'Click',
        Label: '(319) FCB Dropdown - SwitchToF21',
        value: '',
      },
      private: {
        catId: 'AC',
        eventId: 351,
        category: '(AC) Select a Table - FCB Header - Mobile',
        eventAction: 'Click',
        Label: '(351) FCB Dropdown - LiveCasino',
        value: '',
      },
      privatefriends: {
        catId: 'AC',
        eventId: 352,
        category: '(AC) Select a Table - FCB Header - Mobile',
        eventAction: 'Click',
        Label: '(352) FCB Dropdown - PrivateTable',
        value: '',
      },
      livedealer_icon: {
        catId: 'AC',
        eventId: 353,
        category: '(AC) Select a Table - FCB Header - Mobile',
        eventAction: 'Click',
        Label: '(353) FCB Dropdown - LiveDealer',
        value: '',
      },
    };
  }

  public static get FCBLDMOBILE() {
    return {
      favorites1: {
        catId: 'AD',
        eventId: 248,
        category: '(AD) Select a Table - FCB LD - Mobile',
        eventAction: 'On',
        Label: '(248) FCBLiveDealerFavoritesIconSelected - Studio1',
        value: '',
      },
      favorites2: {
        catId: 'AD',
        eventId: 249,
        category: '(AD) Select a Table - FCB LD - Mobile',
        eventAction: 'On',
        Label: '(249) FCBLiveDealerFavoritesIconSelected - Studio2',
        value: '',
      },
      favorites3: {
        catId: 'AD',
        eventId: 250,
        category: '(AD) Select a Table - FCB LD - Mobile',
        eventAction: 'On',
        Label: '(250) FCBLiveDealerFavoritesIconSelected - Studio3',
        value: '',
      },
      favorites4: {
        catId: 'AD',
        eventId: 251,
        category: '(AD) Select a Table - FCB LD - Mobile',
        eventAction: 'On',
        Label: '(251) FCBLiveDealerFavoritesIconSelected - Studio4',
        value: '',
      },
      favorites5: {
        catId: 'AD',
        eventId: 252,
        category: '(AD) Select a Table - FCB LD - Mobile',
        eventAction: 'On',
        Label: '(252) FCBLiveDealerFavoritesIconSelected - Studio5',
        value: '',
      },
      favorites0: {
        catId: 'AD',
        eventId: 253,
        category: '(AD) Select a Table - FCB LD - Mobile',
        eventAction: 'On',
        Label: '(253) FCBLiveDealerFavoritesIconSelected - Studio6',
        value: '',
      },
      playnow1: {
        catId: 'AD',
        eventId: 254,
        category: '(AD) Select a Table - FCB LD - Mobile',
        eventAction: 'On',
        Label: '(254) FCBLiveDealerPlayNow - Table1',
        value: '',
      },
      playnow2: {
        catId: 'AD',
        eventId: 255,
        category: '(AD) Select a Table - FCB LD - Mobile',
        eventAction: 'On',
        Label: '(255) FCBLiveDealerPlayNow - Table2',
        value: '',
      },
      playnow3: {
        catId: 'AD',
        eventId: 256,
        category: '(AD) Select a Table - FCB LD - Mobile',
        eventAction: 'On',
        Label: '(256) FCBLiveDealerPlayNow - Table3',
        value: '',
      },
      playnow4: {
        catId: 'AD',
        eventId: 257,
        category: '(AD) Select a Table - FCB LD - Mobile',
        eventAction: 'On',
        Label: '(257) FCBLiveDealerPlayNow - Table4',
        value: '',
      },
      playnow5: {
        catId: 'AD',
        eventId: 258,
        category: '(AD) Select a Table - FCB LD - Mobile',
        eventAction: 'On',
        Label: '(258) FCBLiveDealerPlayNow - Table5',
        value: '',
      },
      playnow0: {
        catId: 'AD',
        eventId: 259,
        category: '(AD) Select a Table - FCB LD - Mobile',
        eventAction: 'On',
        Label: '(259) FCBLiveDealerPlayNow - Table6',
        value: '',
      },
      gamedetails: {
        catId: 'AD',
        eventId: 260,
        category: '(AD) Select a Table - FCB LD - Mobile',
        eventAction: 'Click',
        Label: '(260) FCBLiveDealerGameSettings Open/Close',
        value: '',
      },
    };
  }

  public static get FCBLCMOBILE() {
    return {
      favorites1: {
        catId: 'AE',
        eventId: 261,
        category: '(AE) Select a Table - FCB LC - Mobile',
        eventAction: 'On',
        Label: '(261) FCBLiveCasinoFavoritesIconSelected - BetLimit1',
        value: '',
      },
      favorites2: {
        catId: 'AE',
        eventId: 262,
        category: '(AE) Select a Table - FCB LC - Mobile',
        eventAction: 'On',
        Label: '(262) FCBLiveCasinoFavoritesIconSelected - BetLimit2',
        value: '',
      },
      favorites3: {
        catId: 'AE',
        eventId: 263,
        category: '(AE) Select a Table - FCB LC - Mobile',
        eventAction: 'On',
        Label: '(263) FCBLiveCasinoFavoritesIconSelected - BetLimit3',
        value: '',
      },
      favorites4: {
        catId: 'AE',
        eventId: 264,
        category: '(AE) Select a Table - FCB LC - Mobile',
        eventAction: 'On',
        Label: '(264) FCBLiveCasinoFavoritesIconSelected - BetLimit4',
        value: '',
      },
      favorites5: {
        catId: 'AE',
        eventId: 265,
        category: '(AE) Select a Table - FCB LC - Mobile',
        eventAction: 'On',
        Label: '(265) FCBLiveCasinoFavoritesIconSelected - BetLimit5',
        value: '',
      },
      favorites0: {
        catId: 'AE',
        eventId: 266,
        category: '(AE) Select a Table - FCB LC - Mobile',
        eventAction: 'On',
        Label: '(266) FCBLiveCasinoFavoritesIconSelected - NewTable',
        value: '',
      },
      playnow1: {
        catId: 'AE',
        eventId: 267,
        category: '(AE) Select a Table - FCB LC - Mobile',
        eventAction: 'On',
        Label: '(267) FCBLiveCasinoPlayNow - BetLimit1',
        value: '',
      },
      playnow2: {
        catId: 'AE',
        eventId: 268,
        category: '(AE) Select a Table - FCB LC - Mobile',
        eventAction: 'On',
        Label: '(268) FCBLiveCasinoPlayNow - BetLimit2',
        value: '',
      },
      playnow3: {
        catId: 'AE',
        eventId: 269,
        category: '(AE) Select a Table - FCB LC - Mobile',
        eventAction: 'On',
        Label: '(269) FCBLiveCasinoPlayNow - BetLimit3',
        value: '',
      },
      playnow4: {
        catId: 'AE',
        eventId: 270,
        category: '(AE) Select a Table - FCB LC - Mobile',
        eventAction: 'On',
        Label: '(270) FCBLiveCasinoPlayNow - BetLimit4',
        value: '',
      },
      playnow5: {
        catId: 'AE',
        eventId: 271,
        category: '(AE) Select a Table - FCB LC - Mobile',
        eventAction: 'On',
        Label: '(271) FCBLiveCasinoPlayNow - BetLimit5',
        value: '',
      },
      playnow0: {
        catId: 'AE',
        eventId: 272,
        category: '(AE) Select a Table - FCB LC - Mobile',
        eventAction: 'On',
        Label: '(272) FCBLiveCasinoPlayNow - NewTable',
        value: '',
      },
      gamedetails: {
        catId: 'AE',
        eventId: 273,
        category: '(AE) Select a Table - FCB LC - Mobile',
        eventAction: 'Click',
        Label: '(273) FCBLiveCasinoGameSettings Open/Close',
        value: '',
      },
    };
  }

  public static get FCBPTMOBILE() {
    return {
      favorites6: {
        catId: 'AF',
        eventId: 274,
        category: '(AF) Select a Table-FCB PT-Mobile',
        eventAction: 'On',
        Label: '(274) FCBPrivateTable5HFavoritesIconSelected - BetLimit1',
        value: '',
      },
      favorites7: {
        catId: 'AF',
        eventId: 275,
        category: '(AF) Select a Table - FCB PT - Mobile',
        eventAction: 'On',
        Label: '(275) FCBPrivateTable5HFavoritesIconSelected - BetLimit2',
        value: '',
      },
      favorites8: {
        catId: 'AF',
        eventId: 276,
        category: '(AF) Select a Table - FCB PT - Mobile',
        eventAction: 'On',
        Label: '(276) FCBPrivateTable5HFavoritesIconSelected - BetLimit3',
        value: '',
      },
      favorites9: {
        catId: 'AF',
        eventId: 277,
        category: '(AF) Select a Table - FCB PT - Mobile',
        eventAction: 'On',
        Label: '(277) FCBPrivateTable5HFavoritesIconSelected - BetLimit4',
        value: '',
      },
      favorites10: {
        catId: 'AF',
        eventId: 278,
        category: '(AF) Select a Table - FCB PT - Mobile',
        eventAction: 'On',
        Label: '(278) FCBPrivateTable5HFavoritesIconSelected - BetLimit5',
        value: '',
      },
      favorites0: {
        catId: 'AF',
        eventId: 279,
        category: '(AF) Select a Table - FCB PT - Mobile',
        eventAction: 'On',
        Label: '(279) FCBPrivateTable5HFavoritesIconSelected - NewTable',
        value: '',
      },
      playnow6: {
        catId: 'AF',
        eventId: 280,
        category: '(AF) Select a Table - FCB PT - Mobile',
        eventAction: 'On',
        Label: '(280) FCBPrivateTable5HPlayNow - BetLimit1',
        value: '',
      },
      playnow7: {
        catId: 'AF',
        eventId: 281,
        category: '(AF) Select a Table - FCB PT - Mobile',
        eventAction: 'On',
        Label: '(281) FCBPrivateTable5HPlayNow - BetLimit2',
        value: '',
      },
      playnow8: {
        catId: 'AF',
        eventId: 282,
        category: '(AF) Select a Table - FCB PT - Mobile',
        eventAction: 'On',
        Label: '(282) FCBPrivateTable5HPlayNow - BetLimit3',
        value: '',
      },
      playnow9: {
        catId: 'AF',
        eventId: 283,
        category: '(AF) Select a Table - FCB PT - Mobile',
        eventAction: 'On',
        Label: '(283) FCBPrivateTable5HPlayNow - BetLimit4',
        value: '',
      },
      playnow10: {
        catId: 'AF',
        eventId: 284,
        category: '(AF) Select a Table - FCB PT - Mobile',
        eventAction: 'On',
        Label: '(284) FCBPrivateTable5HPlayNow - BetLimit5',
        value: '',
      },
      playnow0: {
        catId: 'AF',
        eventId: 285,
        category: '(AF) Select a Table - FCB PT - Mobile',
        eventAction: 'On',
        Label: '(285) FCBPrivateTable5HPlayNow - NewTable',
        value: '',
      },
      gamedetails: {
        catId: 'AF',
        eventId: 286,
        category: '(AF) Select a Table - FCB PT - Mobile',
        eventAction: 'Click',
        Label: '(286) FCBPrivateTable5HGameSettings Open/Close',
        value: '',
      },
    };
  }

  /*-game-----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------*/

  public static get FC21ORNOTHINGGAME() {
    return {
      menu: {
        catId: 'AG',
        eventId: 354,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(354) Menu',
        value: '',
      },
      fullscreen_on: {
        catId: 'AG',
        eventId: 355,
        category: '(AG) FC21orNothing Game',
        eventAction: 'On',
        Label: '(355) FullScreenExpand',
        value: '',
      },
      fullscreen_off: {
        catId: 'AG',
        eventId: 356,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Off',
        Label: '(356) FullScreenMinimize',
        value: '',
      },
      changechips: {
        catId: 'AG',
        eventId: 357,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(357) ChangeChipsIcon',
        value: '',
      } /*'changechips': {catId: 'AG', eventId: 369, category: '(AG) FC21orNothing Game', eventAction: 'Click', Label: '(369) Change Chips', value: ''},*/,
      helpinghands_on: {
        catId: 'AG',
        eventId: 358,
        category: '(AG) FC21orNothing Game',
        eventAction: 'On',
        Label: '(358) HelpingHandsToggleOn',
        value: '',
      },
      helpinghands_off: {
        catId: 'AG',
        eventId: 359,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Off',
        Label: '(359) HelpingHandsToggleOff',
        value: '',
      },
      tutorials_on: {
        catId: 'AG',
        eventId: 360,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(360) TutorialsToggleOn',
        value: '',
      },
      tutorials_off: {
        catId: 'AG',
        eventId: 361,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(361) TutorialsToggleOff',
        value: '',
      },
      quicktips_on: {
        catId: 'AG',
        eventId: 362,
        category: '(AG) FC21orNothing Game',
        eventAction: 'On',
        Label: '(362) QuickTipsToggleOn',
        value: '',
      },
      quicktips_off: {
        catId: 'AG',
        eventId: 363,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Off',
        Label: '(363) QuickTipsToggleOff',
        value: '',
      },
      quickkeys_on: {
        catId: 'AG',
        eventId: 364,
        category: '(AG) FC21orNothing Game',
        eventAction: 'On',
        Label: '(364) QuickKeysToggleOn',
        value: '',
      },
      quickkeys_off: {
        catId: 'AG',
        eventId: 365,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Off',
        Label: '(365) QuickKeysToggleOff',
        value: '',
      },
      settings: {
        catId: 'AG',
        eventId: 366,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(366) Settings',
        value: '',
      },
      selectedchip: {
        catId: 'AG',
        eventId: 367,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(367) SelectedChip',
        value: '',
      },
      placeyourbet: {
        catId: 'AG',
        eventId: 368,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(368) Place Your Bet',
        value: '',
      },
      //'changechips': {catId: 'AG', eventId: 369, category: '(AG) FC21orNothing Game', eventAction: 'Click', Label: '(369) Change Chips', value: ''},
      confirmbet: {
        catId: 'AG',
        eventId: 370,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(370) ConfirmBet',
        value: '',
      },
      allbetscleared: {
        catId: 'AG',
        eventId: 371,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(371) ClearBet',
        value: '',
      },
      stand: {
        catId: 'AG',
        eventId: 372,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(372) Stand',
        value: '',
      },
      hit: {
        catId: 'AG',
        eventId: 373,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(373) Hit',
        value: '',
      },
      doubledown: {
        catId: 'AG',
        eventId: 374,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(374) Double',
        value: '',
      } /*
       'doubleno': {catId: 'AG', eventId: 7, category: '(AG) FC21orNothing Game', eventAction: 'Click', Label: '() DoubleDownIgnored', value: ''},
       'doubleyes': {catId: 'AG', eventId: 7, category: '(AG) FC21orNothing Game', eventAction: 'Click', Label: '() DoubleDownTaken', value: ''},*/,
      russianroulette: {
        catId: 'AG',
        eventId: 375,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(375) RussianRouletteOffered',
        value: '',
      },
      rouletteyes17: {
        catId: 'AG',
        eventId: 376,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(376) RussianRoulette17Taken',
        value: '',
      },
      rouletteyes18: {
        catId: 'AG',
        eventId: 377,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(377) RussianRoulette18Taken',
        value: '',
      },
      rouletteyes19: {
        catId: 'AG',
        eventId: 378,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(378) RussianRoulette19Taken',
        value: '',
      },
      rouletteyes20: {
        catId: 'AG',
        eventId: 379,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(379) RussianRoulette20Taken',
        value: '',
      },
      rouletteno: {
        catId: 'AG',
        eventId: 380,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(380) RussianRouletteIgnored',
        value: '',
      },

      colorinsurance: {
        catId: 'AG',
        eventId: 381,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Show',
        Label: '(381) ColorCardInsuranceOffered',
        value: '',
      },
      colorinsuranceyes: {
        catId: 'AG',
        eventId: 382,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(382) ColorCardInsuranceTaken',
        value: '',
      },
      colorinsuranceno: {
        catId: 'AG',
        eventId: 383,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(383) ColorCardInsuranceIgnored',
        value: '',
      },
      colorinsuranceallyes: {
        catId: 'AG',
        eventId: 384,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(384) ColorCardInsuranceTakenAll',
        value: '',
      },
      colorinsurancetoallno: {
        catId: 'AG',
        eventId: 385,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(385) ColorCardInsuranceIgnoredAll',
        value: '',
      },

      whiteinsurance: {
        catId: 'AG',
        eventId: 386,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Show',
        Label: '(386) WhiteCardInsuranceOffered',
        value: '',
      },
      whiteinsuranceyes: {
        catId: 'AG',
        eventId: 387,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(387) WhiteCardInsuranceTaken',
        value: '',
      },
      whiteinsuranceno: {
        catId: 'AG',
        eventId: 388,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(388) WhiteCardInsuranceIgnored',
        value: '',
      },
      whiteinsuranceallyes: {
        catId: 'AG',
        eventId: 389,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(389) WhiteCardInsuranceTakenAll',
        value: '',
      },
      whiteinsurancetoallno: {
        catId: 'AG',
        eventId: 390,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(390) WhiteCardInsuranceIgnoredAll',
        value: '',
      },

      newbet: {
        catId: 'AG',
        eventId: 391,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(391) NewBet',
        value: '',
      },
      rebet: {
        catId: 'AG',
        eventId: 392,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(392) Rebet',
        value: '',
      },
      rebet2x: {
        catId: 'AG',
        eventId: 393,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(393) Rebet2X',
        value: '',
      },

      splityourhand: {
        catId: 'AG',
        eventId: 394,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Show',
        Label: '(394) SplitYourHandOffered',
        value: '',
      },
      splityes5: {
        catId: 'AG',
        eventId: 395,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(395) SplitYourHandTaken5',
        value: '',
      },
      splityes6: {
        catId: 'AG',
        eventId: 396,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(396) SplitYourHandTaken6',
        value: '',
      },
      splityes7: {
        catId: 'AG',
        eventId: 397,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(397) SplitYourHandTaken7',
        value: '',
      },
      splityes8: {
        catId: 'AG',
        eventId: 398,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(398) SplitYourHandTaken8',
        value: '',
      },
      splityes9: {
        catId: 'AG',
        eventId: 399,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(399) SplitYourHandTaken9',
        value: '',
      },
      splitno: {
        catId: 'AG',
        eventId: 400,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(400) SplitYourHandIgnored',
        value: '',
      },

      '46': {
        catId: 'AG',
        eventId: 401,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(401) QuickKeys - QuickKeyIcon',
        value: '',
      } /**/,
      '47': {
        catId: 'AG',
        eventId: 402,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Press',
        Label: '(402) KeyPress - BetChips',
        value: '',
      } /**/,
      '48': {
        catId: 'AG',
        eventId: 403,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Press',
        Label: '(403) KeyPress - Arrows',
        value: '',
      } /**/,
      '49': {
        catId: 'AG',
        eventId: 404,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Press',
        Label: '(404) KeyPress - Buttons',
        value: '',
      } /**/,

      'betChip_s1h1-2H': {
        catId: 'AG',
        eventId: 405,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(405) PT-2H-BetAmountSeat1Hand1',
        value: '',
      },
      'betChip_s1h2-2H': {
        catId: 'AG',
        eventId: 406,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(406) PT-2H-BetAmountSeat1Hand2',
        value: '',
      },
      'betChip_s2h1-2H': {
        catId: 'AG',
        eventId: 407,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(407) PT-2H-BetAmountSeat2Hand1',
        value: '',
      },
      'betChip_s2h2-2H': {
        catId: 'AG',
        eventId: 408,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(408) PT-2H-BetAmountSeat2Hand2',
        value: '',
      },

      'insuranceBetChip_s1h1-2H': {
        catId: 'AG',
        eventId: 409,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(409) PT-2H-InsuranceBetAmountSeat1',
        value: '',
      },
      'insuranceBetChip_s2h1-2H': {
        catId: 'AG',
        eventId: 410,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(410) PT-2H-InsuranceBetAmountSeat2',
        value: '',
      },

      '56': {
        catId: 'AG',
        eventId: 411,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(411) PT-2H-RRBetAmountRiskedSeat1Hand1',
        value: '',
      } /**/,
      '57': {
        catId: 'AG',
        eventId: 412,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(412) PT-2H-RRBetAmountRiskedSeat1Hand2',
        value: '',
      } /**/,
      '58': {
        catId: 'AG',
        eventId: 413,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(413) PT-2H-RRBetAmountRiskedSeat2Hand1',
        value: '',
      } /**/,
      '59': {
        catId: 'AG',
        eventId: 414,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(414) PT-2H-RRBetAmountRiskedSeat2Hand2',
        value: '',
      } /**/,

      doubleyes_gameType_private_gameHand_2_seat_1_seatHand_1: {
        catId: 'AG',
        eventId: 415,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(415) PT-2H-DoubleDownBetAmountSeat1Hand1',
        value: '',
      },
      doubleyes_gameType_private_gameHand_2_seat_3_seatHand_2: {
        catId: 'AG',
        eventId: 416,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(416) PT-2H-DoubleDownBetAmountSeat1Hand2',
        value: '',
      },
      doubleyes_gameType_private_gameHand_2_seat_2_seatHand_1: {
        catId: 'AG',
        eventId: 417,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(417) PT-2H-DoubleDownBetAmountSeat2Hand1',
        value: '',
      },
      doubleyes_gameType_private_gameHand_2_seat_4_seatHand_2: {
        catId: 'AG',
        eventId: 418,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(418) PT-2H-DoubleDownBetAmountSeat2Hand2',
        value: '',
      },

      'betChip_s1h1-3H': {
        catId: 'AG',
        eventId: 419,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(419) PT-3H-BetAmountSeat1Hand1',
        value: '',
      },
      'betChip_s1h2-3H': {
        catId: 'AG',
        eventId: 420,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(420) PT-3H-BetAmountSeat1Hand2',
        value: '',
      },
      'betChip_s2h1-3H': {
        catId: 'AG',
        eventId: 421,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(421) PT-3H-BetAmountSeat2Hand1',
        value: '',
      },
      'betChip_s2h2-3H': {
        catId: 'AG',
        eventId: 422,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(422) PT-3H-BetAmountSeat2Hand2',
        value: '',
      },
      'betChip_s3h1-3H': {
        catId: 'AG',
        eventId: 423,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(423) PT-3H-BetAmountSeat3Hand1',
        value: '',
      },
      'betChip_s3h2-3H': {
        catId: 'AG',
        eventId: 424,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(424) PT-3H-BetAmountSeat3Hand2',
        value: '',
      },

      'insuranceBetChip_s1h1-3H': {
        catId: 'AG',
        eventId: 425,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(425) PT-3H-InsuranceBetAmountSeat1',
        value: '',
      } /**/,
      'insuranceBetChip_s2h1-3H': {
        catId: 'AG',
        eventId: 426,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(426) PT-3H-InsuranceBetAmountSeat2',
        value: '',
      } /**/,
      'insuranceBetChip_s3h1-3H': {
        catId: 'AG',
        eventId: 427,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(427) PT-3H-InsuranceBetAmountSeat3',
        value: '',
      } /**/,

      '73': {
        catId: 'AG',
        eventId: 428,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(428) PT-3H-RRBetAmountRiskedSeat1Hand1',
        value: '',
      },
      '74': {
        catId: 'AG',
        eventId: 429,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(429) PT-3H-RRBetAmountRiskedSeat1Hand2',
        value: '',
      },
      '75': {
        catId: 'AG',
        eventId: 430,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(430) PT-3H-RRBetAmountRiskedSeat2Hand1',
        value: '',
      },
      '76': {
        catId: 'AG',
        eventId: 431,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(431) PT-3H-RRBetAmountRiskedSeat2Hand2',
        value: '',
      },
      '77': {
        catId: 'AG',
        eventId: 432,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(432) PT-3H-RRBetAmountRiskedSeat3Hand1',
        value: '',
      },
      '78': {
        catId: 'AG',
        eventId: 433,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(433) PT-3H-RRBetAmountRiskedSeat3Hand2',
        value: '',
      },

      doubleyes_gameType_private_gameHand_3_seat_1_seatHand_1: {
        catId: 'AG',
        eventId: 434,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(434) PT-3H-DoubleDownBetAmountSeat1Hand1',
        value: '',
      },
      doubleyes_gameType_private_gameHand_3_seat_4_seatHand_2: {
        catId: 'AG',
        eventId: 435,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(435) PT-3H-DoubleDownBetAmountSeat1Hand2',
        value: '',
      },
      doubleyes_gameType_private_gameHand_3_seat_2_seatHand_1: {
        catId: 'AG',
        eventId: 436,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(436) PT-3H-DoubleDownBetAmountSeat2Hand1',
        value: '',
      },
      doubleyes_gameType_private_gameHand_3_seat_5_seatHand_2: {
        catId: 'AG',
        eventId: 437,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(437) PT-3H-DoubleDownBetAmountSeat2Hand2',
        value: '',
      },
      doubleyes_gameType_private_gameHand_3_seat_3_seatHand_1: {
        catId: 'AG',
        eventId: 438,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(438) PT-3H-DoubleDownBetAmountSeat3Hand1',
        value: '',
      },
      doubleyes_gameType_private_gameHand_3_seat_6_seatHand_2: {
        catId: 'AG',
        eventId: 439,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(439) PT-3H-DoubleDownBetAmountSeat3Hand2',
        value: '',
      },

      'betChip_s1h1-5H': {
        catId: 'AG',
        eventId: 440,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(440) PT-5H-BetAmountSeat1Hand1',
        value: '',
      },
      'betChip_s1h2-5H': {
        catId: 'AG',
        eventId: 441,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(441) PT-5H-BetAmountSeat1Hand2',
        value: '',
      },
      'betChip_s2h1-5H': {
        catId: 'AG',
        eventId: 442,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(442) PT-5H-BetAmountSeat2Hand1',
        value: '',
      },
      'betChip_s2h2-5H': {
        catId: 'AG',
        eventId: 443,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(443) PT-5H-BetAmountSeat2Hand2',
        value: '',
      },
      'betChip_s3h1-5H': {
        catId: 'AG',
        eventId: 444,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(444) PT-5H-BetAmountSeat3Hand1',
        value: '',
      },
      'betChip_s3h2-5H': {
        catId: 'AG',
        eventId: 445,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(445) PT-5H-BetAmountSeat3Hand2',
        value: '',
      },
      'betChip_s4h1-5H': {
        catId: 'AG',
        eventId: 446,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(446) PT-5H-BetAmountSeat4Hand1',
        value: '',
      },
      'betChip_s4h2-5H': {
        catId: 'AG',
        eventId: 447,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(447) PT-5H-BetAmountSeat4Hand2',
        value: '',
      },
      'betChip_s5h1-5H': {
        catId: 'AG',
        eventId: 448,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(448) PT-5H-BetAmountSeat5Hand1',
        value: '',
      },
      'betChip_s5h2-5H': {
        catId: 'AG',
        eventId: 449,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(449) PT-5H-BetAmountSeat5Hand2',
        value: '',
      },

      'insuranceBetChip_s1h1-5H': {
        catId: 'AG',
        eventId: 450,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(450) PT-5H-InsuranceBetAmountSeat1',
        value: '',
      } /**/,
      'insuranceBetChip_s2h1-5H': {
        catId: 'AG',
        eventId: 451,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(451) PT-5H-InsuranceBetAmountSeat2',
        value: '',
      } /**/,
      'insuranceBetChip_s3h1-5H': {
        catId: 'AG',
        eventId: 452,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(452) PT-5H-InsuranceBetAmountSeat3',
        value: '',
      } /**/,
      'insuranceBetChip_s4h1-5H': {
        catId: 'AG',
        eventId: 453,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(453) PT-5H-InsuranceBetAmountSeat4',
        value: '',
      } /**/,
      'insuranceBetChip_s5h1-5H': {
        catId: 'AG',
        eventId: 454,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(454) PT-5H-InsuranceBetAmountSeat5',
        value: '',
      } /**/,

      '100': {
        catId: 'AG',
        eventId: 455,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(455) PT-5H-RRBetAmountRiskedSeat1Hand1',
        value: '',
      },
      '101': {
        catId: 'AG',
        eventId: 456,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(456) PT-5H-RRBetAmountRiskedSeat1Hand2',
        value: '',
      },
      '102': {
        catId: 'AG',
        eventId: 457,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(457) PT-5H-RRBetAmountRiskedSeat2Hand1',
        value: '',
      },
      '103': {
        catId: 'AG',
        eventId: 458,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(458) PT-5H-RRBetAmountRiskedSeat2Hand2',
        value: '',
      },
      '104': {
        catId: 'AG',
        eventId: 459,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(459) PT-5H-RRBetAmountRiskedSeat3Hand1',
        value: '',
      },
      '105': {
        catId: 'AG',
        eventId: 460,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(460) PT-5H-RRBetAmountRiskedSeat3Hand2',
        value: '',
      },
      '106': {
        catId: 'AG',
        eventId: 461,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(461) PT-5H-RRBetAmountRiskedSeat4Hand1',
        value: '',
      },
      '107': {
        catId: 'AG',
        eventId: 462,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(462) PT-5H-RRBetAmountRiskedSeat4Hand2',
        value: '',
      },
      '108': {
        catId: 'AG',
        eventId: 463,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(463) PT-5H-RRBetAmountRiskedSeat5Hand1',
        value: '',
      },
      '109': {
        catId: 'AG',
        eventId: 464,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(464) PT-5H-RRBetAmountRiskedSeat5Hand2',
        value: '',
      },

      doubleyes_gameType_private_gameHand_5_seat_1_seatHand_1: {
        catId: 'AG',
        eventId: 465,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(465) PT-5H-DoubleDownBetAmountSeat1Hand1',
        value: '',
      },
      doubleyes_gameType_private_gameHand_5_seat_6_seatHand_2: {
        catId: 'AG',
        eventId: 466,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(466) PT-5H-DoubleDownBetAmountSeat1Hand2',
        value: '',
      },
      doubleyes_gameType_private_gameHand_5_seat_2_seatHand_1: {
        catId: 'AG',
        eventId: 467,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(467) PT-5H-DoubleDownBetAmountSeat2Hand1',
        value: '',
      },
      doubleyes_gameType_private_gameHand_5_seat_7_seatHand_2: {
        catId: 'AG',
        eventId: 468,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(468) PT-5H-DoubleDownBetAmountSeat2Hand2',
        value: '',
      },
      doubleyes_gameType_private_gameHand_5_seat_3_seatHand_1: {
        catId: 'AG',
        eventId: 469,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(469) PT-5H-DoubleDownBetAmountSeat3Hand1',
        value: '',
      },
      doubleyes_gameType_private_gameHand_5_seat_8_seatHand_2: {
        catId: 'AG',
        eventId: 470,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(470) PT-5H-DoubleDownBetAmountSeat3Hand2',
        value: '',
      },
      doubleyes_gameType_private_gameHand_5_seat_4_seatHand_1: {
        catId: 'AG',
        eventId: 471,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(471) PT-5H-DoubleDownBetAmountSeat4Hand1',
        value: '',
      },
      doubleyes_gameType_private_gameHand_5_seat_9_seatHand_2: {
        catId: 'AG',
        eventId: 472,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(472) PT-5H-DoubleDownBetAmountSeat4Hand2',
        value: '',
      },
      doubleyes_gameType_private_gameHand_5_seat_5_seatHand_1: {
        catId: 'AG',
        eventId: 473,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(473) PT-5H-DoubleDownBetAmountSeat5Hand1',
        value: '',
      },
      doubleyes_gameType_private_gameHand_5_seat_10_seatHand_2: {
        catId: 'AG',
        eventId: 474,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(474) PT-5H-DoubleDownBetAmountSeat5Hand2',
        value: '',
      },

      betChip_s1h1_PTF: {
        catId: 'AG',
        eventId: 475,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(475) PTF-5H-BetAmountSeat1Hand1',
        value: '',
      } /**/,
      betChip_s1h2_PTF: {
        catId: 'AG',
        eventId: 476,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(476) PTF-5H-BetAmountSeat1Hand2',
        value: '',
      } /**/,
      betChip_s2h1_PTF: {
        catId: 'AG',
        eventId: 477,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(477) PTF-5H-BetAmountSeat2Hand1',
        value: '',
      } /**/,
      betChip_s2h2_PTF: {
        catId: 'AG',
        eventId: 478,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(478) PTF-5H-BetAmountSeat2Hand2',
        value: '',
      } /**/,
      betChip_s3h1_PTF: {
        catId: 'AG',
        eventId: 479,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(479) PTF-5H-BetAmountSeat3Hand1',
        value: '',
      } /**/,
      betChip_s3h2_PTF: {
        catId: 'AG',
        eventId: 480,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(480) PTF-5H-BetAmountSeat3Hand2',
        value: '',
      } /**/,
      betChip_s4h1_PTF: {
        catId: 'AG',
        eventId: 481,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(481) PTF-5H-BetAmountSeat4Hand1',
        value: '',
      } /**/,
      betChip_s4h2_PTF: {
        catId: 'AG',
        eventId: 482,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(482) PTF-5H-BetAmountSeat4Hand2',
        value: '',
      } /**/,
      betChip_s5h1_PTF: {
        catId: 'AG',
        eventId: 483,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(483) PTF-5H-BetAmountSeat5Hand1',
        value: '',
      } /**/,
      betChip_s5h2_PTF: {
        catId: 'AG',
        eventId: 484,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(484) PTF-5H-BetAmountSeat5Hand2',
        value: '',
      } /**/,

      insuranceBetChip_s1h1_PTF: {
        catId: 'AG',
        eventId: 485,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(485) PTF-5H-InsuranceBetAmountSeat1',
        value: '',
      } /**/,
      insuranceBetChip_s2h1_PTF: {
        catId: 'AG',
        eventId: 486,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(486) PTF-5H-InsuranceBetAmountSeat2',
        value: '',
      } /**/,
      insuranceBetChip_s3h1_PTF: {
        catId: 'AG',
        eventId: 487,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(487) PTF-5H-InsuranceBetAmountSeat3',
        value: '',
      } /**/,
      insuranceBetChip_s4h1_PTF: {
        catId: 'AG',
        eventId: 488,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(488) PTF-5H-InsuranceBetAmountSeat4',
        value: '',
      } /**/,
      insuranceBetChip_s5h1_PTF: {
        catId: 'AG',
        eventId: 489,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(489) PTF-5H-InsuranceBetAmountSeat5',
        value: '',
      } /**/,

      '135': {
        catId: 'AG',
        eventId: 490,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(490) PTF-5H-RRBetAmountRiskedSeat1Hand1',
        value: '',
      } /**/,
      '136': {
        catId: 'AG',
        eventId: 491,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(491) PTF-5H-RRBetAmountRiskedSeat1Hand2',
        value: '',
      } /**/,
      '137': {
        catId: 'AG',
        eventId: 492,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(492) PTF-5H-RRBetAmountRiskedSeat2Hand1',
        value: '',
      } /**/,
      '138': {
        catId: 'AG',
        eventId: 493,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(493) PTF-5H-RRBetAmountRiskedSeat2Hand2',
        value: '',
      } /**/,
      '139': {
        catId: 'AG',
        eventId: 494,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(494) PTF-5H-RRBetAmountRiskedSeat3Hand1',
        value: '',
      } /**/,
      '140': {
        catId: 'AG',
        eventId: 495,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(495) PTF-5H-RRBetAmountRiskedSeat3Hand2',
        value: '',
      } /**/,
      '141': {
        catId: 'AG',
        eventId: 496,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(496) PTF-5H-RRBetAmountRiskedSeat4Hand1',
        value: '',
      } /**/,
      '142': {
        catId: 'AG',
        eventId: 497,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(497) PTF-5H-RRBetAmountRiskedSeat4Hand2',
        value: '',
      } /**/,
      '143': {
        catId: 'AG',
        eventId: 498,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(498) PTF-5H-RRBetAmountRiskedSeat5Hand1',
        value: '',
      } /**/,
      '144': {
        catId: 'AG',
        eventId: 499,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(499) PTF-5H-RRBetAmountRiskedSeat5Hand2',
        value: '',
      } /**/,

      doubleyes_gameType_privateFriend_gameHand_5_seat_1_seatHand_1: {
        catId: 'AG',
        eventId: 500,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(500) PTF-5H-DoubleDownBetAmountSeat1Hand1',
        value: '',
      },
      doubleyes_gameType_privateFriend_gameHand_5_seat_6_seatHand_2: {
        catId: 'AG',
        eventId: 501,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(501) PTF-5H-DoubleDownBetAmountSeat1Hand2',
        value: '',
      },
      doubleyes_gameType_privateFriend_gameHand_5_seat_2_seatHand_1: {
        catId: 'AG',
        eventId: 502,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(502) PTF-5H-DoubleDownBetAmountSeat2Hand1',
        value: '',
      },
      doubleyes_gameType_privateFriend_gameHand_5_seat_7_seatHand_2: {
        catId: 'AG',
        eventId: 503,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(503) PTF-5H-DoubleDownBetAmountSeat2Hand2',
        value: '',
      },
      doubleyes_gameType_privateFriend_gameHand_5_seat_3_seatHand_1: {
        catId: 'AG',
        eventId: 504,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(504) PTF-5H-DoubleDownBetAmountSeat3Hand1',
        value: '',
      },
      doubleyes_gameType_privateFriend_gameHand_5_seat_8_seatHand_2: {
        catId: 'AG',
        eventId: 505,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(505) PTF-5H-DoubleDownBetAmountSeat3Hand2',
        value: '',
      },
      doubleyes_gameType_privateFriend_gameHand_5_seat_4_seatHand_1: {
        catId: 'AG',
        eventId: 506,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(506) PTF-5H-DoubleDownBetAmountSeat4Hand1',
        value: '',
      },
      doubleyes_gameType_privateFriend_gameHand_5_seat_9_seatHand_2: {
        catId: 'AG',
        eventId: 507,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(507) PTF-5H-DoubleDownBetAmountSeat4Hand2',
        value: '',
      },
      doubleyes_gameType_privateFriend_gameHand_5_seat_5_seatHand_1: {
        catId: 'AG',
        eventId: 508,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(508) PTF-5H-DoubleDownBetAmountSeat5Hand1',
        value: '',
      },
      doubleyes_gameType_privateFriend_gameHand_5_seat_10_seatHand_2: {
        catId: 'AG',
        eventId: 509,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(509) PTF-5H-DoubleDownBetAmountSeat5Hand2',
        value: '',
      },

      betChip_s1h1_LC: {
        catId: 'AG',
        eventId: 510,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(510) LC-5H-BetAmountSeat1Hand1',
        value: '',
      },
      betChip_s1h2_LC: {
        catId: 'AG',
        eventId: 511,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(511) LC-5H-BetAmountSeat1Hand2',
        value: '',
      },
      betChip_s2h1_LC: {
        catId: 'AG',
        eventId: 512,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(512) LC-5H-BetAmountSeat2Hand1',
        value: '',
      },
      betChip_s2h2_LC: {
        catId: 'AG',
        eventId: 513,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(513) LC-5H-BetAmountSeat2Hand2',
        value: '',
      },
      betChip_s3h1_LC: {
        catId: 'AG',
        eventId: 514,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(514) LC-5H-BetAmountSeat3Hand1',
        value: '',
      },
      betChip_s3h2_LC: {
        catId: 'AG',
        eventId: 515,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(515) LC-5H-BetAmountSeat3Hand2',
        value: '',
      },
      betChip_s4h1_LC: {
        catId: 'AG',
        eventId: 516,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(516) LC-5H-BetAmountSeat4Hand1',
        value: '',
      },
      betChip_s4h2_LC: {
        catId: 'AG',
        eventId: 517,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(517) LC-5H-BetAmountSeat4Hand2',
        value: '',
      },
      betChip_s5h1_LC: {
        catId: 'AG',
        eventId: 518,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(518) LC-5H-BetAmountSeat5Hand1',
        value: '',
      },
      betChip_s5h2_LC: {
        catId: 'AG',
        eventId: 519,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(519) LC-5H-BetAmountSeat5Hand2',
        value: '',
      },

      insuranceBetChip_s1h1_LC: {
        catId: 'AG',
        eventId: 520,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(520) LC-5H-InsuranceBetAmountSeat1',
        value: '',
      } /**/,
      insuranceBetChip_s2h1_LC: {
        catId: 'AG',
        eventId: 521,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(521) LC-5H-InsuranceBetAmountSeat2',
        value: '',
      } /**/,
      insuranceBetChip_s3h1_LC: {
        catId: 'AG',
        eventId: 522,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(522) LC-5H-InsuranceBetAmountSeat3',
        value: '',
      } /**/,
      insuranceBetChip_s4h1_LC: {
        catId: 'AG',
        eventId: 523,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(523) LC-5H-InsuranceBetAmountSeat4',
        value: '',
      } /**/,
      insuranceBetChip_s5h1_LC: {
        catId: 'AG',
        eventId: 524,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(524) LC-5H-InsuranceBetAmountSeat5',
        value: '',
      } /**/,

      '170': {
        catId: 'AG',
        eventId: 525,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(525) LC-5H-RRBetAmountRiskedSeat1Hand1',
        value: '',
      },
      '171': {
        catId: 'AG',
        eventId: 526,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(526) LC-5H-RRBetAmountRiskedSeat1Hand2',
        value: '',
      },
      '172': {
        catId: 'AG',
        eventId: 527,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(527) LC-5H-RRBetAmountRiskedSeat2Hand1',
        value: '',
      },
      '173': {
        catId: 'AG',
        eventId: 528,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(528) LC-5H-RRBetAmountRiskedSeat2Hand2',
        value: '',
      },
      '174': {
        catId: 'AG',
        eventId: 529,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(529) LC-5H-RRBetAmountRiskedSeat3Hand1',
        value: '',
      },
      '175': {
        catId: 'AG',
        eventId: 530,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(530) LC-5H-RRBetAmountRiskedSeat3Hand2',
        value: '',
      },
      '176': {
        catId: 'AG',
        eventId: 531,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(531) LC-5H-RRBetAmountRiskedSeat4Hand1',
        value: '',
      },
      '177': {
        catId: 'AG',
        eventId: 532,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(532) LC-5H-RRBetAmountRiskedSeat4Hand2',
        value: '',
      },
      '178': {
        catId: 'AG',
        eventId: 533,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(533) LC-5H-RRBetAmountRiskedSeat5Hand1',
        value: '',
      },
      '179': {
        catId: 'AG',
        eventId: 534,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(534) LC-5H-RRBetAmountRiskedSeat5Hand2',
        value: '',
      },

      doubleyes_gameType_livecasino_gameHand_5_seat_1_seatHand_1: {
        catId: 'AG',
        eventId: 535,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(535) LC-5H-DoubleDownBetAmountSeat1Hand1',
        value: '',
      },
      doubleyes_gameType_livecasino_gameHand_5_seat_6_seatHand_2: {
        catId: 'AG',
        eventId: 536,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(536) LC-5H-DoubleDownBetAmountSeat1Hand2',
        value: '',
      },
      doubleyes_gameType_livecasino_gameHand_5_seat_2_seatHand_1: {
        catId: 'AG',
        eventId: 537,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(537) LC-5H-DoubleDownBetAmountSeat2Hand1',
        value: '',
      },
      doubleyes_gameType_livecasino_gameHand_5_seat_7_seatHand_2: {
        catId: 'AG',
        eventId: 538,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(538) LC-5H-DoubleDownBetAmountSeat2Hand2',
        value: '',
      },
      doubleyes_gameType_livecasino_gameHand_5_seat_3_seatHand_1: {
        catId: 'AG',
        eventId: 539,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(539) LC-5H-DoubleDownBetAmountSeat3Hand1',
        value: '',
      },
      doubleyes_gameType_livecasino_gameHand_5_seat_8_seatHand_2: {
        catId: 'AG',
        eventId: 540,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(540) LC-5H-DoubleDownBetAmountSeat3Hand2',
        value: '',
      },
      doubleyes_gameType_livecasino_gameHand_5_seat_4_seatHand_1: {
        catId: 'AG',
        eventId: 541,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(541) LC-5H-DoubleDownBetAmountSeat4Hand1',
        value: '',
      },
      doubleyes_gameType_livecasino_gameHand_5_seat_9_seatHand_2: {
        catId: 'AG',
        eventId: 542,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(542) LC-5H-DoubleDownBetAmountSeat4Hand2',
        value: '',
      },
      doubleyes_gameType_livecasino_gameHand_5_seat_5_seatHand_1: {
        catId: 'AG',
        eventId: 543,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(543) LC-5H-DoubleDownBetAmountSeat5Hand1',
        value: '',
      },
      doubleyes_gameType_livecasino_gameHand_5_seat_10_seatHand_2: {
        catId: 'AG',
        eventId: 544,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(544) LC-5H-DoubleDownBetAmountSeat5Hand2',
        value: '',
      },

      '190': {
        catId: 'AG',
        eventId: 545,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(545) LD-7H-BetAmountSeat1Hand1',
        value: '',
      } /**/,
      '191': {
        catId: 'AG',
        eventId: 546,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(546) LD-7H-BetAmountSeat1Hand2',
        value: '',
      } /**/,
      '192': {
        catId: 'AG',
        eventId: 547,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(547) LD-7H-BetAmountSeat2Hand1',
        value: '',
      } /**/,
      '193': {
        catId: 'AG',
        eventId: 548,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(548) LD-7H-BetAmountSeat2Hand2',
        value: '',
      } /**/,
      '194': {
        catId: 'AG',
        eventId: 549,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(549) LD-7H-BetAmountSeat3Hand1',
        value: '',
      } /**/,
      '195': {
        catId: 'AG',
        eventId: 550,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(550) LD-7H-BetAmountSeat3Hand2',
        value: '',
      } /**/,
      '196': {
        catId: 'AG',
        eventId: 551,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(551) LD-7H-BetAmountSeat4Hand1',
        value: '',
      } /**/,
      '197': {
        catId: 'AG',
        eventId: 552,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(552) LD-7H-BetAmountSeat4Hand2',
        value: '',
      } /**/,
      '198': {
        catId: 'AG',
        eventId: 553,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(553) LD-7H-BetAmountSeat5Hand1',
        value: '',
      } /**/,
      '199': {
        catId: 'AG',
        eventId: 554,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(554) LD-7H-BetAmountSeat5Hand2',
        value: '',
      } /**/,
      '200': {
        catId: 'AG',
        eventId: 555,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(555) LD-7H-BetAmountSeat6Hand1',
        value: '',
      } /**/,
      '201': {
        catId: 'AG',
        eventId: 556,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(556) LD-7H-BetAmountSeat6Hand2',
        value: '',
      } /**/,
      '202': {
        catId: 'AG',
        eventId: 557,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(557) LD-7H-BetAmountSeat7Hand1',
        value: '',
      } /**/,
      '203': {
        catId: 'AG',
        eventId: 558,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(558) LD-7H-BetAmountSeat7Hand2',
        value: '',
      } /**/,

      '204': {
        catId: 'AG',
        eventId: 559,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(559) LD-7H-InsuranceBetAmountSeat1',
        value: '',
      } /**/,
      '205': {
        catId: 'AG',
        eventId: 560,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(560) LD-7H-InsuranceBetAmountSeat2',
        value: '',
      } /**/,
      '206': {
        catId: 'AG',
        eventId: 561,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(561) LD-7H-InsuranceBetAmountSeat3',
        value: '',
      } /**/,
      '207': {
        catId: 'AG',
        eventId: 562,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(562) LD-7H-InsuranceBetAmountSeat4',
        value: '',
      } /**/,
      '208': {
        catId: 'AG',
        eventId: 563,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(563) LD-7H-InsuranceBetAmountSeat5',
        value: '',
      } /**/,
      '209': {
        catId: 'AG',
        eventId: 564,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(564) LD-7H-InsuranceBetAmountSeat6',
        value: '',
      } /**/,
      '210': {
        catId: 'AG',
        eventId: 565,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(565) LD-7H-InsuranceBetAmountSeat7',
        value: '',
      } /**/,

      '211': {
        catId: 'AG',
        eventId: 566,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(566) LD-7H-RRBetAmountRiskedSeat1Hand1',
        value: '',
      } /**/,
      '212': {
        catId: 'AG',
        eventId: 567,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(567) LD-7H-RRBetAmountRiskedSeat1Hand2',
        value: '',
      } /**/,
      '213': {
        catId: 'AG',
        eventId: 568,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(568) LD-7H-RRBetAmountRiskedSeat2Hand1',
        value: '',
      } /**/,
      '214': {
        catId: 'AG',
        eventId: 569,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(569) LD-7H-RRBetAmountRiskedSeat2Hand2',
        value: '',
      } /**/,
      '215': {
        catId: 'AG',
        eventId: 570,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(570) LD-7H-RRBetAmountRiskedSeat3Hand1',
        value: '',
      } /**/,
      '216': {
        catId: 'AG',
        eventId: 571,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(571) LD-7H-RRBetAmountRiskedSeat3Hand2',
        value: '',
      } /**/,
      '217': {
        catId: 'AG',
        eventId: 572,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(572) LD-7H-RRBetAmountRiskedSeat4Hand1',
        value: '',
      } /**/,
      '218': {
        catId: 'AG',
        eventId: 573,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(573) LD-7H-RRBetAmountRiskedSeat4Hand2',
        value: '',
      } /**/,
      '219': {
        catId: 'AG',
        eventId: 574,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(574) LD-7H-RRBetAmountRiskedSeat5Hand1',
        value: '',
      } /**/,
      '220': {
        catId: 'AG',
        eventId: 575,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(575) LD-7H-RRBetAmountRiskedSeat5Hand2',
        value: '',
      } /**/,
      '221': {
        catId: 'AG',
        eventId: 576,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(576) LD-7H-RRBetAmountRiskedSeat6Hand1',
        value: '',
      } /**/,
      '222': {
        catId: 'AG',
        eventId: 577,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(577) LD-7H-RRBetAmountRiskedSeat6Hand2',
        value: '',
      } /**/,
      '223': {
        catId: 'AG',
        eventId: 578,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(578) LD-7H-RRBetAmountRiskedSeat7Hand1',
        value: '',
      } /**/,
      '224': {
        catId: 'AG',
        eventId: 579,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(579) LD-7H-RRBetAmountRiskedSeat7Hand2',
        value: '',
      } /**/,

      doubleyes_gameType_liveDealer_gameHand_5_seat_1_seatHand_1: {
        catId: 'AG',
        eventId: 580,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(580) LD-7H-DoubleDownBetAmountSeat1Hand1',
        value: '',
      },
      doubleyes_gameType_liveDealer_gameHand_5_seat_1_seatHand_2: {
        catId: 'AG',
        eventId: 581,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(581) LD-7H-DoubleDownBetAmountSeat1Hand2',
        value: '',
      },
      doubleyes_gameType_liveDealer_gameHand_5_seat_2_seatHand_1: {
        catId: 'AG',
        eventId: 582,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(582) LD-7H-DoubleDownBetAmountSeat2Hand1',
        value: '',
      },
      doubleyes_gameType_liveDealer_gameHand_5_seat_2_seatHand_2: {
        catId: 'AG',
        eventId: 583,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(583) LD-7H-DoubleDownBetAmountSeat2Hand2',
        value: '',
      },
      doubleyes_gameType_liveDealer_gameHand_5_seat_3_seatHand_1: {
        catId: 'AG',
        eventId: 584,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(584) LD-7H-DoubleDownBetAmountSeat3Hand1',
        value: '',
      },
      doubleyes_gameType_liveDealer_gameHand_5_seat_3_seatHand_2: {
        catId: 'AG',
        eventId: 585,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(585) LD-7H-DoubleDownBetAmountSeat3Hand2',
        value: '',
      },
      doubleyes_gameType_liveDealer_gameHand_5_seat_4_seatHand_1: {
        catId: 'AG',
        eventId: 586,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(586) LD-7H-DoubleDownBetAmountSeat4Hand1',
        value: '',
      },
      doubleyes_gameType_liveDealer_gameHand_5_seat_4_seatHand_2: {
        catId: 'AG',
        eventId: 587,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(587) LD-7H-DoubleDownBetAmountSeat4Hand2',
        value: '',
      },
      doubleyes_gameType_liveDealer_gameHand_5_seat_5_seatHand_1: {
        catId: 'AG',
        eventId: 588,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(588) LD-7H-DoubleDownBetAmountSeat5Hand1',
        value: '',
      },
      doubleyes_gameType_liveDealer_gameHand_5_seat_5_seatHand_2: {
        catId: 'AG',
        eventId: 589,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(589) LD-7H-DoubleDownBetAmountSeat5Hand2',
        value: '',
      },
      doubleyes_gameType_liveDealer_gameHand_5_seat_6_seatHand_1: {
        catId: 'AG',
        eventId: 590,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(590) LD-7H-DoubleDownBetAmountSeat6Hand1',
        value: '',
      },
      doubleyes_gameType_liveDealer_gameHand_5_seat_6_seatHand_2: {
        catId: 'AG',
        eventId: 591,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(591) LD-7H-DoubleDownBetAmountSeat6Hand2',
        value: '',
      },
      doubleyes_gameType_liveDealer_gameHand_5_seat_7_seatHand_1: {
        catId: 'AG',
        eventId: 592,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(592) LD-7H-DoubleDownBetAmountSeat7Hand1',
        value: '',
      },
      doubleyes_gameType_liveDealer_gameHand_5_seat_7_seatHand_2: {
        catId: 'AG',
        eventId: 593,
        category: '(AG) FC21orNothing Game',
        eventAction: 'Click',
        Label: '(593) LD-7H-DoubleDownBetAmountSeat7Hand2',
        value: '',
      },
    };
  }

  public static get FULLCOLORBACCARATGAME() {
    return {
      changechips_selectedchip: {
        catId: 'AH',
        eventId: 594,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(594) ChangeChips - SelectedChip',
        value: '',
      },
      placebets: {
        catId: 'AH',
        eventId: 595,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(595) Place Your bet',
        value: '',
      },
      confirmbet: {
        catId: 'AH',
        eventId: 596,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(596) ConfirmBet',
        value: '',
      },
      clearbet: {
        catId: 'AH',
        eventId: 597,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(597) ClearBet',
        value: '',
      },
      maximumbet: {
        catId: 'AH',
        eventId: 598,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(598) MaximumBet',
        value: '',
      },
      minimumbet: {
        catId: 'AH',
        eventId: 599,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(599) MinimumBet',
        value: '',
      },
      betsuccess: {
        catId: 'AH',
        eventId: 600,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(600) Success',
        value: '',
      },
      betfailed: {
        catId: 'AH',
        eventId: 601,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(601) Bet Failed',
        value: '',
      },
      newbet: {
        catId: 'AH',
        eventId: 602,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(602) NewBet',
        value: '',
      },
      rebet: {
        catId: 'AH',
        eventId: 603,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(603) Rebet',
        value: '',
      },
      rebet2x: {
        catId: 'AH',
        eventId: 604,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(604) Rebet2X',
        value: '',
      },
      next: {
        catId: 'AH',
        eventId: 605,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(605) Next',
        value: '',
      },
      sidemap: {
        catId: 'AH',
        eventId: 606,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(606) SideBetsToggle',
        value: '',
      },
      sidemapplaybtn: {
        catId: 'AH',
        eventId: 606,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(606) SideBetsToggle',
        value: '',
      },
      mainmap: {
        catId: 'AH',
        eventId: 607,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(607) MainBetsToggle',
        value: '',
      },
      mainmapplaybtn: {
        catId: 'AH',
        eventId: 607,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(607) MainBetsToggle',
        value: '',
      },
      colorpalette: {
        catId: 'AH',
        eventId: 608,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(608) ColorPaletteToggle',
        value: '',
      },
      sidemapzoombtn: {
        catId: 'AH',
        eventId: 609,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(609) ZoomIn / ZoomOut',
        value: '',
      },
      mainmapzoombtn: {
        catId: 'AH',
        eventId: 609,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(609) ZoomIn / ZoomOut',
        value: '',
      },
      mainmaplinkbtn: {
        catId: 'AH',
        eventId: 610,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(610) MainBets - Link',
        value: '',
      },
      Main: {
        catId: 'AH',
        eventId: 611,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(611) Link - Main',
        value: '',
      },
      Slide: {
        catId: 'AH',
        eventId: 612,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(612) Link - Side',
        value: '',
      },
      '+/-': {
        catId: 'AH',
        eventId: 613,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(613) Link - PlusMinus',
        value: '',
      },
      '2/3': {
        catId: 'AH',
        eventId: 614,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(614) Link - TwoByThree',
        value: '',
      },
      Shuffles: {
        catId: 'AH',
        eventId: 615,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(615) Link - Shuffles',
        value: '',
      },
      Total: {
        catId: 'AH',
        eventId: 616,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(616) Link - Total',
        value: '',
      },
      selectedchip: {
        catId: 'AH',
        eventId: 617,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(617) SelectedChip',
        value: '',
      },
      changechips: {
        catId: 'AH',
        eventId: 618,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(618) ChangeChips',
        value: '',
      },
      helpinghands: {
        catId: 'AH',
        eventId: 619,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(619) HelpingHands',
        value: '',
      },
      info: {
        catId: 'AH',
        eventId: 620,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(620) Tutorials',
        value: '',
      },
      quicktips: {
        catId: 'AH',
        eventId: 621,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(621) QuickTips',
        value: '',
      },
      quickkeys: {
        catId: 'AH',
        eventId: 622,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(622) QuickKeys',
        value: '',
      },
      menu: {
        catId: 'AH',
        eventId: 623,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(623) Menu',
        value: '',
      },
      /*'draw': {catId: 'AH', eventId: 7, category: '(AH) FullColorBaccarat Game', eventAction: 'Click', Label: '() Draw', value: ''},
      'hints': {catId: 'AH', eventId: 7, category: '(AH) FullColorBaccarat Game', eventAction: 'Click', Label: '() Hints', value: ''},*/
      playerbetspot: {
        catId: 'AH',
        eventId: 624,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Bet',
        Label: '(624) PlayerBetSpot',
        value: '',
      },
      bankerbetspot: {
        catId: 'AH',
        eventId: 625,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Bet',
        Label: '(625) BankerBetSpot',
        value: '',
      },
      tiebetspot: {
        catId: 'AH',
        eventId: 626,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Bet',
        Label: '(626) TieBetSpot',
        value: '',
      },
      minustwobetspot: {
        catId: 'AH',
        eventId: 627,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Bet',
        Label: '(627) 2MinusBetSpot',
        value: '',
      },
      plustwobetspot: {
        catId: 'AH',
        eventId: 628,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Bet',
        Label: '(628) 2PlusBetSpot',
        value: '',
      },
      minusthreebetspot: {
        catId: 'AH',
        eventId: 629,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Bet',
        Label: '(629) 3MinusBetSpot',
        value: '',
      },
      plusthreebetspot: {
        catId: 'AH',
        eventId: 630,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Bet',
        Label: '(630) 3PlusBetSpot',
        value: '',
      },
      playerbetamount: {
        catId: 'AH',
        eventId: 631,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Bet',
        Label: '(631) PlayerBetAmount',
        value: '',
      },
      bankerbetamount: {
        catId: 'AH',
        eventId: 632,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Bet',
        Label: '(632) BankerBetAmount',
        value: '',
      },
      tiebetamount: {
        catId: 'AH',
        eventId: 633,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Bet',
        Label: '(633) TieBetAmount',
        value: '',
      },
      minustwobetamount: {
        catId: 'AH',
        eventId: 634,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Bet',
        Label: '(634) 2MinusBetAmount',
        value: '',
      },
      plustwobetamount: {
        catId: 'AH',
        eventId: 635,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Bet',
        Label: '(635) 2PlusBetAmount',
        value: '',
      },
      minusthreebetamount: {
        catId: 'AH',
        eventId: 636,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Bet',
        Label: '(636) 3MinusBetAmount',
        value: '',
      },
      plusthreebetamount: {
        catId: 'AH',
        eventId: 637,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Bet',
        Label: '(637) 3PlusBetAmount',
        value: '',
      },
      /*'keypress': {catId: 'AH', eventId: 7, category: '(AH) FullColorBaccarat Game', eventAction: 'Click', Label: '() KeyPress', value: ''},*/

      hint_1: {
        catId: 'AH',
        eventId: 638,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(638) BCHint-1-PlayerShows',
        value: '',
      },
      hint_2: {
        catId: 'AH',
        eventId: 639,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(639) BCHint-2-BankerHas',
        value: '',
      },
      hint_3: {
        catId: 'AH',
        eventId: 640,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(640) BCHint-3-AlwaysEndOn8-9',
        value: '',
      },
      hint_4: {
        catId: 'AH',
        eventId: 641,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(641) BCHint-4-AlwaysStandOn6-7',
        value: '',
      },
      hint_5: {
        catId: 'AH',
        eventId: 642,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(642) BCHint-5-AlwaysDrawOn0-5',
        value: '',
      },
      hint_6: {
        catId: 'AH',
        eventId: 643,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(643) BCHint-6-BankerWinsScoreRanksHigher',
        value: '',
      },
      hint_7: {
        catId: 'AH',
        eventId: 644,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(644) BCHint-7-WinningHandHasPlusScoreFromCards',
        value: '',
      },
      hint_8: {
        catId: 'AH',
        eventId: 645,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(645) BCHint-8-WinningHandHasMinusScoreFromCards',
        value: '',
      },
      hint_9: {
        catId: 'AH',
        eventId: 646,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(646) BCHint-9-2PlusSideBetWins-Pays1:1',
        value: '',
      },
      hint_10: {
        catId: 'AH',
        eventId: 647,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(647) BCHint-10-2MinusSideBetWins-Pays1:1',
        value: '',
      },
      hint_11: {
        catId: 'AH',
        eventId: 648,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(648) BCHint-11-3PlusSideBetWins-Pays3:1',
        value: '',
      },
      hint_12: {
        catId: 'AH',
        eventId: 649,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(649) BCHint-12-3MinusSideBetWins-Pays5:1',
        value: '',
      },
      hint_13: {
        catId: 'AH',
        eventId: 650,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(650) BCHint-13-TieSideBetWins-Pays6:1',
        value: '',
      },
      hint_14: {
        catId: 'AH',
        eventId: 651,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(651) BCHint-14-BankerStandsOnMinusScore',
        value: '',
      },
      hint_15: {
        catId: 'AH',
        eventId: 652,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(652) BCHint-15-TiesOnDeal',
        value: '',
      },
      hint_16: {
        catId: 'AH',
        eventId: 653,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(653) BCHint-16-TieBetWins-Player-BankerBetsPush',
        value: '',
      },
      hint_17: {
        catId: 'AH',
        eventId: 654,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(654) BCHint-17-Player-BankerHandTiedOn2Cards',
        value: '',
      },
      hint_18: {
        catId: 'AH',
        eventId: 655,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(655) BCHint-18-MinusScoreTriggersSpreadRule',
        value: '',
      },
      hint_19: {
        catId: 'AH',
        eventId: 656,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(656) BCHint-19-PlayerDraws',
        value: '',
      },
      hint_20: {
        catId: 'AH',
        eventId: 657,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(657) BCHint-20-BankerDraws',
        value: '',
      },
      hint_21: {
        catId: 'AH',
        eventId: 658,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(658) BCHint-21-PlayerWinsAsAnyMinusScoreBeatsAnyPlusScore',
        value: '',
      },
      hint_22: {
        catId: 'AH',
        eventId: 659,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(659) BCHint-22-BankerWinsAsAnyMinusScoreBeatsAnyPlusScore',
        value: '',
      },
      hint_23: {
        catId: 'AH',
        eventId: 660,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(660) BCHint-23-GameOverAsSpread',
        value: '',
      },
      hint_24: {
        catId: 'AH',
        eventId: 661,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(661) BCHint-24-SpreadBetweenHandScoreIsLessThanEqualTo11',
        value: '',
      },
      hint_25: {
        catId: 'AH',
        eventId: 662,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(662) BCHint-25-SpreadIsLessThanEqualTo11',
        value: '',
      },
      hint_26: {
        catId: 'AH',
        eventId: 663,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(663) BCHint-26-PlayerWinsRanksHigher',
        value: '',
      },
      hint_27: {
        catId: 'AH',
        eventId: 664,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(664) BCHint-27-TiesOnDraw',
        value: '',
      },
      hint_28: {
        catId: 'AH',
        eventId: 665,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(665) BCHint-28-PlayerBankerHandTiedOn2Cards',
        value: '',
      },
      hint_29: {
        catId: 'AH',
        eventId: 666,
        category: '(AH) FullColorBaccarat Game',
        eventAction: 'Click',
        Label: '(666) BCHint-29-PlayerBankerHandTiedOn3Cards',
        value: '',
      },
    };
  }

  public static get QUICKTIPSBUTTONPOPUPLIST() {
    return {
      '1': {
        catId: 'AI',
        eventId: 667,
        category: '(AI) HelpingHands-QTB',
        eventAction: 'Click',
        Label: '(667) QTB-01-PlaceYourBets',
        value: '',
      },
      '2': {
        catId: 'AI',
        eventId: 668,
        category: '(AI) HelpingHands-QTB',
        eventAction: 'Click',
        Label: '(668) QTB-02-ChangeChips',
        value: '',
      },
      '3': {
        catId: 'AI',
        eventId: 669,
        category: '(AI) HelpingHands-QTB',
        eventAction: 'Click',
        Label: '(669) QTB-03-Pick5',
        value: '',
      } /**/,
      '4': {
        catId: 'AI',
        eventId: 670,
        category: '(AI) HelpingHands-QTB',
        eventAction: 'Click',
        Label: '(670) QTB-04-Pick6',
        value: '',
      } /**/,
      '5': {
        catId: 'AI',
        eventId: 671,
        category: '(AI) HelpingHands-QTB',
        eventAction: 'Click',
        Label: '(671) QTB-05-Clear',
        value: '',
      },
      '6': {
        catId: 'AI',
        eventId: 672,
        category: '(AI) HelpingHands-QTB',
        eventAction: 'Click',
        Label: '(672) QTB-06-Confirm',
        value: '',
      },
      '7': {
        catId: 'AI',
        eventId: 673,
        category: '(AI) HelpingHands-QTB',
        eventAction: 'Click',
        Label: '(673) QTB-07-Stand',
        value: '',
      },
      '8': {
        catId: 'AI',
        eventId: 674,
        category: '(AI) HelpingHands-QTB',
        eventAction: 'Click',
        Label: '(674) QTB-08-Hit',
        value: '',
      },
      '9': {
        catId: 'AI',
        eventId: 675,
        category: '(AI) HelpingHands-QTB',
        eventAction: 'Click',
        Label: '(675) QTB-09-DoubleDown',
        value: '',
      },
      '10': {
        catId: 'AI',
        eventId: 676,
        category: '(AI) HelpingHands-QTB',
        eventAction: 'Click',
        Label: '(676) QTB-10-NewBet',
        value: '',
      },
      '11': {
        catId: 'AI',
        eventId: 677,
        category: '(AI) HelpingHands-QTB',
        eventAction: 'Click',
        Label: '(677) QTB-11-Rebet',
        value: '',
      },
      '12': {
        catId: 'AI',
        eventId: 678,
        category: '(AI) HelpingHands-QTB',
        eventAction: 'Click',
        Label: '(678) QTB-12-Rebet2x',
        value: '',
      },
      '13': {
        catId: 'AI',
        eventId: 679,
        category: '(AI) HelpingHands-QTB',
        eventAction: 'Click',
        Label: '(679) QTB-13-Yes-Insurance',
        value: '',
      },
      '14': {
        catId: 'AI',
        eventId: 680,
        category: '(AI) HelpingHands-QTB',
        eventAction: 'Click',
        Label: '(680) QTB-14-YesToAll',
        value: '',
      },
      '15': {
        catId: 'AI',
        eventId: 681,
        category: '(AI) HelpingHands-QTB',
        eventAction: 'Click',
        Label: '(681) QTB-15-No-Insurance',
        value: '',
      },
      '16': {
        catId: 'AI',
        eventId: 682,
        category: '(AI) HelpingHands-QTB',
        eventAction: 'Click',
        Label: '(682) QTB-16-NoToYes',
        value: '',
      },
      '17': {
        catId: 'AI',
        eventId: 683,
        category: '(AI) HelpingHands-QTB',
        eventAction: 'Click',
        Label: '(683) QTB-17-RussianRoulette™',
        value: '',
      },
      '18': {
        catId: 'AI',
        eventId: 684,
        category: '(AI) HelpingHands-QTB',
        eventAction: 'Click',
        Label: '(684) QTB-18-Yes',
        value: '',
      },
      '19': {
        catId: 'AI',
        eventId: 685,
        category: '(AI) HelpingHands-QTB',
        eventAction: 'Click',
        Label: '(685) QTB-19-No',
        value: '',
      },
      '20': {
        catId: 'AI',
        eventId: 686,
        category: '(AI) HelpingHands-QTB',
        eventAction: 'Click',
        Label: '(686) QTB-20-SplitYourHand',
        value: '',
      },
      '21': {
        catId: 'AI',
        eventId: 687,
        category: '(AI) HelpingHands-QTB',
        eventAction: 'Click',
        Label: '(687) QTB-21-WaitingForOtherPlayers',
        value: '',
      } /**/,
      '22': {
        catId: 'AI',
        eventId: 688,
        category: '(AI) HelpingHands-QTB',
        eventAction: 'Click',
        Label: '(688) QTB-22-GameOver',
        value: '',
      },
      '22a': {
        catId: 'AI',
        eventId: 689,
        category: '(AI) HelpingHands-QTB',
        eventAction: 'Click',
        Label: '(689) QTB-23-ObservationMode',
        value: '',
      },
    };
  }

  public static get QUICKSTIPSDETAILSPOPUPLIST() {
    return {
      '23': {
        catId: 'AJ',
        eventId: 690,
        category: '(AJ) HelpingHands-QTD',
        eventAction: 'Click',
        Label: '(690) QTD-01-CurrentUTC',
        value: '',
      },
      '24': {
        catId: 'AJ',
        eventId: 691,
        category: '(AJ) HelpingHands-QTD',
        eventAction: 'Click',
        Label: '(691) QTD-02-GameID',
        value: '',
      },
      '25': {
        catId: 'AJ',
        eventId: 692,
        category: '(AJ) HelpingHands-QTD',
        eventAction: 'Click',
        Label: '(692) QTD-03-MinimumBet',
        value: '',
      },
      '26': {
        catId: 'AJ',
        eventId: 693,
        category: '(AJ) HelpingHands-QTD',
        eventAction: 'Click',
        Label: '(693) QTD-04-MaximumBet',
        value: '',
      },
      '27': {
        catId: 'AJ',
        eventId: 694,
        category: '(AJ) HelpingHands-QTD',
        eventAction: 'Click',
        Label: '(694) QTD-05-TotalBet',
        value: '',
      },
      '28': {
        catId: 'AJ',
        eventId: 695,
        category: '(AJ) HelpingHands-QTD',
        eventAction: 'Click',
        Label: '(695) QTD-06-ReturntoPlayer',
        value: '',
      },
      '29': {
        catId: 'AJ',
        eventId: 696,
        category: '(AJ) HelpingHands-QTD',
        eventAction: 'Click',
        Label: '(696) QTD-07-BankBalance',
        value: '',
      },
      '30': {
        catId: 'AJ',
        eventId: 697,
        category: '(AJ) HelpingHands-QTD',
        eventAction: 'Click',
        Label: '(697) QTD-08-SlidingToolBar',
        value: '',
      },
      '31': {
        catId: 'AJ',
        eventId: 698,
        category: '(AJ) HelpingHands-QTD',
        eventAction: 'Click',
        Label: '(698) QTD-09-ChangeChips',
        value: '',
      },
      '32': {
        catId: 'AJ',
        eventId: 699,
        category: '(AJ) HelpingHands-QTD',
        eventAction: 'Click',
        Label: '(699) QTD-10-Tutorials',
        value: '',
      },
      '33': {
        catId: 'AJ',
        eventId: 700,
        category: '(AJ) HelpingHands-QTD',
        eventAction: 'Click',
        Label: '(700) QTD-11-HelpingHand',
        value: '',
      },
      '34': {
        catId: 'AJ',
        eventId: 701,
        category: '(AJ) HelpingHands-QTD',
        eventAction: 'Click',
        Label: '(701) QTD-12-QuickTips',
        value: '',
      },
      '35': {
        catId: 'AJ',
        eventId: 702,
        category: '(AJ) HelpingHands-QTD',
        eventAction: 'Click',
        Label: '(702) QTD-13-QuickKeys',
        value: '',
      },
      '36': {
        catId: 'AJ',
        eventId: 703,
        category: '(AJ) HelpingHands-QTD',
        eventAction: 'Click',
        Label: '(703) QTD-14-Chip1',
        value: '',
      },
      '37': {
        catId: 'AJ',
        eventId: 704,
        category: '(AJ) HelpingHands-QTD',
        eventAction: 'Click',
        Label: '(704) QTD-15-Chip2',
        value: '',
      },
      '38': {
        catId: 'AJ',
        eventId: 705,
        category: '(AJ) HelpingHands-QTD',
        eventAction: 'Click',
        Label: '(705) QTD-16-Chip3',
        value: '',
      },
      '39': {
        catId: 'AJ',
        eventId: 706,
        category: '(AJ) HelpingHands-QTD',
        eventAction: 'Click',
        Label: '(706) QTD-17-Chip4',
        value: '',
      },
      '40': {
        catId: 'AJ',
        eventId: 707,
        category: '(AJ) HelpingHands-QTD',
        eventAction: 'Click',
        Label: '(707) QTD-18-Chip5',
        value: '',
      },
      '41': {
        catId: 'AJ',
        eventId: 708,
        category: '(AJ) HelpingHands-QTD',
        eventAction: 'Click',
        Label: '(708) QTD-19-Chip6',
        value: '',
      },
      '42': {
        catId: 'AJ',
        eventId: 709,
        category: '(AJ) HelpingHands-QTD',
        eventAction: 'Click',
        Label: '(709) QTD-20-BetSpot',
        value: '',
      },
      '43': {
        catId: 'AJ',
        eventId: 710,
        category: '(AJ) HelpingHands-QTD',
        eventAction: 'Click',
        Label: '(710) QTD-21-PlaceYourBets-Tutorial_06_StartAGame',
        value: '',
      },
      '44': {
        catId: 'AJ',
        eventId: 711,
        category: '(AJ) HelpingHands-QTD',
        eventAction: 'Click',
        Label: '(711) QTD-22-Shoe-Tutorial_01_Introduction',
        value: '',
      },
      '45': {
        catId: 'AJ',
        eventId: 712,
        category: '(AJ) HelpingHands-QTD',
        eventAction: 'Click',
        Label: '(712) QTD-23-PlaceYourBets-Tutorial_02_Scores',
        value: '',
      },
      '46': {
        catId: 'AJ',
        eventId: 713,
        category: '(AJ) HelpingHands-QTD',
        eventAction: 'Click',
        Label: '(713) QTD-24-FC21Logo-Tutorial_03_GameAction',
        value: '',
      },
      '47': {
        catId: 'AJ',
        eventId: 714,
        category: '(AJ) HelpingHands-QTD',
        eventAction: 'Click',
        Label: '(714) QTD-25-TopRuleBar-Tutorial_04_GameRules',
        value: '',
      },
      '48': {
        catId: 'AJ',
        eventId: 715,
        category: '(AJ) HelpingHands-QTD',
        eventAction: 'Click',
        Label: '(715) QTD-26-TopRuleBar-Tutorial_05_Soft17',
        value: '',
      },
      '49': {
        catId: 'AJ',
        eventId: 716,
        category: '(AJ) HelpingHands-QTD',
        eventAction: 'Click',
        Label: '(716) QTD-27-DealerChasesNZ-Tutorial_06_StartAGame',
        value: '',
      },
      '50': {
        catId: 'AJ',
        eventId: 717,
        category: '(AJ) HelpingHands-QTD',
        eventAction: 'Click',
        Label: '(717) QTD-28-BottomRuleBar-Tutorial_07_NaturalHands',
        value: '',
      },
      '51': {
        catId: 'AJ',
        eventId: 718,
        category: '(AJ) HelpingHands-QTD',
        eventAction: 'Click',
        Label: '(718) QTD-29-BottomRuleBar-Tutorial_08_SNWins',
        value: '',
      },
      '52': {
        catId: 'AJ',
        eventId: 719,
        category: '(AJ) HelpingHands-QTD',
        eventAction: 'Click',
        Label: '(719) QTD-30-BottomRuleBar-Tutorial_09_N21Wins',
        value: '',
      },
      '53': {
        catId: 'AJ',
        eventId: 720,
        category: '(AJ) HelpingHands-QTD',
        eventAction: 'Click',
        Label: '(720) QTD-31-BottomRuleBar-Tutorial_10_DNWins',
        value: '',
      },
      '54': {
        catId: 'AJ',
        eventId: 721,
        category: '(AJ) HelpingHands-QTD',
        eventAction: 'Click',
        Label: '(721) QTD-32-BottomRuleBar-Tutorial_11_NZWins',
        value: '',
      },
      '55': {
        catId: 'AJ',
        eventId: 722,
        category: '(AJ) HelpingHands-QTD',
        eventAction: 'Click',
        Label: '(722) QTD-33-TopRuleBar-Tutorial_12_BustOver22',
        value: '',
      },
      '56': {
        catId: 'AJ',
        eventId: 723,
        category: '(AJ) HelpingHands-QTD',
        eventAction: 'Click',
        Label: '(723) QTD-34-BottomRuleBar-Tutorial_13_Splits',
        value: '',
      },
      '57': {
        catId: 'AJ',
        eventId: 724,
        category: '(AJ) HelpingHands-QTD',
        eventAction: 'Click',
        Label: '(724) QTD-35-BottomRuleBar-Tutorial_14_ImpossibleSplits',
        value: '',
      },
      '58': {
        catId: 'AJ',
        eventId: 725,
        category: '(AJ) HelpingHands-QTD',
        eventAction: 'Click',
        Label: '(725) QTD-36-BottomRuleBar-Tutorial_15_DoubleDown',
        value: '',
      },
      '59': {
        catId: 'AJ',
        eventId: 726,
        category: '(AJ) HelpingHands-QTD',
        eventAction: 'Click',
        Label: '(726) QTD-37-BottomRuleBar-Tutorial_16_ColorInsurance',
        value: '',
      },
      '60': {
        catId: 'AJ',
        eventId: 727,
        category: '(AJ) HelpingHands-QTD',
        eventAction: 'Click',
        Label: '(727) QTD-38-BottomRuleBar-Tutorial_17_WhiteInsurance',
        value: '',
      },
      '61': {
        catId: 'AJ',
        eventId: 728,
        category: '(AJ) HelpingHands-QTD',
        eventAction: 'Click',
        Label: '(728) QTD-39-PeekerRed',
        value: '',
      },
      '62': {
        catId: 'AJ',
        eventId: 729,
        category: '(AJ) HelpingHands-QTD',
        eventAction: 'Click',
        Label: '(729) QTD-40-PeekerGreen',
        value: '',
      },
      '63': {
        catId: 'AJ',
        eventId: 730,
        category: '(AJ) HelpingHands-QTD',
        eventAction: 'Click',
        Label: '(730) QTD-41-ColorCardInsuranceAlertBoxes',
        value: '',
      } /**/,
      '64': {
        catId: 'AJ',
        eventId: 731,
        category: '(AJ) HelpingHands-QTD',
        eventAction: 'Click',
        Label: '(731) QTD-42-WhiteCardInsuranceAlertBoxes',
        value: '',
      } /**/,
      '65': {
        catId: 'AJ',
        eventId: 732,
        category: '(AJ) HelpingHands-QTD',
        eventAction: 'Click',
        Label: '(732) QTD-43-RussianRouletteAlertBoxes',
        value: '',
      } /**/,
    };
  }

  public static get QUICKTIPSEVENTSPOPUPLIST() {
    return {
      '1': {
        catId: 'AK',
        eventId: 733,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(733) QTE-01-FirstTimeEventsHelper',
        value: '',
      },
      '2': {
        catId: 'AK',
        eventId: 734,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(734) QTE-02-On1stGameEntry',
        value: '',
      } /**/,
      '3': {
        catId: 'AK',
        eventId: 735,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(735) QTE-03-Before1stBet-UpDownAction',
        value: '',
      } /**/,
      '4': {
        catId: 'AK',
        eventId: 736,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(736) QTE-04-Before1stDeal-Win2Ways',
        value: '',
      } /**/,
      '5': {
        catId: 'AK',
        eventId: 737,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(737) QTE-05-Before1stDeal-GameRules',
        value: '',
      } /**/,
      '6': {
        catId: 'AK',
        eventId: 738,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(738) QTE-06-Before1stDeal-StartaGame',
        value: '',
      } /**/,
      '7': {
        catId: 'AK',
        eventId: 739,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(739) QTE-07-FinishedPlaynow',
        value: '',
      },
      '71': {
        catId: 'AK',
        eventId: 740,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(740) QTE-08-HelpingHand-OnOff',
        value: '',
      },
      '72': {
        catId: 'AK',
        eventId: 741,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(741) QTE-09-GameStatus',
        value: '',
      },
      '73': {
        catId: 'AK',
        eventId: 742,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(742) QTE-10-After1stHandScore-showhandrankingchart',
        value: '',
      },
      '74': {
        catId: 'AK',
        eventId: 743,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(743) QTE-11-After1stDrawZero™-PlayerorDealer',
        value: '',
      },
      '75': {
        catId: 'AK',
        eventId: 744,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(744) QTE-12-ExpandthePlayersCurrentCards',
        value: '',
      },
      '76': {
        catId: 'AK',
        eventId: 745,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(745) QTE-13-ExpandtheDealersCurrentCards',
        value: '',
      },
      '77': {
        catId: 'AK',
        eventId: 746,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(746) QTE-14-On1stSoft17byDealer',
        value: '',
      },
      '78': {
        catId: 'AK',
        eventId: 747,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(747) QTE-15-OnDealers1stNaturalZero',
        value: '',
      },
      '79': {
        catId: 'AK',
        eventId: 748,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(748) QTE-16-On1stPlayerNaturalZeroDealer-Chase',
        value: '',
      },
      '80': {
        catId: 'AK',
        eventId: 749,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(749) QTE-17-On1stPlayersSuperNatural',
        value: '',
      },
      '81': {
        catId: 'AK',
        eventId: 750,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(750) QTE-18-On1stPlayersNatural21',
        value: '',
      },
      '82': {
        catId: 'AK',
        eventId: 751,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(751) QTE-19-On1stPlayersDoubleNatural™',
        value: '',
      },
      '83': {
        catId: 'AK',
        eventId: 752,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(752) QTE-20-On1stPlayersNaturalZero-NoChase',
        value: '',
      },
      '84': {
        catId: 'AK',
        eventId: 753,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(753) QTE-21-On1stBust',
        value: '',
      },
      '85': {
        catId: 'AK',
        eventId: 754,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(754) QTE-22-On1stDisplayof1stEligibleSplits',
        value: '',
      },
      '86': {
        catId: 'AK',
        eventId: 755,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(755) QTE-23-After1stEligibleSplitOccurs',
        value: '',
      },
      '87': {
        catId: 'AK',
        eventId: 756,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(756) QTE-24-On1stIneligibleSplits',
        value: '',
      },
      '88': {
        catId: 'AK',
        eventId: 757,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(757) QTE-25-On1stImpossibleSplitNZ',
        value: '',
      },
      '89': {
        catId: 'AK',
        eventId: 758,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(758) QTE-26-On1stImpossibleSplitDN',
        value: '',
      },
      '90': {
        catId: 'AK',
        eventId: 759,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(759) QTE-27-On1stImpossibleSplitSN',
        value: '',
      },
      '91': {
        catId: 'AK',
        eventId: 760,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(760) QTE-28-On1stDisplayofDoubleDownButton',
        value: '',
      },
      '92': {
        catId: 'AK',
        eventId: 761,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(761) QTE-29-After1stDoubleDownOccursonaWin',
        value: '',
      },
      '93': {
        catId: 'AK',
        eventId: 762,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(762) QTE-30-On1stColorCardInsurance-BetBarAlerts',
        value: '',
      },
      '94': {
        catId: 'AK',
        eventId: 763,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(763) QTE-31-On1stColorCardInsurance-GradientBar-Lose',
        value: '',
      },
      '95': {
        catId: 'AK',
        eventId: 764,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(764) QTE-32-After1stColorInsuranceWin',
        value: '',
      },
      '96': {
        catId: 'AK',
        eventId: 765,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(765) QTE-33-On1stWhiteCardInsurance-BetBarAlerts',
        value: '',
      },
      '97': {
        catId: 'AK',
        eventId: 766,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(766) QTE-34-On1stWhiteCardInsurance-GradientBar-Lose',
        value: '',
      },
      '98': {
        catId: 'AK',
        eventId: 767,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(767) QTE-35-After1stWhiteInsuranceWin',
        value: '',
      },
      '99': {
        catId: 'AK',
        eventId: 768,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(768) QTE-36-On1stRussianRoulette17-BetBarAlertBoxes',
        value: '',
      },
      '100': {
        catId: 'AK',
        eventId: 769,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(769) QTE-37-On1stRussianRoulette17-Gradient',
        value: '',
      },
      '101': {
        catId: 'AK',
        eventId: 770,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(770) QTE-38-After1stRussianRoulette17Win',
        value: '',
      },
      '102': {
        catId: 'AK',
        eventId: 771,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(771) QTE-39-On1stRussianRoulette18-BetBarAlertBoxes',
        value: '',
      },
      '103': {
        catId: 'AK',
        eventId: 772,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(772) QTE-40-On1stRussianRoulette18-Gradient',
        value: '',
      },
      '104': {
        catId: 'AK',
        eventId: 773,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(773) QTE-41-After1stRussianRoulette18Win',
        value: '',
      },
      '105': {
        catId: 'AK',
        eventId: 774,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(774) QTE-42-On1stRussianRoulette19BetBarAlertBoxes',
        value: '',
      },
      '106': {
        catId: 'AK',
        eventId: 775,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(775) QTE-43-On1stRussianRoulette19Gradient',
        value: '',
      },
      '107': {
        catId: 'AK',
        eventId: 776,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(776) QTE-44-After1stRussianRoulette19Win',
        value: '',
      },
      '108': {
        catId: 'AK',
        eventId: 777,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(777) QTE-45-On1stRussianRoulette20-BetBarAlertBoxes',
        value: '',
      },
      '109': {
        catId: 'AK',
        eventId: 778,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(778) QTE-46-On1stRussianRoulette20-Gradient',
        value: '',
      },
      '110': {
        catId: 'AK',
        eventId: 779,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(779) QTE-47-After1stRussianRoulette20Win',
        value: '',
      },
      '111': {
        catId: 'AK',
        eventId: 780,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(780) QTE-48-After1stHand≥6Cards-ExpandPlayerHand',
        value: '',
      },
      '112': {
        catId: 'AK',
        eventId: 781,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(781) QTE-49-After1stHand≥6-ExpandDealerHands',
        value: '',
      },
      '113': {
        catId: 'AK',
        eventId: 782,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(782) QTE-50-After1stDrawZero-WhatisaNothing',
        value: '',
      },
      '114': {
        catId: 'AK',
        eventId: 783,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(783) QTE-51-After1stDealerScore-HandRanks',
        value: '',
      },
      '115': {
        catId: 'AK',
        eventId: 784,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(784) QTE-52-After1stPlayersNZ-DealersDrawZero',
        value: '',
      },
      '116': {
        catId: 'AK',
        eventId: 785,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(785) QTE-53-After1stPlayersNZ-DealersD21',
        value: '',
      },
      '117': {
        catId: 'AK',
        eventId: 786,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(786) QTE-54-After1stAnyD21AnyD21',
        value: '',
      },
      '118': {
        catId: 'AK',
        eventId: 787,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(787) QTE-55-After1stAnyNZ',
        value: '',
      },
      '119': {
        catId: 'AK',
        eventId: 788,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(788) QTE-56-AfterDealers1stSN',
        value: '',
      },
      '120': {
        catId: 'AK',
        eventId: 789,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(789) QTE-57-AfterDealers1stN21',
        value: '',
      },
      '121': {
        catId: 'AK',
        eventId: 790,
        category: '(AK) HelpingHands-QTE',
        eventAction: 'Click',
        Label: '(790) QTE-58-AfterDealers1stDN',
        value: '',
      },
    };
  }

  public static get QUICKKEYS() {
    return {
      arrowleft: {
        catId: 'AL',
        eventId: 791,
        category: '(AL) QuickKeys',
        eventAction: 'Click',
        Label: '(791) QK-01-BetSpotNavigation-leftarrow',
        value: '',
      },
      arrowright: {
        catId: 'AL',
        eventId: 792,
        category: '(AL) QuickKeys',
        eventAction: 'Click',
        Label: '(792) QK-02-BetSpotNavigation-rightarrow',
        value: '',
      },
      '1': {
        catId: 'AL',
        eventId: 793,
        category: '(AL) QuickKeys',
        eventAction: 'Click',
        Label: '(793) QK-03-Selectchip1andplacebet',
        value: '',
      },
      '2': {
        catId: 'AL',
        eventId: 794,
        category: '(AL) QuickKeys',
        eventAction: 'Click',
        Label: '(794) QK-04-Selectchip2andplacebet',
        value: '',
      },
      '3': {
        catId: 'AL',
        eventId: 795,
        category: '(AL) QuickKeys',
        eventAction: 'Click',
        Label: '(795) QK-05-Selectchip3andplacebet',
        value: '',
      },
      '4': {
        catId: 'AL',
        eventId: 796,
        category: '(AL) QuickKeys',
        eventAction: 'Click',
        Label: '(796) QK-06-Selectchip4andplacebet',
        value: '',
      },
      '5': {
        catId: 'AL',
        eventId: 797,
        category: '(AL) QuickKeys',
        eventAction: 'Click',
        Label: '(797) QK-07-Selectchip5andplacebet',
        value: '',
      },
      '6': {
        catId: 'AL',
        eventId: 798,
        category: '(AL) QuickKeys',
        eventAction: 'Click',
        Label: '(798) QK-08-Selectchip6andplacebet',
        value: '',
      },
      '7': {
        catId: 'AL',
        eventId: 799,
        category: '(AL) QuickKeys',
        eventAction: 'Click',
        Label: '(799) QK-09-ChangeChips',
        value: '',
      },
      '8': {
        catId: 'AL',
        eventId: 800,
        category: '(AL) QuickKeys',
        eventAction: 'Click',
        Label: '(800) QK-10-ExpandDealersCards',
        value: '',
      },
      '9': {
        catId: 'AL',
        eventId: 801,
        category: '(AL) QuickKeys',
        eventAction: 'Click',
        Label: '(801) QK-11-TurnInstantDealOnSettings',
        value: '',
      },
      '0': {
        catId: 'AL',
        eventId: 802,
        category: '(AL) QuickKeys',
        eventAction: 'Click',
        Label: '(802) QK-12-OpensQuickKeysDialogueBox',
        value: '',
      },
      h: {
        catId: 'AL',
        eventId: 803,
        category: '(AL) QuickKeys',
        eventAction: 'Click',
        Label: '(803) QK-13-History',
        value: '',
      },
      i: {
        catId: 'AL',
        eventId: 804,
        category: '(AL) QuickKeys',
        eventAction: 'Click',
        Label: '(804) QK-14-Tutorials',
        value: '',
      },
      '`': {
        catId: 'AL',
        eventId: 805,
        category: '(AL) QuickKeys',
        eventAction: 'Click',
        Label: '(805) QK-15-QuickTipsOnOff-tildesign',
        value: '',
      },
      '=': {
        catId: 'AL',
        eventId: 806,
        category: '(AL) QuickKeys',
        eventAction: 'Click',
        Label: '(806) QK-16-LanguagesOnOff-Equalssign',
        value: '',
      },
      s: {
        catId: 'AL',
        eventId: 807,
        category: '(AL) QuickKeys',
        eventAction: 'Click',
        Label: '(807) QK-17-Stand',
        value: '',
      },
      d: {
        catId: 'AL',
        eventId: 808,
        category: '(AL) QuickKeys',
        eventAction: 'Click',
        Label: '(808) QK-18-DoubleDown',
        value: '',
      },
      r: {
        catId: 'AL',
        eventId: 809,
        category: '(AL) QuickKeys',
        eventAction: 'Click',
        Label: '(809) QK-19-Rebet2',
        value: '',
      },
      c: {
        catId: 'AL',
        eventId: 810,
        category: '(AL) QuickKeys',
        eventAction: 'Click',
        Label: '(810) QK-20-Clear',
        value: '',
      },
      y: {
        catId: 'AL',
        eventId: 811,
        category: '(AL) QuickKeys',
        eventAction: 'Click',
        Label: '(811) QK-21-Yes',
        value: '',
      },
      n: {
        catId: 'AL',
        eventId: 812,
        category: '(AL) QuickKeys',
        eventAction: 'Click',
        Label: '(812) QK-22-No',
        value: '',
      },
      x: {
        catId: 'AL',
        eventId: 813,
        category: '(AL) QuickKeys',
        eventAction: 'Click',
        Label: '(813) QK-23-Notoall',
        value: '',
      },
      escape: {
        catId: 'AL',
        eventId: 814,
        category: '(AL) QuickKeys',
        eventAction: 'Click',
        Label: '(814) QK-24-Close-esckey',
        value: '',
      },
      confirmbet: {
        catId: 'AL',
        eventId: 815,
        category: '(AL) QuickKeys',
        eventAction: 'Click',
        Label: '(815) QK-25-Confirm-spacebar',
        value: '',
      },
      hitrebet: {
        catId: 'AL',
        eventId: 816,
        category: '(AL) QuickKeys',
        eventAction: 'Click',
        Label: '(816) QK-26-HitRebet-spacebar',
        value: '',
      },
      russianroulette: {
        catId: 'AL',
        eventId: 817,
        category: '(AL) QuickKeys',
        eventAction: 'Click',
        Label: '(817) QK-27-RussianRoulette-spacebar',
        value: '',
      },
      splithand: {
        catId: 'AL',
        eventId: 818,
        category: '(AL) QuickKeys',
        eventAction: 'Click',
        Label: '(818) QK-28-Split-spacebar',
        value: '',
      },
      e: {
        catId: 'AL',
        eventId: 819,
        category: '(AL) QuickKeys',
        eventAction: 'Click',
        Label: '(819) QK-29-ExpandCards',
        value: '',
      },
      g: {
        catId: 'AL',
        eventId: 820,
        category: '(AL) QuickKeys',
        eventAction: 'Click',
        Label: '(820) QK-30-Settings',
        value: '',
      },
      '31': {
        catId: 'AL',
        eventId: 821,
        category: '(AL) QuickKeys',
        eventAction: 'Click',
        Label: '(821) QK-31-HelpingHand-dashsign',
        value: '',
      } /**/,
    };
  }

  public static get QUICKSTARTPOPUPLIST() {
    return {
      '0': {
        catId: 'AM',
        eventId: 822,
        category: '(AM) QuickStart',
        eventAction: 'Click',
        Label: '(822) QS-01-Welcome',
        value: '',
      },
      '1': {
        catId: 'AM',
        eventId: 823,
        category: '(AM) QuickStart',
        eventAction: 'Click',
        Label: '(823) QS-02-MenuBar',
        value: '',
      },
      menu: {
        catId: 'AM',
        eventId: 824,
        category: '(AM) QuickStart',
        eventAction: 'Click',
        Label: '(824) QS-03-MenuFlyout',
        value: '',
      },
      'MenuFlyout-PreviousNext': {
        catId: 'AM',
        eventId: 825,
        category: '(AM) QuickStart',
        eventAction: 'Click',
        Label: '(825) QS-04-MenuFlyout-PreviousNext',
        value: '',
      },
      SlidingToolBar: {
        catId: 'AM',
        eventId: 826,
        category: '(AM) QuickStart',
        eventAction: 'Click',
        Label: '(826) QS-05-SlidingToolBar',
        value: '',
      },
      'SlidingToolBar-Arrows': {
        catId: 'AM',
        eventId: 827,
        category: '(AM) QuickStart',
        eventAction: 'Click',
        Label: '(827) QS-06-SlidingToolBar-Arrows',
        value: '',
      },
      '4': {
        catId: 'AM',
        eventId: 828,
        category: '(AM) QuickStart',
        eventAction: 'Click',
        Label: '(828) QS-07-FeaturesFunctions',
        value: '',
      },
      '5': {
        catId: 'AM',
        eventId: 829,
        category: '(AM) QuickStart',
        eventAction: 'Click',
        Label: '(829) QS-08-ChangeChips',
        value: '',
      },
      '6': {
        catId: 'AM',
        eventId: 830,
        category: '(AM) QuickStart',
        eventAction: 'Click',
        Label: '(830) QS-09-Tutorials',
        value: '',
      },
      '7': {
        catId: 'AM',
        eventId: 831,
        category: '(AM) QuickStart',
        eventAction: 'Click',
        Label: '(831) QS-10-HelpingHand',
        value: '',
      },
      '8': {
        catId: 'AM',
        eventId: 832,
        category: '(AM) QuickStart',
        eventAction: 'Click',
        Label: '(832) QS-11-QuickTips',
        value: '',
      },
      '9': {
        catId: 'AM',
        eventId: 833,
        category: '(AM) QuickStart',
        eventAction: 'Click',
        Label: '(833) QS-12-QuickKeys',
        value: '',
      },
      '10': {
        catId: 'AM',
        eventId: 834,
        category: '(AM) QuickStart',
        eventAction: 'Click',
        Label: '(834) QS-13-CurrentUTCGameID',
        value: '',
      },
      '11': {
        catId: 'AM',
        eventId: 835,
        category: '(AM) QuickStart',
        eventAction: 'Click',
        Label: '(835) QS-14-TableLimits',
        value: '',
      },
      '12': {
        catId: 'AM',
        eventId: 836,
        category: '(AM) QuickStart',
        eventAction: 'Click',
        Label: '(836) QS-15-BetBar',
        value: '',
      },
      '13': {
        catId: 'AM',
        eventId: 837,
        category: '(AM) QuickStart',
        eventAction: 'Click',
        Label: '(837) QS-16-PlaceYourBets',
        value: '',
      },
      '14': {
        catId: 'AM',
        eventId: 838,
        category: '(AM) QuickStart',
        eventAction: 'Click',
        Label: '(838) QS-17-HowtoPlay',
        value: '',
      },
    };
  }

  public static get QUICKSTARTEVENTSPOPUPLIST(): any {
    return {
      '0': {
        catId: 'AM',
        eventId: 839,
        category: '(AM) QuickStart',
        eventAction: 'Click',
        Label: '(839) LiveHelpingHandForFirstTimeEvents',
        value: '',
      },
      'Tutorials-popup': {
        catId: 'AM',
        eventId: 840,
        category: '(AM) QuickStart',
        eventAction: 'Click',
        Label: '(840) TurnsOnTutorials',
        value: '',
      },
      'VideoTutorials-popup': {
        catId: 'AM',
        eventId: 841,
        category: '(AM) QuickStart',
        eventAction: 'Click',
        Label: '(841) VideoTutorials',
        value: '',
      },
      ExperiencedPlayer: {
        catId: 'AM',
        eventId: 842,
        category: '(AM) QuickStart',
        eventAction: 'Click',
        Label: '(842) ExperiencedPlayer',
        value: '',
      },
      '1': {
        catId: 'AM',
        eventId: 843,
        category: '(AM) QuickStart',
        eventAction: 'Click',
        Label: '(843) HelpingHand1-On1stGameEntry',
        value: '',
      },
      '2': {
        catId: 'AM',
        eventId: 844,
        category: '(AM) QuickStart',
        eventAction: 'Click',
        Label: '(844) HelpingHand2-Before1stBet-UpDownAction',
        value: '',
      },
      '3': {
        catId: 'AM',
        eventId: 845,
        category: '(AM) QuickStart',
        eventAction: 'Click',
        Label: '(845) HelpingHand3-Before1stDeal-Win2Ways',
        value: '',
      },
      '4': {
        catId: 'AM',
        eventId: 846,
        category: '(AM) QuickStart',
        eventAction: 'Click',
        Label: '(846) HelpingHand4-Before1stDeal-GameRules',
        value: '',
      },
      '5': {
        catId: 'AM',
        eventId: 847,
        category: '(AM) QuickStart',
        eventAction: 'Click',
        Label: '(847) HelpingHand5-Before1stDeal-StartaGame',
        value: '',
      },
      /* '-1' : 'Finished-popup',
       '0' : 'LiveHelpingHandForFirstTimeEvents',
       '1' : 'HelpingHand1-On1stGameEntry',
       '2' : 'HelpingHand2-Before1stBet-UpDownAction',
       '3' : 'HelpingHand3-Before1stDeal-Win2Ways',
       '4' : 'HelpingHand4-Before1stDeal-GameRules',
       '5' : 'HelpingHand5-Before1stDeal-StartaGame'*/
    };
  }
  public static get Tutorials_FCB() {
    return {
      '0': {
        catId: 'AN',
        eventId: 848,
        category: '(AN) Tutorials_FCB',
        eventAction: 'Click',
        Label: '(848) Index',
        value: '',
      },
      '1': {
        catId: 'AN',
        eventId: 848,
        category: '(AN) Tutorials_FCB',
        eventAction: 'Click',
        Label: '(848) FullColorCards',
        value: '',
      },
      '2': {
        catId: 'AN',
        eventId: 849,
        category: '(AN) Tutorials_FCB',
        eventAction: 'Click',
        Label: '(849) PlusMinusScores',
        value: '',
      },
      '3': {
        catId: 'AN',
        eventId: 850,
        category: '(AN) Tutorials_FCB',
        eventAction: 'Click',
        Label: '(850) TwoWaysToWin',
        value: '',
      },
      '4': {
        catId: 'AN',
        eventId: 851,
        category: '(AN) Tutorials_FCB',
        eventAction: 'Click',
        Label: '(851) GameRules',
        value: '',
      },
      '5': {
        catId: 'AN',
        eventId: 852,
        category: '(AN) Tutorials_FCB',
        eventAction: 'Click',
        Label: '(852) HandScoring',
        value: '',
      },
      '6': {
        catId: 'AN',
        eventId: 853,
        category: '(AN) Tutorials_FCB',
        eventAction: 'Click',
        Label: '(853) DealScoring',
        value: '',
      },
      '7': {
        catId: 'AN',
        eventId: 854,
        category: '(AN) Tutorials_FCB',
        eventAction: 'Click',
        Label: '(854) DrawScoring',
        value: '',
      },
      '8': {
        catId: 'AN',
        eventId: 855,
        category: '(AN) Tutorials_FCB',
        eventAction: 'Click',
        Label: '(855) SpreadRulePlayer',
        value: '',
      },
      '9': {
        catId: 'AN',
        eventId: 856,
        category: '(AN) Tutorials_FCB',
        eventAction: 'Click',
        Label: '(856) SpreadRuleBanker',
        value: '',
      },
      '10': {
        catId: 'AN',
        eventId: 857,
        category: '(AN) Tutorials_FCB',
        eventAction: 'Click',
        Label: '(857) SpreadRuleDual',
        value: '',
      },
      '11': {
        catId: 'AN',
        eventId: 858,
        category: '(AN) Tutorials_FCB',
        eventAction: 'Click',
        Label: '(858) SpreadRuleGreaterEleven',
        value: '',
      },
      '12': {
        catId: 'AN',
        eventId: 859,
        category: '(AN) Tutorials_FCB',
        eventAction: 'Click',
        Label: '(859) TieGameRules',
        value: '',
      },
      '13': {
        catId: 'AN',
        eventId: 860,
        category: '(AN) Tutorials_FCB',
        eventAction: 'Click',
        Label: '(860) CommissionRules',
        value: '',
      },
      '14': {
        catId: 'AN',
        eventId: 861,
        category: '(AN) Tutorials_FCB',
        eventAction: 'Click',
        Label: '(861) SideBets',
        value: '',
      },
      '15': {
        catId: 'AN',
        eventId: 862,
        category: '(AN) Tutorials_FCB',
        eventAction: 'Click',
        Label: '(862) SessionBets',
        value: '',
      },
      '16': {
        catId: 'AN',
        eventId: 863,
        category: '(AN) Tutorials_FCB',
        eventAction: 'Click',
        Label: '(863) LiveSideBets',
        value: '',
      },
      '17': {
        catId: 'AN',
        eventId: 864,
        category: '(AN) Tutorials_FCB',
        eventAction: 'Click',
        Label: '(864) HandRankings',
        value: '',
      },
      '18': {
        catId: 'AN',
        eventId: 865,
        category: '(AN) Tutorials_FCB',
        eventAction: 'Click',
        Label: '(865) RoadMaps',
        value: '',
      },
      '19': {
        catId: 'AN',
        eventId: 866,
        category: '(AN) Tutorials_FCB',
        eventAction: 'Click',
        Label: '(866) QuickKeys',
        value: '',
      },
      '20': {
        catId: 'AN',
        eventId: 867,
        category: '(AN) Tutorials_FCB',
        eventAction: 'Click',
        Label: '(867) GameSummary',
        value: '',
      },
    };
  }
  /*--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
}

/*export class NameFormatConstant {
  /!*public static get NameFormat(): any {
    return {
      home: "Home", /!*MENU - 1*!/
      languages: "Languages", /!*MENU - 2*!/
      settings: "Settings", /!*MENU - 3*!/
      tutorials: "Tutorials", /!*MENU - 4*!/
      quickkeys: "Quickkeys", /!*MENU - 5*!/
      videotutorials: "Video Tutorials", /!*MENU - 6*!/
      premiumpay: "Premium Pays", /!*MENU - 7*!/
      history: "History", /!*MENU - 8*!/
      communityforums: "Community Forums", /!*MENU - 9*!/
      fixourtranslations: "Fix Our Translations", /!*MENU - 10*!/
      helpdesk: "Help Desk", /!*MENU - 11*!/
      aboutus: "About Us", /!*MENU - 12*!/
      logout: "Logout", /!*MENU - 13*!/
      gamedetails: "GameDetails",
      selecttable: "SelectTable",
      handranks: "HandRanks",
      changechips: "ChangeChips",
      quickstart: "Quickstart",
      quicktips: "Quicktips",
      helpinghand: "HelpingHand",
      fcbtutorials: "FcbTutorials",
    };
  }*!/
  /!*public static get QUICKSTARTPOPUPLIST(): any {
    return {
      '0' : 'QS-01-Welcome',
      '1' : 'QS-02-MenuBar',
      'MenuFlyout' : 'QS-03-MenuFlyout',
      'MenuFlyout-PreviousNext' : 'QS-04-MenuFlyout-PreviousNext',
      'SlidingToolBar' : 'QS-05-SlidingToolBar',
      'SlidingToolBar-Arrows' : 'QS-06-SlidingToolBar-Arrows',
      '4' : 'QS-07-FeaturesFunctions',
      '5' : 'QS-08-ChangeChips',
      '6' : 'QS-09-Tutorials',
      '7' : 'QS-10-HelpingHand',
      '8' : 'QS-11-QuickTips',
      '9' : 'QS-12-QuickKeys',
      '10' : 'QS-13-CurrentUTCGameID',
      '11' : 'QS-14-TableLimits',
      '12' : 'QS-15-BetBar',
      '13' : 'QS-16-PlaceYourBets',
      '14' : 'QS-17-HowtoPlay',
    };
  }*!/
  /!*public static get QUICKSTARTEVENTSPOPUPLIST(): any {
    return {
      '-1' : 'Finished-popup',
      '0' : 'LiveHelpingHandForFirstTimeEvents',
      '1' : 'HelpingHand1-On1stGameEntry',
      '2' : 'HelpingHand2-Before1stBet-UpDownAction',
      '3' : 'HelpingHand3-Before1stDeal-Win2Ways',
      '4' : 'HelpingHand4-Before1stDeal-GameRules',
      '5' : 'HelpingHand5-Before1stDeal-StartaGame'

    };
  }*!/
  /!*public static get QuickTipsButtonPopupList(): any {
      return {
               '1' : 'QTB-01-PlaceYourBets',
               '2' : 'QTB-02-ChangeChips',
               '3' : 'QTB-03-Pick5',
               '4' : 'QTB-04-Pick6',
               '5' : 'QTB-05-Clear',
               '6' : 'QTB-06-Confirm',
               '7' : 'QTB-07-Stand',
               '8' : 'QTB-08-Hit',
               '9' : 'QTB-09-DoubleDown',
               '10' : 'QTB-10-NewBet',
               '11' : 'QTB-11-Rebet',
               '12' : 'QTB-12-Rebet2x',
               '13' : 'QTB-13-Yes-Insurance',
               '14' : 'QTB-14-YesToAll',
               '15' : 'QTB-15-No-Insurance',
               '16' : 'QTB-16-NoToYes',
               '17' : 'QTB-17-RussianRoulette™',
               '18' : 'QTB-18-Yes',
               '19' : 'QTB-19-No',
               '20' : 'QTB-20-SplitYourHand',
               '21' : 'QTB-21-WaitingForOtherPlayers',
               '22' : 'QTB-22-GameOver',
               '22a' : 'QTB-23-ObservationMode',
  };
    }*!/
  public static get QuickSTipsDetailsPopupList(): any {
    return {
      '23' : 'QTD-01-CurrentUTC',
      '24' : 'QTD-02-GameID',
      '25' : 'QTD-03-MinimumBet',
      '26' : 'QTD-04-MaximumBet',
      '27' : 'QTD-05-TotalBet',
      '28' : 'QTD-06-ReturntoPlayer',
      '29' : 'QTD-07-BankBalance',
      '30' : 'QTD-08-SlidingToolBar',
      '31' : 'QTD-09-ChangeChips',
      '32' : 'QTD-10-Tutorials',
      '33' : 'QTD-11-HelpingHand',
      '34' : 'QTD-12-QuickTips',
      '35' : 'QTD-13-QuickKeys',
      '36' : 'QTD-14-Chip1',
      '37' : 'QTD-15-Chip2',
      '38' : 'QTD-16-Chip3',
      '39' : 'QTD-17-Chip4',
      '40' : 'QTD-18-Chip5',
      '41' : 'QTD-19-Chip6',
      '42' : 'QTD-20-BetSpot',
      '43' : 'QTD-21-PlaceYourBets-Tutorial_06_StartAGame',
      '44' : 'QTD-22-Shoe-Tutorial_01_Introduction',
      '45' : 'QTD-23-PlaceYourBets-Tutorial_02_Scores',
      '46' : 'QTD-24-FC21Logo-Tutorial_03_GameAction',
      '47' : 'QTD-25-TopRuleBar-Tutorial_04_GameRules',
      '48' : 'QTD-26-TopRuleBar-Tutorial_05_Soft17',
      '49' : 'QTD-27-DealerChasesNZ-Tutorial_06_StartAGame',
      '50' : 'QTD-28-BottomRuleBar-Tutorial_07_NaturalHands',
      '51' : 'QTD-29-BottomRuleBar-Tutorial_08_SNWins',
      '52' : 'QTD-30-BottomRuleBar-Tutorial_09_N21Wins',
      '53' : 'QTD-31-BottomRuleBar-Tutorial_10_DNWins',
      '54' : 'QTD-32-BottomRuleBar-Tutorial_11_NZWins',
      '55' : 'QTD-33-TopRuleBar-Tutorial_12_BustOver22',
      '56' : 'QTD-34-BottomRuleBar-Tutorial_13_Splits',
      '57' : 'QTD-35-BottomRuleBar-Tutorial_14_ImpossibleSplits',
      '58' : 'QTD-36-BottomRuleBar-Tutorial_15_DoubleDown',
      '59' : 'QTD-37-BottomRuleBar-Tutorial_16_ColorInsurance',
      '60' : 'QTD-38-BottomRuleBar-Tutorial_17_WhiteInsurance',
      '61' : 'QTD-39-PeekerRed',
      '62' : 'QTD-40-PeekerGreen',
      '63' : 'QTD-41-ColorCardInsuranceAlertBoxes',
      '64' : 'QTD-42-WhiteCardInsuranceAlertBoxes',
      '65' : 'QTD-43-RussianRouletteAlertBoxes',


    };
  }

  public static get QuickTipsEventsPopupList(): any {
    return {
      '71' : 'QTE-08-HelpingHand-OnOff',
      '72' : 'QTE-09-GameStatus',/!*72a,b,c*!/
      '73' : 'QTE-10-After1stHandScore-showhandrankingchart',
      '74' : 'QTE-11-After1stDrawZero™-PlayerorDealer',
      '75' : 'QTE-12-ExpandthePlayersCurrentCards',
      '76' : 'QTE-13-ExpandtheDealersCurrentCards',
      '77' : 'QTE-14-On1stSoft17byDealer',
      '78' : 'QTE-15-OnDealers1stNaturalZero',
      '79' : 'QTE-16-On1stPlayerNaturalZeroDealer-Chase',
      '80' : 'QTE-17-On1stPlayersSuperNatural',
      '81' : 'QTE-18-On1stPlayersNatural21',
      '82' : 'QTE-19-On1stPlayersDoubleNatural™',
      '83' : 'QTE-20-On1stPlayersNaturalZero-NoChase',
      '84' : 'QTE-21-On1stBust',
      '85' : 'QTE-22-On1stDisplayof1stEligibleSplits',
      '86' : 'QTE-23-After1stEligibleSplitOccurs',
      '87' : 'QTE-24-On1stIneligibleSplits',
      '88' : 'QTE-25-On1stImpossibleSplitNZ',
      '89' : 'QTE-26-On1stImpossibleSplitDN',
      '90' : 'QTE-27-On1stImpossibleSplitSN',
      '91' : 'QTE-28-On1stDisplayofDoubleDownButton',
      '92' : 'QTE-29-After1stDoubleDownOccursonaWin',
      '93' : 'QTE-30-On1stColorCardInsurance-BetBarAlerts',
      '94' : 'QTE-31-On1stColorCardInsurance-GradientBar-Lose',
      '95' : 'QTE-32-After1stColorInsuranceWin',
      '96' : 'QTE-33-On1stWhiteCardInsurance-BetBarAlerts',
      '97' : 'QTE-34-On1stWhiteCardInsurance-GradientBar-Lose',
      '98' : 'QTE-35-After1stWhiteInsuranceWin',
      '99' : 'QTE-36-On1stRussianRoulette17-BetBarAlertBoxes',
      '100' : 'QTE-37-On1stRussianRoulette17-Gradient',
      '101' : 'QTE-38-After1stRussianRoulette17Win',
      '102' : 'QTE-39-On1stRussianRoulette18-BetBarAlertBoxes',
      '103' : 'QTE-40-On1stRussianRoulette18-Gradient',
      '104' : 'QTE-41-After1stRussianRoulette18Win',
      '105' : 'QTE-42-On1stRussianRoulette19BetBarAlertBoxes',
      '106' : 'QTE-43-On1stRussianRoulette19Gradient',
      '107' : 'QTE-44-After1stRussianRoulette19Win',
      '108' : 'QTE-45-On1stRussianRoulette20-BetBarAlertBoxes',
      '109' : 'QTE-46-On1stRussianRoulette20-Gradient',
      '110' : 'QTE-47-After1stRussianRoulette20Win',
      '111' : 'QTE-48-After1stHand≥6Cards-ExpandPlayerHand',
      '112' : 'QTE-49-After1stHand≥6-ExpandDealerHands',
      '113' : 'QTE-50-After1stDrawZero-WhatisaNothing',
      '114' : 'QTE-51-After1stDealerScore-HandRanks',
      '115' : 'QTE-52-After1stPlayersNZ-DealersDrawZero',
      '116' : 'QTE-53-After1stPlayersNZ-DealersD21',
      '117' : 'QTE-54-After1stAnyD21AnyD21',
      '118' : 'QTE-55-After1stAnyNZ',
      '119' : 'QTE-56-AfterDealers1stSN',
      '120' : 'QTE-57-AfterDealers1stN21',
      '121' : 'QTE-58-AfterDealers1stDN'


    };
  }


  public static get FC21orNothing_Game(): any {
    return {
      'rebet2x': 'Rebet2X',
      'newbet': 'NewBet',
      'confirmbet': 'ConfirmBet',
      'hit': 'Hit',
      'rouletteno': 'RussianRouletteIgnored',
      'rouletteyes': 'RussianRouletteTaken',
      'russianroulette': 'RussianRouletteOffered',
      'doubledown': 'DoubleDownOffered',
      'doubleno': 'DoubleDownIgnored',
      'doubleyes': 'DoubleDownTaken',
      'splityourhand': 'SplitYourHandOffered',
      'splityes': 'SplitYourHandTaken',
      'splitno': 'SplitYourHandIgnored',
      'colorinsuranceallyes': 'ColorCardInsuranceTakenAll',
      'colorinsurancetoallno': 'ColorCardInsuranceIgnoredAll',
      'colorinsuranceyes': 'ColorCardInsuranceTaken',
      'colorinsuranceno': 'ColorCardInsuranceIgnored',
      'whiteinsuranceallyes': 'WhiteCardInsuranceTakenAll',
      'whiteinsurancetoallno': 'WhiteCardInsuranceIgnoredAll',
      'whiteinsuranceyes': 'WhiteCardInsuranceTaken',
      'whiteinsuranceno': 'WhiteCardInsuranceIgnored',
      'colorinsurance': 'ColorCardInsuranceOffered',
      'whiteinsurance': 'WhiteCardInsuranceOffered',
      'changechips': 'ChangeChips',
      'helpinghands': 'HelpingHandsToggle',
      'quickkeys': 'QuickKeysToggle',
      'quicktips': 'QuickTipsToggle',
      'rebet': 'Rebet',
      'settings': 'Settings',
      'tutorials': 'Tutorials',
      'fullscreen': 'FullScreen',
      'menu': 'Menu',
      'selectedchip':'SelectedChip',
      'stand': 'Stand',
      'allbetscleared': 'ClearBet',
    };
  }

  public static get FCBaccarat_Game(): any {
    return {
      'rebet2x': 'Rebet2X',
      'newbet': 'NewBet',
      'confirmbet': 'ConfirmBet',
      'changechips': 'ChangeChips',
      'changechips_selectedchip' : 'ChangeChips - SelectedChip',
      'helpinghands': 'HelpingHands',
      'quickkeys': 'QuickKeys',
      'quicktips': 'QuickTips',
      'rebet': 'Rebet',
      'info': 'Tutorials',
      'menu': 'Menu',
      'selectedchip':'SelectedChip',
      'clearbet': 'ClearBet',
      'next' : 'Next',
      'draw': 'Draw',
      'hints':'Hints',
      'mainmap' : 'MainBetsToggle',
      'mainmapplaybtn' : 'MainBetsToggle',
      'sidemap' : 'SideBetsToggle',
      'sidemapplaybtn' : 'SideBetsToggle',
      'mainmaplinkbtn' : 'MainBets - Link',
      'colorpalette' : 'ColorPaletteToggle',
      'sidemapzoombtn' : 'ZoomIn / ZoomOut',
      'mainmapzoombtn' : 'ZoomIn / ZoomOut',
      'Main' : 'Link - Main',
      'Slide' : 'Link - Side',
      '+/-' : 'Link - PlusMinus',
      '2/3' : 'Link - TwoByThree',
      'Shuffles' : 'Link - Shuffles',
      'Total' : 'Link - Total',
      'maximumbet' : 'MaximumBet',
      'minimumbet' : 'MinimumBet',
      'betsuccess' : 'Success',
      'betfailed' : 'Bet Failed',
      'playerbetspot' : 'PlayerBetSpot',
      'bankerbetspot' : 'BankerBetSpot',
      'tiebetspot' : 'TieBetSpot',
      'minustwobetspot' : '2MinusBetSpot',
      'plustwobetspot' : '2PlusBetSpot',
      'minusthreebetspot' : '3MinusBetSpot',
      'plusthreebetspot' : '3PlusBetSpot',
    };
  }
}*/
